(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ui"] = factory();
	else
		root["ui"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(43);
	
	var Top = __webpack_require__(16);
	var Navigation = __webpack_require__(26);
	
	module.exports = { Top: Top, Navigation: Navigation };

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/*
	DomQuery Module
	List of functions to read browser and dom element properties cross browser consistently
	*/
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    'use strict';
	
	    var domQ;
	
	    (function () {
	        domQ = function domQ(el) {
	
	            if (typeof el === 'string') {
	                return new DomQuery(document.createElement(el));
	            }
	
	            return new DomQuery(el);
	        };
	
	        var DomQuery = function DomQuery(el) {
	            this.el = el;
	            return this;
	        };
	
	        DomQuery.prototype = {
	
	            /**
	             * Returns offset of domQ element 
	             * @returns {Object} offset object
	             */
	            offset: function offset() {
	                var curleft = 0,
	                    curtop = 0;
	
	                if (this.el.offsetParent) {
	                    do {
	                        curleft += this.el.offsetLeft;
	                        curtop += this.el.offsetTop;
	
	                        this.el = this.el.offsetParent;
	                    } while (this.el);
	                }
	
	                return { left: curleft, top: curtop };
	            },
	
	            /**
	             * Returns width of domQ element 
	             * @returns {Number} element width
	             */
	            width: function width() {
	
	                if (!window.addEventListener) {
	                    return 0;
	                }
	
	                var elStyle = window.getComputedStyle(this.el),
	                    width = elStyle.width === 'auto' ? this.el.offsetWidth : parseFloat(elStyle.width);
	
	                if (this.browser.ie) {
	                    width += parseFloat(elStyle.paddingRight) + parseFloat(elStyle.paddingRight);
	                }
	
	                return width;
	            },
	
	            /**
	             * Returns height of domQ element 
	             * @returns {Number} element height
	             */
	            height: function height() {
	
	                if (!window.addEventListener) {
	                    return 0;
	                }
	
	                var elStyle = window.getComputedStyle(this.el),
	                    height = elStyle.height === 'auto' ? this.el.offsetHeight : parseFloat(elStyle.height, 10);
	
	                if (this.browser.ie) {
	                    height += parseFloat(elStyle.paddingTop) + parseFloat(elStyle.paddingBottom);
	                }
	
	                return height;
	            },
	
	            /**
	             * Add css class to domQ element
	             * @param {string} css class name 
	             * @returns {Object} DomQuery instance
	             */
	            addClass: function addClass(cssClass) {
	                var list = this.el.className.split(/\s+/);
	
	                if (list.indexOf(cssClass) > -1) {
	                    return;
	                }
	
	                list.push(cssClass);
	                this.el.className = list.join(' ');
	
	                return this;
	            },
	
	            /**
	             * Remove css class from domQ element
	             * @param {string} css class name 
	             * @returns {Object} DomQuery instance
	             */
	            removeClass: function removeClass(cssClass) {
	                var list = this.el.className.split(/\s+/);
	
	                if (list.indexOf(cssClass) === -1) {
	                    return;
	                }
	
	                list = list.filter(function (item) {
	                    return item !== cssClass;
	                });
	
	                this.el.className = list.join(' ');
	
	                return this;
	            },
	
	            /**
	             * Check if domQ element has a css class
	             * @param {string} css class name 
	             * @returns {Boolean} true if element has specified css class
	             */
	            hasClass: function hasClass(cssClass) {
	                return this.el.className.split(/\s+/).indexOf(cssClass) !== -1;
	            },
	
	            /**
	             * Set attribute to element
	             * @param {string} attribute name
	             * @param {string} attribute value 
	             * @returns {Object} DomQuery instance
	             */
	            attr: function attr(name, value) {
	                if (value) {
	                    this.el.setAttribute(name, value);
	                    return this;
	                }
	
	                return this.el.getAttribute(name);
	            },
	
	            /**
	             * Set text to element
	             * @param {string} text content
	             * @returns {Object} DomQuery instance
	             */
	            text: function text(_text) {
	                if (_text) {
	                    this.el.textContent = _text;
	                    return this;
	                }
	
	                return this.el.textContent;
	            },
	
	            /**
	             * Set html content to element
	             * @param {string} html content
	             * @returns {Object} DomQuery instance
	             */
	            html: function html(_html) {
	                if (_html) {
	                    this.el.innerHTML = _html;
	                    return this;
	                }
	
	                return this.el.innerHTML;
	            },
	
	            /**
	             * Appends current element into provided element
	             * @param {Object} DOM element
	             * @returns {Object} DomQuery instance
	             */
	            appendTo: function appendTo(el) {
	                el.appendChild(this.el);
	                return this;
	            },
	
	            /**
	             * Appends provided element into current element
	             * @param {Object} DOM element
	             * @returns {Object} DomQuery instance
	             */
	            append: function append(el) {
	                if (el instanceof Element) {
	                    this.el.appendChild(el);
	                }
	
	                return this;
	            }
	        };
	
	        // set browser configurations
	        (function () {
	            var isIE = function isIE() {
	                return navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape' && new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) != null;
	            };
	            DomQuery.prototype.browser = {
	                ie: isIE()
	            };
	        })();
	    })();
	
	    return domQ;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof window !== 'undefined' && typeof window.mnsHeaderConfig !== 'undefined') {
	    module.exports = window.mnsHeaderConfig;
	} else {
	    module.exports = {
	        "wcsBaseUrl": "/webapp/wcs/stores/servlet/",
	        "CMD": {
	            "authToken": "MSAuthToken",
	            "miniBasket": "MSResMiniBasket",
	            "savedBasketDisplay": "MSSavedBasketDisplayCmd",
	            "navigation23": "MSTopNavTier3Cmd",
	            "countryLinks": "MSResCountryLinks",
	            "removeItemMiniBag": "MSOrderItemUpdateCmd"
	        },
	        "storeId": "10151",
	        "langId": "-24",
	        "catalogId": "10051"
	    };
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var utils = {
	        hasTouchCapability: function hasTouchCapability() {
	            return document.querySelector('html.touch') !== null;
	        },
	
	        preventClick: function preventClick(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            return false;
	        },
	
	        hasClass: function hasClass(element, className) {
	            if (element) {
	                return new RegExp(' ' + className + ' ').test(' ' + element.className + ' ');
	            }
	            return false;
	        },
	
	        addClass: function addClass(element, className) {
	            var hasClass = utils.hasClass(element, className);
	            if (!hasClass) {
	                element.className += ' ' + className;
	            }
	        },
	
	        removeClass: function removeClass(element, className) {
	            var hasClass = utils.hasClass(element, className);
	            if (hasClass) {
	                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
	                element.className = element.className.replace(reg, ' ');
	            }
	        },
	
	        /**
	         * @param {Object} obj key values to construct string
	         * @returns {string/Boolean}
	         */
	        serialize: function serialize(obj) {
	            var str = [];
	
	            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || Array.isArray(obj)) {
	                return false;
	            }
	
	            for (var p in obj) {
	                if (obj.hasOwnProperty(p)) {
	                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	                }
	            }
	
	            return str.join('&');
	        },
	
	        /**
	         * @param host {string}
	         * @param params {object}
	         * @returns {string}
	         */
	        constructUrl: function constructUrl(host, params) {
	            var parts = [];
	
	            if (typeof host !== 'string') {
	                return '';
	            }
	
	            parts.push(host);
	
	            if (utils.serialize(params)) {
	                parts.push(utils.serialize(params));
	            }
	
	            return parts.join('?');
	        },
	
	        /**
	         * Append the current url to the target url
	         * @param {String} targetUrl
	         * @param {String} sourceUrl
	         * @returns {String}
	         */
	        appendSourceUrl: function appendSourceUrl(targetUrl, sourceUrl) {
	            if (typeof targetUrl !== 'string' || typeof sourceUrl !== 'string') {
	                return '/';
	            }
	            if (targetUrl.indexOf('sourceurl') === -1) {
	                sourceUrl = decodeURIComponent(sourceUrl);
	                if (targetUrl.indexOf('?') === -1) {
	                    targetUrl += '?';
	                } else {
	                    if (targetUrl.indexOf('?') !== targetUrl.length - 1) {
	                        targetUrl += '&';
	                    }
	                }
	                return targetUrl + 'sourceurl=' + encodeURIComponent(sourceUrl);
	            } else {
	                return targetUrl;
	            }
	        },
	
	        /**
	         * Set a group of DOM elements' tabindex
	         * @param {DOM object} els
	         * @param {Integer} tabindex
	         */
	        setTabIndex: function setTabIndex(els, tabindex) {
	            for (var i = 0; i < els.length; i++) {
	                els[i].setAttribute('tabindex', tabindex);
	            }
	        },
	
	        checkIeVersion: function checkIeVersion() {
	            var ua = window.navigator.userAgent;
	            var msie = ua.indexOf('MSIE ');
	            if (msie > 0) {
	                // IE 10 or older => return version number
	                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	            }
	
	            var trident = ua.indexOf('Trident/');
	            if (trident > 0) {
	                // IE 11 => return version number
	                var rv = ua.indexOf('rv:');
	                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	            }
	
	            var edge = ua.indexOf('Edge/');
	            if (edge > 0) {
	                // Edge (IE 12+) => return version number
	                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	            }
	
	            // other browser
	            return false;
	        }
	    };
	
	    return utils;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var MS_USER_COOKIE = 'MS_USER_COOKIE',
	        MS_SPARKS_PAY = /MS_SP_C=([^;]+)/,
	        MS_PREFERRED_COUNTRY = 'MS_PREFERRED_COUNTRY',
	        MS_USER_SEGMENT_COOKIE = /MS_USER_SEGMENT_COOKIE=([^;]+)/,
	        BASKET_COOKIE = 'basketSize_[0-9]+',
	        SAVED_ITEM_COOKIE = 'savedItemSize_[0-9]+',
	        MS_AUTH_TOKEN = /MS_AUTH_TOKEN_\d+=([^;]+)/,
	        IS_LOYALTY_USER_COOKIE = /IS_LOYALTY_USER_COOKIE=([^;]+)/,
	        config = window.mnsHeaderConfig ? window.mnsHeaderConfig : {};
	
	    /**
	     * Returns userSegment_XXXX cookie value
	     * @returns {Number | null} userSegment_XXXX value
	     */
	    function getUserSegmentCookieValue() {
	        var matches = document.cookie.match(MS_USER_SEGMENT_COOKIE);
	
	        return matches !== null ? matches[1] : null;
	    }
	
	    /**
	     * Returns MS_AUTH_TOKEN_[0-9]+ cookie value
	     * @returns {string | null} MS_AUTH_TOKEN_ value
	     */
	    function getAuthTokenCookieValue() {
	        var matches = document.cookie.match(MS_AUTH_TOKEN);
	
	        return matches !== null ? matches[1] : null;
	    }
	
	    /**
	     * Returns logged in user status from MS_USER_COOKIE
	     * @returns {boolean} TRUE if user is logged in
	     */
	    function isUserLoggedIn() {
	        return getUserCookieValue() !== null;
	    }
	
	    /**
	     * Returns username from MS_USER_COOKIE
	     * @returns {string | null} username
	     */
	    function getUsername() {
	        var value = getUserCookieValue();
	
	        return value !== null ? value.split('_')[0] : null;
	    }
	
	    /**
	     * Returns loyalty username from IS_LOYALTY_USER_COOKIE
	     * @returns {string | null} username
	     */
	    function isUserSparksMember() {
	        var matches = document.cookie.match(IS_LOYALTY_USER_COOKIE);
	        return matches !== null ? matches[1] === 'true' : false;
	    }
	
	    /**
	     * Returns loyalty username from IS_LOYALTY_USER_COOKIE
	     * @returns {string | null} username
	     */
	    function getStoreIdSuffixCookieValue(patternStr) {
	        var cookieKey,
	            cookieVal,
	            cookiePattern = patternStr + '=',
	            storeAwareCookiePattern;
	
	        if (config.MS_MAKE_STORE_AWARE_COOKIE) {
	            // read store aware cookie
	            storeAwareCookiePattern = patternStr + '_' + config.storeId + '=';
	            cookieVal = getCookieValue(storeAwareCookiePattern);
	
	            if (cookieVal) {
	                return cookieVal;
	            }
	
	            // read existing cookie
	            cookieVal = getCookieValue(cookiePattern);
	
	            if (cookieVal) {
	                cookieKey = getCookieKey(cookiePattern);
	                setCookieWithOptions(cookieKey + '_' + config.storeId, cookieVal);
	            }
	
	            return cookieVal;
	        }
	
	        return getCookieValue(cookiePattern);
	    }
	
	    function setCookieWithOptions(key, value, options, raw, json) {
	        options = options ? options : {};
	        raw = raw ? raw : false;
	        json = json ? json : false;
	
	        if (typeof options.expires === 'number') {
	            var days = options.expires;
	            var date = new Date();
	            date.setDate(date.getDate() + days);
	            options.expires = date.toUTCString();
	        }
	
	        value = json ? JSON.stringify(value) : String(value);
	        value = raw ? value : encodeURIComponent(value);
	        var keyValue = encodeURIComponent(key) + '=' + value + ';';
	
	        var optionsString = Object.keys(options).map(function (option) {
	            if (option === 'Secure') {
	                return option;
	            }
	            return option + '=' + options[option];
	        }).join(';');
	
	        return document.cookie = keyValue + ' ' + optionsString;
	    }
	
	    function getCookieKey(patternStr) {
	        var pattern = new RegExp(patternStr + '[^;]+'),
	            matches = document.cookie.match(pattern);
	        return matches && matches[0] ? matches[0].split('=')[0] : null;
	    }
	
	    function getCookieValue(patternStr) {
	        var pattern = new RegExp(patternStr + '[^;]+'),
	            matches = document.cookie.match(pattern);
	
	        return matches && matches[0] ? matches[0].split('=')[1] : null;
	    }
	
	    function getUserCookieValue() {
	        return getStoreIdSuffixCookieValue(MS_USER_COOKIE);
	    }
	
	    function getBasketCookieValue() {
	        return getStoreIdSuffixCookieValue(BASKET_COOKIE) || 0;
	    }
	
	    function getSavedItemsCookieValue() {
	        return getStoreIdSuffixCookieValue(SAVED_ITEM_COOKIE) || 0;
	    }
	
	    function updatePreferredCountryCookie(evt) {
	        if (evt && evt.target && evt.target.dataset && evt.target.dataset.lang && evt.target.dataset.countryname) {
	            var value = evt.target.dataset.lang.toLowerCase() + '_' + evt.target.dataset.countryname;
	            setCookieWithOptions(MS_PREFERRED_COUNTRY, value, { path: '/' });
	        }
	    }
	
	    function getUserSparkspayStatus() {
	        var sparkspaymatches = document.cookie.match(MS_SPARKS_PAY);
	        return sparkspaymatches && sparkspaymatches[0] ? sparkspaymatches[0].split(',')[1] : null;
	    }
	
	    // service API
	    return {
	        isUserLoggedIn: isUserLoggedIn,
	        getUsername: getUsername,
	        getCookieValue: getCookieValue,
	        getUserLoginCookieValue: getUserCookieValue,
	        getUserSegmentCookieValue: getUserSegmentCookieValue,
	        getBasketSizeCookieValue: getBasketCookieValue,
	        getSavedItemCountCookieValue: getSavedItemsCookieValue,
	        getAuthTokenCookieValue: getAuthTokenCookieValue,
	        isUserSparksMember: isUserSparksMember,
	        updatePreferredCountryCookie: updatePreferredCountryCookie,
	        getUserSparkspayStatus: getUserSparkspayStatus
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    function Breakpoint() {}
	
	    Breakpoint.size = function () {
	        var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	        if (window.getComputedStyle(document.getElementById('breakpoint'), '::before').content === '') {
	            if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
	                return 'xsmall';
	            }
	        }
	        return window.getComputedStyle(document.getElementById('breakpoint'), '::before').content.replace(/\'|\"/g, '');
	    };
	
	    return Breakpoint;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var constant = {
	        ukId: '10151',
	        ieId: '10451',
	        ukSearch: '/search',
	        ieSearch: '/ie/MSFindItemsByKeyword',
	        ukFlagID: 'GB',
	        ieFlagID: 'IE',
	        ukCountryName: 'United Kingdom (£)',
	        ieCountryName: 'Ireland (€)',
	        ukCountryNameI: 'United Kingdom',
	        ieCountryNameI: 'Ireland'
	    };
	    return constant;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(40);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    /**
	     * Attach analytics events
	     */
	    var analytics = {
	
	        /**
	         * @description ensure that element(s) passed are in array format for iteration in bind method
	         * @param el
	         * @returns {Array}
	         */
	        normaliseElements: function normaliseElements(el) {
	            if (!el) {
	                return [];
	            }
	            if (Array.isArray(el)) {
	                return el;
	            }
	            if (!el.length && !Array.isArray(el)) {
	                el = [el];
	            }
	            return el;
	        },
	        /**
	         * @description add event listeners and associated data for event
	         * @param el {Object}
	         * @param actions {Object}
	         */
	        bind: function bind(el, actions) {
	            var elements = analytics.normaliseElements(el);
	
	            for (var iItem = 0; iItem < elements.length; iItem++) {
	                var elItem = elements[iItem];
	                if (!elItem.nodeName) {
	                    throw new Error('element is not a DOM object');
	                }
	                for (var iAction = 0; iAction < actions.length; iAction++) {
	                    var action = actions[iAction];
	                    var data = action.data ? [action.data] : [elItem];
	                    elItem.addEventListener(action.event, analytics.send(action.functionName, data));
	                }
	            }
	        },
	        /**
	         * @description event listener function
	         * @param functionName {String}
	         * @param data {Object}
	         * @returns {Function}
	         */
	        send: function send(functionName, data) {
	            return function () {
	                try {
	                    if (window[functionName]) {
	                        window[functionName].apply(null, data);
	                    }
	                } catch (e) {
	                    throw new Error(e.stack);
	                }
	            };
	        }
	    };
	
	    return analytics;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(2), __webpack_require__(6), __webpack_require__(5), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (XhrPromise, config, constant, Breakpoint, cookieService) {
	    var countryData = null;
	
	    return {
	        buildDropDown: function buildDropDown() {
	            this.headerEL = document.querySelector('.navigation-common-hdr-main');
	            var loadCountryDom = this.loadCountryDom.bind(this);
	            var updateLanguageDropdown = this.updateLanguageDropdown.bind(this);
	            var changeLanguageDropdown = this.changeLanguageDropdown.bind(this);
	
	            this.countryDomMobile = document.querySelector('.navigation-country-mobile--country-list');
	            this.countryDom = document.querySelector('.navigation-country-overlay--country-list');
	            var ariaLabel = config && config.storeId === constant.ukId ? constant.ukCountryNameI : constant.ieCountryNameI;
	            window.analyticsNavCountryName = config && config.storeId === constant.ukId ? constant.ukFlagID : constant.ieFlagID;
	            window.analyticsNavCountryLanguage = 'English';
	
	            if (Breakpoint.size() === 'xsmall' && this.countryDomMobile.childElementCount === 0) {
	                this.languageDomMobile = document.querySelector('.navigation-country-mobile--language-list');
	                this.finalLinkMobile = document.querySelector('.navigation-country-mobile--link');
	                this.dropDownFlagMobile = document.querySelector('#navigation-flags-overlay-mobile');
	                this.countryDomMobile.addEventListener('change', updateLanguageDropdown);
	                this.languageDomMobile.addEventListener('change', changeLanguageDropdown);
	                this.finalLinkMobile.addEventListener('click', cookieService.updatePreferredCountryCookie);
	
	                this.finalLinkMobile.href = 'javascript:;';
	
	                var elementMob = document.createElement('option');
	                elementMob.innerText = config && config.storeId === constant.ukId ? constant.ukCountryName : constant.ieCountryName;
	                elementMob.value = '0';
	                elementMob.setAttribute('data-lang', window.analyticsNavCountryName);
	                elementMob.setAttribute('aria-label', ariaLabel);
	                this.countryDomMobile.appendChild(elementMob);
	                var langElementMob = document.createElement('option');
	                langElementMob.innerText = 'English';
	                langElementMob.value = 'javascript:;';
	                this.languageDomMobile.appendChild(langElementMob);
	                this.loadCountryData(loadCountryDom);
	            } else if (Breakpoint.size() !== 'xsmall' && this.countryDom.childElementCount === 0) {
	                this.languageDom = document.querySelector('.navigation-country-overlay--language-list');
	                this.finalLink = document.querySelector('.navigation-country-overlay--link');
	                this.dropDownFlag = document.querySelector('#navigation-flags-overlay-desktop');
	                this.finalLink.addEventListener('click', cookieService.updatePreferredCountryCookie);
	
	                this.countryDom.addEventListener('change', updateLanguageDropdown);
	                this.languageDom.addEventListener('change', changeLanguageDropdown);
	
	                this.finalLink.href = 'javascript:;';
	
	                var element = document.createElement('option');
	                element.innerText = config && config.storeId === constant.ukId ? constant.ukCountryName : constant.ieCountryName;
	                element.value = '0';
	                element.setAttribute('data-lang', window.analyticsNavCountryName);
	                element.setAttribute('aria-label', ariaLabel);
	                this.countryDom.appendChild(element);
	                var langElement = document.createElement('option');
	                langElement.innerText = 'English';
	                langElement.value = 'javascript:;';
	                this.languageDom.appendChild(langElement);
	                this.loadCountryData(loadCountryDom);
	            }
	        },
	
	        loadCountryDom: function loadCountryDom(data) {
	            window.analyticsCountryData = data;
	            countryData = data.countryLinks;
	            var spriteImage = data.countryFlagLink;
	            var img = document.createElement('img');
	            img.src = spriteImage;
	            if (countryData) {
	                for (var i = 0; i < countryData.length; i++) {
	                    var countryName = countryData[i].imgPath + ' ( ' + countryData[i].currency + ' )';
	                    var element = document.createElement('option');
	                    element.innerText = countryName;
	                    element.value = 1 + i;
	                    element.setAttribute('aria-label', countryData[i].imgPath);
	                    element.setAttribute('data-lang', countryData[i].langId);
	                    if (Breakpoint.size() === 'xsmall') {
	                        this.countryDomMobile.appendChild(element);
	                    } else {
	                        this.countryDom.appendChild(element);
	                    }
	                }
	                if (this.dropDownFlagMobile) {
	                    this.dropDownFlagMobile.style.backgroundImage = 'url("' + spriteImage + '")';
	                    document.querySelector('.navigation-mobile-country-selector .navigation-lazyload').style.display = 'none';
	                }
	                if (this.dropDownFlag) {
	                    this.dropDownFlag.style.backgroundImage = 'url("' + spriteImage + '")';
	                    document.querySelector('.navigation-country-overlay--dropdown .navigation-lazyload').style.display = 'none';
	                }
	            }
	        },
	
	        loadCountryData: function loadCountryData(callback) {
	            this.config = window.mnsHeaderConfig;
	            var xhrp = new XhrPromise();
	
	            xhrp.send({
	                url: this.config.wcsBaseUrl + this.config.CMD.countryLinks + '?catalogId=' + this.config.catalogId + '&langId=' + this.config.langId + '&storeId=' + this.config.storeId,
	                method: 'GET'
	            }).then(function (response) {
	                if (response.status === 200) {
	                    callback(response.responseText);
	                }
	            }).catch(function () {
	                //Handle errors here
	                callback([]);
	            });
	        },
	
	        updateLanguageDropdown: function updateLanguageDropdown() {
	            var lanDom = this.languageDom,
	                finalLink = this.finalLink,
	                countryDom = this.countryDom,
	                dropDownFlag = this.dropDownFlag;
	            if (Breakpoint.size() === 'xsmall') {
	                lanDom = this.languageDomMobile;
	                finalLink = this.finalLinkMobile;
	                countryDom = this.countryDomMobile;
	                dropDownFlag = this.dropDownFlagMobile;
	            }
	            if (lanDom && finalLink && countryDom && dropDownFlag) {
	                lanDom.innerHTML = '';
	                var langClass = dropDownFlag.classList[1];
	                if (countryDom.value === '0') {
	                    finalLink.href = 'javascript:;';
	                    var defaultElement = document.createElement('option');
	                    defaultElement.innerText = 'English';
	                    defaultElement.value = 'javascript:;';
	                    lanDom.appendChild(defaultElement);
	                    var defaultName = config && config.storeId === constant.ukId ? constant.ukFlagID : constant.ieFlagID;
	                    var defaultFLagClass = dropDownFlag.classList[0] + '--' + defaultName;
	                    dropDownFlag.classList.remove(langClass);
	                    dropDownFlag.classList.add(defaultFLagClass);
	                    window.analyticsNavCountryName = defaultName;
	                    window.analyticsNavCountryLanguage = 'English';
	                } else {
	                    var index = countryDom.value - 1;
	                    var langList = countryData[index].langOptions;
	                    var orgC = config && config.storeId === constant.ukId ? 'uk' : 'ie';
	                    finalLink.href = langList[0].URL + '?intid=' + orgC.toLowerCase() + '_header_country-redirect_' + countryData[index].name.toLowerCase() + '_countryselector';
	                    finalLink.setAttribute('data-lang', countryData[index].lang);
	                    finalLink.setAttribute('data-countryname', countryData[index].name);
	                    var newLangClass = dropDownFlag.classList[0] + '--' + countryData[index].name;
	                    dropDownFlag.classList.remove(langClass);
	                    dropDownFlag.classList.add(newLangClass);
	                    for (var i = 0; i < langList.length; i++) {
	                        var langElement = document.createElement('option');
	                        langElement.innerText = langList[i].Language;
	                        langElement.value = langList[i].URL;
	                        langElement.setAttribute('data-lang', countryData[index].lang);
	                        langElement.setAttribute('data-countryname', countryData[index].name);
	                        lanDom.appendChild(langElement);
	                    }
	                    window.analyticsNavCountryName = countryData[index].name;
	                    window.analyticsNavCountryLanguage = langList[0].Language;
	                }
	            }
	        },
	
	        changeLanguageDropdown: function changeLanguageDropdown() {
	            if (Breakpoint.size() === 'xsmall') {
	                this.finalLinkMobile.href = this.languageDomMobile.value;
	                var langMob = this.languageDomMobile.getAttribute('data-lang'),
	                    nameMob = this.languageDomMobile.getAttribute('data-countryname');
	                this.finalLinkMobile.setAttribute('data-lang', langMob);
	                this.finalLinkMobile.setAttribute('data-countryname', nameMob);
	            } else {
	                this.finalLink.href = this.languageDom.value;
	                var lang = this.languageDom.getAttribute('data-lang'),
	                    name = this.languageDom.getAttribute('data-countryname');
	                this.finalLink.setAttribute('data-lang', lang);
	                this.finalLink.setAttribute('data-countryname', name);
	            }
	        },
	
	        resetDropDown: function resetDropDown() {
	            if (countryData !== null) {
	                if (Breakpoint.size() === 'xsmall') {
	                    this.countryDomMobile.value = 0;
	                } else {
	                    this.countryDom.value = 0;
	                }
	                this.updateLanguageDropdown();
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
	
	    var namespaces = {};
	
	    function DropdownMenu(el, options) {
	
	        // member variables
	        this.menubar = el;
	        this.menuItemLinks = [];
	        this.options = options;
	        this.onMenuOpenCallbacks = [];
	
	        // add menu items
	        this.addMenuItems(el.querySelectorAll(this.options.menuItem));
	
	        // add click handler for document click
	        if (!DropdownMenu.hasDocumentClickHandler) {
	            addDocumentClickHandler(this);
	            DropdownMenu.hasDocumentClickHandler = true;
	        }
	
	        // add current instance to the list for later retrieval
	        if (this.options.namespace) {
	            namespaces[this.options.namespace] = this;
	        }
	    }
	
	    /**
	     * Returns cached instance of DropdownMenu
	     * @param {string} namespace instance regestered with
	     */
	    DropdownMenu.get = function (namespace) {
	        return namespaces[namespace] || null;
	    };
	
	    DropdownMenu.prototype = {
	        addMenuItems: function addMenuItems(els) {
	            for (var i = 0, n = els.length; i < n; i++) {
	                this.addMenuItem(els[i]);
	            }
	        },
	        addMenuItem: function addMenuItem(menuItem) {
	            this.addMenuItemLink(menuItem.querySelector(this.options.menuItemLink), menuItem.querySelector(this.options.menuDropdown));
	        },
	        addMenuItemLink: function addMenuItemLink(menuItemLink, menuDropdown) {
	            if (!menuItemLink || !menuDropdown) {
	                return false;
	            }
	            if (this.menuItemLinks.indexOf(menuItemLink) == -1) {
	                //eslint-disable-line
	                menuDropdown.setAttribute('aria-hidden', 'true');
	                this.menuItemLinks.push(menuItemLink);
	                this.addMenuItemLinkEvent(menuItemLink);
	                this.stopDropdownClickEvent(menuDropdown);
	            }
	        },
	        toggleDropdownEvent: function toggleDropdownEvent(menuItemLink) {
	            var link = menuItemLink.previousElementSibling.checked ? null : menuItemLink,
	                self = this;
	
	            setTimeout(function () {
	                self.toggleDropdown(link);
	            }, 0);
	        },
	        addMenuItemLinkEvent: function addMenuItemLinkEvent(menuItemLink) {
	            menuItemLink.toggleDropdownEventFn = this.toggleDropdownEvent.bind(this, menuItemLink);
	            menuItemLink.href = 'javascript:;';
	            menuItemLink.addEventListener('click', menuItemLink.toggleDropdownEventFn);
	        },
	        removeMenuItemLinkEvent: function removeMenuItemLinkEvent(menuItemLink) {
	            if (menuItemLink.toggleDropdownEventFn) {
	                menuItemLink.removeEventListener('click', menuItemLink.toggleDropdownEventFn);
	            }
	
	            if (menuItemLink.href === 'javascript:;') {
	                menuItemLink.href = menuItemLink.oldHref;
	            }
	        },
	        toggleDropdown: function toggleDropdown(menuItemLinkClicked) {
	            var self = this;
	            this.menuItemLinks.map(function (menuItemLink) {
	                self.toggleAccessibility(menuItemLink, menuItemLinkClicked);
	                if (menuItemLink === menuItemLinkClicked) {
	                    menuItemLinkClicked.previousElementSibling.checked = !menuItemLinkClicked.previousElementSibling.checked;
	                    self.executeOnMenuOpenCallbacks(menuItemLinkClicked);
	                } else {
	                    menuItemLink.previousElementSibling.checked = false;
	                }
	            });
	        },
	        stopDropdownClickEvent: function stopDropdownClickEvent(menuDropdown) {
	            menuDropdown.addEventListener('click', function (evt) {
	                evt.stopPropagation();
	            });
	        },
	        toggleAccessibility: function toggleAccessibility(menuItemLink, menuItemLinkClicked) {
	            var dropdownClicked = menuItemLink === menuItemLinkClicked;
	            var menuItem = dropdownClicked ? menuItemLinkClicked : menuItemLink;
	            var dropdown = menuItem.nextElementSibling;
	            var tabindexToGet = dropdownClicked ? -1 : 0;
	            var tabindexToSet = dropdownClicked ? 0 : -1;
	            var ariaHidden = dropdownClicked ? 'false' : 'true';
	            var els = dropdown.querySelectorAll('[tabindex="' + tabindexToGet + '"]');
	
	            dropdown.setAttribute('aria-hidden', ariaHidden);
	            utils.setTabIndex(els, tabindexToSet);
	        },
	
	        /**
	         * Add onMenuOpen event callback
	         * @param {Function} : Callback function
	         * @returns {Boolean} : TRUE if callback added
	         */
	        onMenuOpen: function onMenuOpen(callback) {
	            var self = this;
	
	            if (self.onMenuOpenCallbacks.indexOf(callback) > -1) {
	                return false;
	            }
	
	            self.onMenuOpenCallbacks.push(callback);
	
	            return function () {
	                self.onMenuOpenCallbacks = self.onMenuOpenCallbacks.filter(function (item) {
	                    return item !== callback;
	                });
	            };
	        },
	
	        /**
	         * Executes onMenuOpen callback functions list
	         * @param {HTMLElement} - Menuitem clicked
	         */
	        executeOnMenuOpenCallbacks: function executeOnMenuOpenCallbacks(menuItemLinkClicked) {
	            this.onMenuOpenCallbacks.map(function (callback) {
	                callback(menuItemLinkClicked);
	            });
	        }
	    };
	
	    // ---- private methods -----
	
	    function addDocumentClickHandler(context) {
	        document.body.addEventListener('click', function () {
	            DropdownMenu.prototype.toggleDropdown.apply(context);
	        });
	    }
	
	    return DropdownMenu;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(21), __webpack_require__(19), __webpack_require__(24), __webpack_require__(8), __webpack_require__(4), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (domQ, DockOverlay, Carousel, miniBagService, analytics, cookieService, config) {
	
	    var ITEM_LBL = 'item',
	        ITEMS_LBL = 'items',
	        BAG_LBL = 'Bag',
	        QTY_LBL = 'Qty',
	        BAG_ITEM_LBL = 'Shopping bag with',
	        BAG_ZERO_LBL = 'Your shopping bag is empty';
	
	    /**
	     * Creates a new MiniBagOverlay component.
	     * @constructor
	     * @param {Object} element Overlay DOM element
	     * @param {Object} options
	     */
	    function MiniBagOverlay(element, options) {
	        this.element = element;
	        this.options = this.getOptions(options);
	        this.target = document.querySelector(this.options.targetSelector);
	
	        this.overlay = new DockOverlay(this.element, this.target, this.options);
	
	        // subscribe basket updation
	        this.bindEvents();
	    }
	
	    /**
	     * Initializes multiple mini bag overlay components.
	     * @param {Object} elements - Nodelist DOM elements
	     * @returns {Object} - Mini bag overlay component list
	     */
	    MiniBagOverlay.initialize = function (elements, options) {
	        var list = [];
	
	        if (!elements.length) {
	            return false;
	        }
	
	        for (var i = 0, n = elements.length; i < n; i++) {
	            list.push(new MiniBagOverlay(elements[i], options));
	        }
	
	        return list;
	    };
	
	    MiniBagOverlay.prototype = {
	
	        /**
	         * Returns overlay configuration options
	         * @returns {Object} options Configuration hash object
	         */
	        getOptions: function getOptions(options) {
	            return _extends({}, options, {
	                targetSelector: this.element.getAttribute('data-mini-bag-link'),
	                align: this.element.getAttribute('data-mini-bag-align'),
	                direction: this.element.getAttribute('data-mini-bag-direction')
	            });
	        },
	
	        /**
	         * Bind load and change data event handlers
	         */
	        bindEvents: function bindEvents() {
	            if (parseInt(this.getBasketSize(), 10) > 0) {
	                this.removeOnInitShowEventHandler = this.overlay.onInitShowEvent(this.loadData.bind(this));
	            } else {
	                this.overlay.disable();
	            }
	
	            miniBagService.onChange(this.basketUpdated.bind(this));
	        },
	
	        /**
	         * Initiates request to load basket details
	         */
	        loadData: function loadData() {
	
	            // remove on init show event
	            if (this.removeOnInitShowEventHandler) {
	                this.removeOnInitShowEventHandler();
	            }
	
	            miniBagService.load(this.options.miniBagCMD, this.options.requestParams);
	        },
	
	        /**
	         * Updates mini bag overlay content/carousel
	         * @param {Object} data Basket detail
	         */
	        basketUpdated: function basketUpdated(data) {
	            this.myBagData = data;
	            var BASKET_ITEM_COUNT = 2;
	            data.basketDetails = (data.basketDetails || []).filter(function (item) {
	                return !item.gatedPriorityAccess;
	            });
	            var addOnLength = 0;
	            if (data.basketDetails.length > 0) {
	                for (var i = 0; i < data.basketDetails.length; i++) {
	                    addOnLength = addOnLength + data.basketDetails[i].childItemCount;
	                }
	            }
	            var totalLength = data.basketDetails.length + addOnLength;
	            if (data.basketDetails.length === 0) {
	                this.overlay.disable();
	            } else if (totalLength <= BASKET_ITEM_COUNT) {
	                this.overlay.enable();
	                this.insertMiniBag(this.generateMiniBagContent(data));
	                this.checkoutBtnAnalyticsfunction();
	                this.disableScroll(true);
	            } else {
	                this.insertMiniBagCarousel(this.generateMiniBagContent(data));
	                this.checkoutBtnAnalyticsfunction();
	                this.disableScroll(false);
	                this.overlay.enable();
	                this.initMiniBagCarousel();
	            }
	
	            //Update mini bag title after rendering
	            this.updateBagTitleWithCount();
	        },
	
	        removeItemEvent: function removeItemEvent() {
	            var removeProductClick = document.querySelectorAll('.navigation-hdr-mini-bag__remove-item');
	            for (var i = 0; i < removeProductClick.length; i++) {
	                removeProductClick[i].addEventListener('click', this.removeProduct.bind(this.myBagData));
	                removeProductClick[i].addEventListener('keyup', this.removeProduct.bind(this.myBagData));
	            }
	        },
	
	        removeProduct: function removeProduct(element) {
	            var minibagData = this;
	            var keyPressed = element.key || element.keyCode;
	            var focusElementParentDiv = element.target.parentNode.parentNode.parentNode.parentNode;
	            var focusElementDiv = focusElementParentDiv.querySelector('.navigation-mini-bag__remove-text');
	            if (keyPressed === 'Enter' || keyPressed === 13) {
	                removeProductOnclick(element, minibagData);
	                focusElementDiv.focus();
	                focusElementDiv.addEventListener('keyup', function (element) {
	                    var linkUrl = element.target.querySelector('.navigation-mini-bag__remove-text a');
	                    var keyPressed = element.key || element.keyCode;
	                    if (keyPressed === 'Enter') {
	                        if (linkUrl) {
	                            window.location.href = linkUrl;
	                        }
	                    }
	                });
	            } else if (element.type === 'click') {
	                removeProductOnclick(element, minibagData);
	            }
	            function removeProductOnclick(element, minibagData) {
	                var spanElement = element.target || element.srcElement;
	                if (spanElement.className === 'navigation-hdr-mini-bag__remove-item--icon') {
	                    element = element.target.parentNode || element.srcElement.parentNode;
	                    spanElement = element;
	                }
	                var orderItemId = spanElement.getAttribute('id');
	                window.analyticsHeaderRemoveProduct(spanElement);
	                var removeItemUrl = config.wcsBaseUrl + config.CMD.removeItemMiniBag + '?deleteChild=true&doInventorycheck=false&calculateOrder=1&resJSON=true&langId=' + config.langId + '&storeId=' + config.storeId + '&basketAction=remove&redirectSecureURL=&quantity_1=0&doPrice=N&isSecureFlow=false&orderItemId_1=' + orderItemId;
	                miniBagService.removeItem(removeItemUrl);
	                var miniBagQty;
	
	                function calculateAddOnQuantity(childItems, orderIds) {
	                    var childMiniBagQty = 0;
	                    for (var k = 0; k < childItems.length; k++) {
	                        for (var l = 0; l < orderIds.length; l++) {
	                            if (childItems[k].orderItemId === orderIds[l]) {
	                                childMiniBagQty = childMiniBagQty + childItems[k].quantity;
	                            }
	                        }
	                    }
	                    return childMiniBagQty;
	                }
	
	                var productContent = spanElement.parentNode.parentNode.parentNode.parentNode.children[0];
	                spanElement.parentNode.parentNode.parentNode.style.display = 'none';
	                if (document.querySelector('.navigation-hdr-mini-bag__remove-element')) {
	                    var removeElement = document.querySelector('.navigation-hdr-mini-bag__remove-element').parentNode;
	                    if (domQ(removeElement).hasClass('navigation-hdr-mini-bag__add-on-container')) {
	                        if (removeElement.parentNode.children.length === 2) {
	                            var addOnTitle = removeElement.parentNode.children[0];
	                            removeElement.parentNode.removeChild(addOnTitle);
	                        }
	                    }
	                    removeElement.parentNode.removeChild(removeElement);
	                }
	                var addOnContent = spanElement.parentNode.parentNode.parentNode.parentNode.children[2];
	                var addOnOrderIds = [];
	                if (addOnContent.children && addOnContent.children.length > 0) {
	                    for (var c = 1; c < addOnContent.children.length; c++) {
	                        var orderId = addOnContent.children[c].querySelector('.navigation-hdr-mini-bag__remove-item-add-on').getAttribute('id');
	                        addOnOrderIds.push(orderId);
	                    }
	                }
	
	                var removedItemPrice = 0.0;
	                var subTotal = 0.0;
	
	                for (var e = 0; e < minibagData.basketDetails.length; e++) {
	                    if (minibagData.basketDetails[e].orderItemId === orderItemId) {
	                        miniBagQty = parseInt(minibagData.basketDetails[e].quantity);
	                        if (minibagData.basketDetails[e].childItemCount > 0) {
	                            var childMiniBagQty = calculateAddOnQuantity(minibagData.basketDetails[e].childItems, addOnOrderIds);
	                            miniBagQty = miniBagQty + childMiniBagQty;
	                        }
	                        removedItemPrice = parseFloat(minibagData.basketDetails[e].itemPrice * minibagData.basketDetails[e].quantity);
	                        break;
	                    }
	                }
	
	                addOnContent.parentNode.removeChild(addOnContent);
	                domQ(productContent).removeClass('navigation-mini-bag__remove-message-display');
	                domQ(productContent).addClass('navigation-hdr-mini-bag__remove-element');
	                var bagCountAtag = document.querySelector('.navigation-res-nav-header__item--bag a');
	                var viewBagCount = document.querySelector('.navigation-nav-header__bag-count');
	                var bagIconElement = document.querySelector('.navigation-res-nav-header__item--bag .navigation-primary__menu-icon');
	                var listOfItems = document.querySelector('.navigation-hdr-mini-bag--list').children;
	                var listOfAddons = document.querySelectorAll('.navigation-hdr-mini-bag__add-on-container').length;
	                var noOfItems = listOfItems.length + listOfAddons;
	                var bagSubtotalElt = document.querySelector('.navigation-hdr-mini-bag__subtotal');
	                if (noOfItems && noOfItems > 1) {
	                    var appendInnerText = parseInt(viewBagCount.textContent) - miniBagQty;
	                    if (noOfItems === 2) {
	                        domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
	                    }
	                    if (appendInnerText === 1) {
	                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEM_LBL + ')';
	                    } else {
	                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEMS_LBL + ')';
	                    }
	                    domQ(viewBagCount).text(viewBagCount.textContent - miniBagQty);
	                    bagCountAtag.setAttribute('aria-label', BAG_ITEM_LBL + ' ' + viewBagCount.innerHTML + ' ' + ITEMS_LBL);
	                    if (minibagData.totalExDelivery) {
	                        subTotal = parseFloat(bagSubtotalElt.textContent.replace(/['£', ',']/g, ''));
	                        bagSubtotalElt.innerText = '£' + (subTotal - removedItemPrice).toFixed(2);
	                    }
	                } else {
	                    if (domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).hasClass('navigation-hdr-mini-bag__carousel')) {
	                        domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
	                    }
	                    document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(empty)';
	                    document.querySelector('.navigation-hdr-mini-bag__cta-links--view-bag').style.display = 'none';
	                    document.querySelector('.navigation-hdr-mini-bag__cta-links--checkout').style.display = 'none';
	                    document.querySelector('.navigation-hdr-mini-bag__cta-links').innerText = BAG_ZERO_LBL;
	                    var miniBagATag = document.querySelector('.navigation-res-nav-header__item--bag a');
	                    miniBagATag.setAttribute('aria-label', 'Shopping bag with 0 item');
	                    domQ(document.querySelector('.navigation-hdr-mini-bag__cta-links')).addClass('navigation-hdr-mini-bag__empty--text');
	                    domQ(document.querySelector('.navigation-res-nav-header__item--bag')).removeClass('selected');
	                    domQ(document.querySelector('.navigation-res-nav-header__item--checkout')).addClass('navigation-res-nav-header__item--hidden');
	                    domQ(bagIconElement).removeClass('navigation-res-icon--fill-my-bag');
	                    domQ(bagIconElement).addClass('navigation-res-icon--empty-my-bag');
	                    domQ(document.querySelector('.navigation-res-nav-header__item--bag')).addClass('navigation-hdr-bag-unclick');
	                    document.querySelector('.navigation-hdr-mini-bag__empty--text').setAttribute('tabIndex', '8');
	                    domQ(document.querySelector('.navigation-chevronicon__minibag')).addClass('navigation-minibag-empty');
	                    domQ(document.querySelector('.navigation-chevronicon__minibag')).removeClass('navigation-minibag-empty-display');
	                    viewBagCount.innerHTML = 0;
	                    bagSubtotalElt.parentElement.style.display = 'none';
	                }
	            }
	        },
	
	        removeAddonEvent: function removeAddonEvent() {
	            var removeAddonClick = document.querySelectorAll('.navigation-hdr-mini-bag__remove-item-add-on');
	            for (var i = 0; i < removeAddonClick.length; i++) {
	                removeAddonClick[i].addEventListener('click', this.removeAddonProduct.bind(this.myBagData));
	                removeAddonClick[i].addEventListener('keyup', this.removeAddonProduct.bind(this.myBagData));
	            }
	        },
	
	        removeAddonProduct: function removeAddonProduct(element) {
	            var minibagData = this;
	            var keyPressed = element.key || element.keyCode;
	            if (keyPressed === 'Enter' || keyPressed === 13) {
	                removeAddonProductClick(element, minibagData);
	                var AddonFocusParentDiv = element.target.parentNode.parentNode.parentNode.parentNode;
	                var AddonFocusDiv = AddonFocusParentDiv.querySelector('.navigation-mini-bag__remove-confirmation-add-on');
	                AddonFocusDiv.focus();
	            } else if (element.type === 'click') {
	                removeAddonProductClick(element, minibagData);
	            }
	
	            function removeAddonProductClick(element, minibagData) {
	                var spanElement = element.target || element.srcElement;
	                if (element.srcElement.className === 'navigation-hdr-mini-bag__remove-item--icon-add-on') {
	                    element = element.srcElement.parentNode;
	                    spanElement = element;
	                }
	                var orderItemId = spanElement.getAttribute('id');
	                window.analyticsHeaderRemoveAddOn(spanElement);
	                var removeItemUrl = config.wcsBaseUrl + config.CMD.removeItemMiniBag + '?deleteChild=true&doInventorycheck=false&calculateOrder=1&resJSON=true&langId=' + config.langId + '&storeId=' + config.storeId + '&basketAction=remove&redirectSecureURL=&quantity_1=0&doPrice=N&isSecureFlow=false&orderItemId_1=' + orderItemId;
	                miniBagService.removeItem(removeItemUrl);
	                var qty;
	                var productOrderItemId = spanElement.parentNode.parentNode.parentNode.getAttribute('id');
	
	                var removedItemPrice = 0.0;
	                var subTotal = 0.0;
	
	                function calculateAddOnQuantity(childItems, childOrderItemId) {
	                    var qty;
	                    for (var k = 0; k < childItems.length; k++) {
	                        if (childItems[k].orderItemId === childOrderItemId) {
	                            qty = parseInt(childItems[k].quantity);
	                            removedItemPrice = parseFloat(childItems[k].itemPrice * qty);
	                        }
	                    }
	                    return qty;
	                }
	
	                for (var j = 0; j < minibagData.basketDetails.length; j++) {
	                    if (minibagData.basketDetails[j].orderItemId === productOrderItemId) {
	                        if (minibagData.basketDetails[j].childItemCount > 0) {
	                            qty = calculateAddOnQuantity(minibagData.basketDetails[j].childItems, orderItemId);
	                        }
	                        break;
	                    }
	                }
	                var productContent = spanElement.parentNode.parentNode.parentNode.parentNode.children[0];
	                spanElement.parentNode.parentNode.parentNode.style.display = 'none';
	                if (document.querySelector('.navigation-hdr-mini-bag__remove-element')) {
	                    var removeElement = document.querySelector('.navigation-hdr-mini-bag__remove-element').parentNode;
	                    if (domQ(removeElement).hasClass('navigation-hdr-mini-bag__add-on-container')) {
	                        if (removeElement.parentNode.children.length === 2) {
	                            var addOnTitle = removeElement.parentNode.children[0];
	                            removeElement.parentNode.removeChild(addOnTitle);
	                        }
	                    }
	                    removeElement.parentNode.removeChild(removeElement);
	                }
	                domQ(productContent).removeClass('navigation-mini-bag__remove-message-display-add-on');
	                domQ(productContent).addClass('navigation-hdr-mini-bag__remove-element');
	                var viewBagCount = document.querySelector('.navigation-nav-header__bag-count');
	
	                var listOfItems = document.querySelector('.navigation-hdr-mini-bag--list').children;
	                var listOfAddons = document.querySelectorAll('.navigation-hdr-mini-bag__add-on-container').length;
	                var noOfItems = listOfItems.length + listOfAddons;
	                var bagSubtotalElt = document.querySelector('.navigation-hdr-mini-bag__subtotal');
	                if (noOfItems > 1) {
	                    var appendInnerText = parseInt(viewBagCount.textContent) - qty;
	                    if (noOfItems === 2) {
	                        domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
	                    }
	                    if (appendInnerText === 1) {
	                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEM_LBL + ')';
	                    } else {
	                        document.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + appendInnerText + ' ' + ITEMS_LBL + ')';
	                    }
	                    domQ(viewBagCount).text(viewBagCount.textContent - qty);
	                    if (minibagData.totalExDelivery) {
	                        subTotal = parseFloat(bagSubtotalElt.textContent.replace(/['£',',']/g, ''));
	                        bagSubtotalElt.innerText = '£' + (subTotal - removedItemPrice).toFixed(2);
	                    }
	                }
	            }
	        },
	
	        updateBagTitleWithCount: function updateBagTitleWithCount() {
	            var bagCount = this.getBasketSize();
	            var bagTitle = document.querySelector('.navigation-mini-bag__title');
	            if (bagTitle && bagCount && bagCount > 0) {
	                bagTitle.innerHTML = BAG_LBL + ' (' + bagCount + ' ' + ITEMS_LBL + ')';
	            } else if (bagTitle && bagCount && bagCount === 0) {
	                bagTitle.innerHTML = BAG_LBL + ' (' + bagCount + ' ' + ITEM_LBL + ')';
	            }
	        },
	        //to enable/disable scroll
	        disableScroll: function disableScroll(_disableScroll) {
	            if (_disableScroll === true) {
	                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--next')).addClass('disabled');
	                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--prev')).addClass('disabled');
	            } else {
	                this.scrollEvent();
	                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--next')).removeClass('disabled');
	                domQ(this.element.querySelector('.navigation-hdr-mini-bag__ctrl--prev')).removeClass('disabled');
	            }
	        },
	
	        checkoutBtnAnalyticsfunction: function checkoutBtnAnalyticsfunction() {
	            var checkoutBtnElement = document.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary');
	            analytics.bind(checkoutBtnElement, [{
	                functionName: 'analyticsHeaderMiniBasketCheckoutButton',
	                event: 'click'
	            }]);
	        },
	
	        /**
	         * Instantiate carousel component on mini bag content
	         */
	        initMiniBagCarousel: function initMiniBagCarousel() {
	            new Carousel(this.overlay.element.querySelector('.navigation-hdr-mini-bag__carousel'), {
	                multiple: true,
	                wrapper: '.navigation-mini-bag__items-wrap',
	                slider: '.navigation-hdr-mini-bag__items',
	                slide: '.navigation-hdr-mini-bag__items li',
	                previousBtn: '.navigation-hdr-mini-bag__ctrl--prev .navigation-hdr-ctrl--link',
	                nextBtn: '.navigation-hdr-mini-bag__ctrl--next .navigation-hdr-ctrl--link',
	                type: 'vertical'
	            }).init();
	        },
	
	        /**
	         * Insert mini bag content into DOM
	         * @param {Object} content Basket detail
	         */
	        insertMiniBag: function insertMiniBag(content) {
	            this.overlay.content(content.innerHTML);
	            this.removeItemEvent();
	            this.removeAddonEvent();
	        },
	
	        /**
	         * Generate DOM for Mini Bag carousel
	         * @param {Object} miniBag Basket detail
	         */
	        insertMiniBagCarousel: function insertMiniBagCarousel(miniBag) {
	            domQ(miniBag.children[1]).addClass('navigation-hdr-mini-bag__carousel');
	            this.insertMiniBag(miniBag);
	        },
	
	        scrollEvent: function scrollEvent() {
	            var minibagContent = document.querySelector('.navigation-mini-bag__items-wrap');
	            minibagContent.addEventListener('scroll', this.minibagContentScroll);
	        },
	
	        minibagContentScroll: function minibagContentScroll() {
	            var minibagDiv = document.querySelector('.navigation-mini-bag__items-wrap');
	            if (!domQ(minibagDiv).hasClass('navigation-hdr-mini-bag__top-line')) {
	                domQ(minibagDiv).addClass('navigation-hdr-mini-bag__top-line');
	            }
	            if (minibagDiv.scrollTop <= 13 && domQ(minibagDiv).hasClass('navigation-hdr-mini-bag__top-line')) {
	                domQ(minibagDiv).removeClass('navigation-hdr-mini-bag__top-line');
	            }
	        },
	
	        /**
	         * Generate DOM for Mini Bag content
	         * @param {Object} data Basket detail
	         */
	        generateMiniBagContent: function generateMiniBagContent(data) {
	            var template = this.getMiniBagTemplate(),
	                miniBagList = template.querySelector('.navigation-hdr-mini-bag__items'),
	                miniBagListItem = miniBagList.removeChild(miniBagList.children[0]),
	                generateMiniBagItem = this.generateMiniBagItem.bind(this),
	                checkOutLink;
	
	            data.basketDetails.map(function (product) {
	                var node;
	                if (!product.gatedPriorityAccess) {
	                    node = miniBagListItem.cloneNode(true);
	                    miniBagList.appendChild(generateMiniBagItem(node, product));
	                }
	            });
	            template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--secondary').setAttribute('href', data.basketLink);
	            var bagCount = this.getBasketSize();
	            if (bagCount && parseInt(bagCount) === 1) {
	                template.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + parseInt(bagCount) + ' ' + ITEM_LBL + ')';
	            } else {
	                template.querySelector('.navigation-mini-bag__title .navigation-bag-title-count').innerText = '(' + parseInt(bagCount) + ' ' + ITEMS_LBL + ')';
	            }
	            if (cookieService.getUserLoginCookieValue() || cookieService.getCookieValue('MS_AO_COOKIE')) {
	                template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary').setAttribute('href', data.checkOutLink);
	            } else {
	                checkOutLink = template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary').dataset.globalCheckoutLink;
	                template.querySelector('.navigation-hdr-mini-bag__cta-links .navigation-hdr-btn--primary').setAttribute('href', checkOutLink);
	            }
	            if (data.totalExDelivery) {
	                template.querySelector('.navigation-hdr-mini-bag__subtotal-wrapper .navigation-hdr-mini-bag__subtotal').innerText = '£' + parseFloat(data.totalExDelivery.replace(/['£', ',']/g, '')).toFixed(2);
	                template.querySelector('.navigation-hdr-mini-bag__cta-links').classList.add('no-border');
	            } else {
	                template.querySelector('.navigation-hdr-mini-bag__subtotal-wrapper').style.display = 'none';
	            }
	            return template;
	        },
	
	        /**
	         * Generate DOM for Mini Bag content
	         * @param {data} Basket detail
	         */
	        generateMiniBagItem: function generateMiniBagItem(el, product) {
	            var productTitle = el.querySelector('.navigation-hdr-mini-bag__item-title'),
	                productTitleRemoveLink = el.querySelector('.navigation-mini-bag__item-title__remove'),
	                productremoveTitlefocus = el.querySelector('.navigation-mini-bag__remove-text'),
	                productImage = el.querySelector('.navigation-hdr-mini-bag__item-img'),
	                productImageLink = el.querySelector('.navigation-hdr-mini-bag__item-img-wrap'),
	                productDetailWrap = el.querySelector('.navigation-hdr-mini-bag__item-detail'),
	                productInfo = productDetailWrap.removeChild(productDetailWrap.querySelector('.navigation-hdr-mini-bag__item-info')),
	                productPriceInfo = productDetailWrap.removeChild(productDetailWrap.querySelector('.navigation-hdr-mini-bag__item-price')),
	                productRemoveItem = productDetailWrap.removeChild(productDetailWrap.querySelector('.navigation-hdr-mini-bag__remove')),
	                productAddOns = el.querySelector('.navigation-hdr-mini-bag__add-ons'),
	                productAddOnHeading = productAddOns.removeChild(productAddOns.querySelector('.navigation-hdr-mini-bag__add-on-title')),
	                productAddOnContainer = productAddOns.removeChild(productAddOns.querySelector('.navigation-hdr-mini-bag__add-on-container'));
	
	            var parser = new window.DOMParser();
	            var dom = parser.parseFromString(product.productTitle, 'text/html');
	            var domAltText = parser.parseFromString(product.productImgeAltText, 'text/html');
	
	            var priceInfoForAria = '';
	            var addOnPriceInfoForAria = '';
	
	            productTitle.innerText = dom.body.textContent;
	            productTitle.setAttribute('href', product.productUrl);
	            productTitle.href = productTitle.href + '#intid=header_minibasket_product-txt';
	            productTitle.setAttribute('title', dom.body.textContent);
	
	            productTitleRemoveLink.innerText = dom.body.textContent;
	            productTitleRemoveLink.setAttribute('href', product.productUrl);
	            productTitleRemoveLink.href = productTitleRemoveLink.href + '#intid=header_minibasket_removed-product-txt';
	            productTitleRemoveLink.setAttribute('title', dom.body.textContent);
	            productremoveTitlefocus.setAttribute('tabIndex', '8');
	            productremoveTitlefocus.setAttribute('aria-label', productTitle.innerText + 'has been removed from your shopping bag , link');
	
	            productImage.setAttribute('src', product.productImgUrl);
	            productImage.setAttribute('alt', product.productImgeAltText);
	
	            productImageLink.setAttribute('href', product.productUrl);
	            productImageLink.href = productImageLink.href + '#intid=header_minibasket_product-image';
	            productImageLink.setAttribute('title', domAltText.body.textContent);
	
	            if (!product.productAttributes) {
	                product.productAttributes = [];
	            }
	
	            if (product.productAttribute && product.productType === 'Furniture' && (product.productDefinition === 'Sofas' || product.productDefinition === 'Armchairs' || product.productDefinition === 'Loveseats' || product.productDefinition === 'Recliners' || product.productDefinition === 'Foot Stools')) {
	                product.productAttributes.push({
	                    productAttrName: '',
	                    productAttrValue: product.productAttribute
	                });
	            }
	            if (product.childItems && product.childItems.length - product.childItemCount >= 1 && product.productType === 'Furniture' && (product.productDefinition === 'Sofas' || product.productDefinition === 'Armchairs' || product.productDefinition === 'Loveseats' || product.productDefinition === 'Recliners' || product.productDefinition === 'Foot Stools')) {
	                for (var i = 0; i < product.childItems.length; i++) {
	                    if (product.childItems[i].productType !== 'Services' && product.childItems[i].addOnColour) {
	                        product.productAttributes.push({
	                            productAttrName: product.childItems[i].productDefinition,
	                            productAttrValue: product.childItems[i].productTitle + ', ' + product.childItems[i].addOnColour
	                        });
	                    } else if (product.childItems[i].productType !== 'Services') {
	                        product.productAttributes.push({
	                            productAttrName: product.childItems[i].productDefinition,
	                            productAttrValue: product.childItems[i].productTitle
	                        });
	                    }
	                }
	            }
	            product.productAttributes.push({
	                productAttrName: QTY_LBL,
	                productAttrValue: product.quantity
	            });
	
	            function getArialabelForProduct(productAttrName, productAttrValue, index, productAttributesLength) {
	
	                var minibagItemInfo = productDetailWrap.getAttribute('aria-label');
	                if (productAttrName === 'Colour') {
	                    productAttrName = '';
	                }
	                if (productAttrName === 'Qty') {
	                    productAttrName = 'Quantity';
	                }
	
	                if (index === productAttributesLength - 1) {
	                    productDetailWrap.setAttribute('aria-label', minibagItemInfo + ', ' + productAttrName + ', ' + productAttrValue + ', ' + priceInfoForAria);
	                } else {
	                    productDetailWrap.setAttribute('aria-label', minibagItemInfo + ', ' + productAttrName + ', ' + productAttrValue);
	                }
	            }
	
	            function getArialabelForAddOnProduct(productAttrName, productAttrValue, index, productAttributesLength, productDetailWrapAddon) {
	                var minibagAddOnItemInfo = productDetailWrapAddon.getAttribute('aria-label');
	                if (productAttrName === 'Colour') {
	                    productAttrName = '';
	                }
	                if (productAttrName === 'Qty') {
	                    productAttrName = 'Quantity';
	                }
	
	                if (index === productAttributesLength - 1) {
	                    productDetailWrapAddon.setAttribute('aria-label', minibagAddOnItemInfo + ', ' + productAttrName + ', ' + productAttrValue + ', ' + addOnPriceInfoForAria);
	                } else {
	                    productDetailWrapAddon.setAttribute('aria-label', minibagAddOnItemInfo + ', ' + productAttrName + ', ' + productAttrValue);
	                }
	            }
	            if (product.quantity || product.quantity !== '') {
	                var productPriceDetails = productPriceInfo.cloneNode(true);
	                var totalItemPrice = product.itemPrice * product.quantity;
	                var totalItemPriceRoundOff = totalItemPrice.toFixed(2);
	                if (product.wasPrice) {
	                    var totalWasPrice = product.wasPrice * product.quantity;
	                    var totalwasPriceRoundOff = totalWasPrice.toFixed(2);
	                    productPriceDetails.innerHTML = '<span class="navigation-minibasket__currentprice">' + product.currency + totalItemPriceRoundOff + '</span><span class="navigation-minibasket__wasprice">' + product.currency + totalwasPriceRoundOff + '</span>';
	                    productDetailWrap.setAttribute('aria-label', productTitle.innerText);
	                    priceInfoForAria = product.currency + totalItemPriceRoundOff;
	                } else {
	                    productPriceDetails.innerText = product.currency + totalItemPriceRoundOff;
	                    productDetailWrap.setAttribute('aria-label', productTitle.innerText);
	                    priceInfoForAria = product.currency + totalItemPriceRoundOff;
	                }
	
	                productDetailWrap.appendChild(productPriceDetails);
	                product.productAttributes.map(function (detail, i) {
	                    var productDetail = productInfo.cloneNode(true);
	
	                    if (product.productType === 'Furniture' && (product.productDefinition === 'Sofas' || product.productDefinition === 'Armchairs' || product.productDefinition === 'Loveseats' || product.productDefinition === 'Recliners' || product.productDefinition === 'Foot Stools') && detail.productAttrName !== 'Qty') {
	                        productDetail.children[0].classList.add('navigation-minibasket-furniture__attributes');
	                        productDetail.children[1].classList.add('navigation-minibasket-furniture__attributes');
	                    }
	
	                    if (detail.productAttrName === '' || detail.productAttrName === undefined) {
	                        productDetail.children[1].innerText = detail.productAttrValue;
	                    } else {
	                        productDetail.children[0].innerText = detail.productAttrName + ': ';
	                        productDetail.children[1].innerText = detail.productAttrValue;
	                    }
	                    getArialabelForProduct(productDetail.children[0].innerText, productDetail.children[1].innerText, i, product.productAttributes.length);
	                    productDetailWrap.appendChild(productDetail);
	                });
	                var productRemoveButton = productRemoveItem.cloneNode(true);
	                productDetailWrap.appendChild(productRemoveButton);
	                var productRemoveClick = productRemoveButton.querySelector('.navigation-hdr-mini-bag__remove-item');
	                productRemoveClick.setAttribute('id', product.orderItemId);
	                productRemoveClick.setAttribute('aria-label', 'Remove ' + productTitle.innerText + ' button');
	                productRemoveClick.setAttribute('data-productStroke', product.productStroke);
	                productRemoveClick.setAttribute('data-productUpc', product.productUPC);
	                productRemoveClick.setAttribute('data-productId', product.productId);
	                productRemoveClick.setAttribute('data-cost', priceInfoForAria);
	                productRemoveClick.setAttribute('data-quantity', product.quantity);
	            }
	
	            if (product.childItemCount > 0) {
	                var productAddOnTitle = productAddOnHeading.cloneNode(true);
	                productAddOnTitle.setAttribute('tabIndex', 8);
	                productAddOns.appendChild(productAddOnTitle);
	                product.childItems.map(function (child) {
	                    if (product.productType === 'Furniture' && child.productType === 'Services' || product.productType !== 'Furniture') {
	                        var productAddOnList = productAddOnContainer.cloneNode(true);
	                        var productAddOnWrap = productAddOnList.querySelector('.navigation-hdr-mini-bag__item-add-on');
	                        var productAddOnRemoveWrap = productAddOnList.querySelector('.navigation-mini-bag__remove-confirmation-add-on');
	                        var productTitleAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-title-add-on');
	                        var productImageAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-img-add-on');
	                        var productImageLinkAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-img-wrap-add-on');
	                        var productDetailWrapAddon = productAddOnWrap.querySelector('.navigation-hdr-mini-bag__item-detail-add-on');
	                        var productInfoAddon = productDetailWrapAddon.removeChild(productDetailWrapAddon.querySelector('.navigation-hdr-mini-bag__item-info-add-on'));
	                        var productPriceInfoAddon = productDetailWrapAddon.removeChild(productDetailWrapAddon.querySelector('.navigation-hdr-mini-bag__item-price-add-on'));
	                        var productRemoveItemAddon = productDetailWrapAddon.removeChild(productDetailWrapAddon.querySelector('.navigation-hdr-mini-bag__remove-add-on'));
	                        var productAddonRemoveTitle = productAddOnRemoveWrap.querySelector('.navigation-mini-bag__item-title__remove-add-on');
	
	                        var dom = parser.parseFromString(child.productTitle, 'text/html');
	                        var domAltText = parser.parseFromString(child.productImgeAltText, 'text/html');
	
	                        productTitleAddon.innerText = dom.body.textContent;
	                        productTitleAddon.setAttribute('title', dom.body.textContent);
	                        productImageAddon.setAttribute('src', child.productImgUrl);
	                        productImageAddon.setAttribute('alt', child.productImgeAltText);
	                        productImageLinkAddon.setAttribute('title', domAltText.body.textContent);
	                        productAddonRemoveTitle.innerText = dom.body.textContent;
	                        productAddonRemoveTitle.setAttribute('title', dom.body.textContent);
	                        if (!child.productAttributes) {
	                            child.productAttributes = [];
	                        }
	                        child.productAttributes.push({
	                            productAttrName: 'Qty',
	                            productAttrValue: child.quantity
	                        });
	
	                        if (child.quantity || child.quantity !== '') {
	                            var productPriceDetailsAddon = productPriceInfoAddon.cloneNode(true);
	                            var totalItemPriceAddon = child.itemPrice * child.quantity;
	                            var totalItemPriceRoundOffAddon = totalItemPriceAddon.toFixed(2);
	                            if (child.wasPrice) {
	                                var totalWasPriceAddon = child.wasPrice * child.quantity;
	                                var totalwasPriceRoundOffAddon = totalWasPriceAddon.toFixed(2);
	                            }
	                            if (product.productType === 'Furniture' && child.wasPrice) {
	                                productPriceDetailsAddon.innerText = child.currency + totalItemPriceRoundOffAddon;
	                                productDetailWrapAddon.setAttribute('aria-label', productTitleAddon.innerText);
	                                addOnPriceInfoForAria = child.currency + totalItemPriceRoundOffAddon;
	                            } else if (child.wasPrice) {
	                                productPriceDetailsAddon.innerHTML = '<span class="navigation-minibasket__currentprice">' + child.currency + totalItemPriceRoundOffAddon + '</span><span class="navigation-minibasket__wasprice">' + child.currency + totalwasPriceRoundOffAddon + '</span>';
	                                productDetailWrapAddon.setAttribute('aria-label', productTitleAddon.innerText);
	                                addOnPriceInfoForAria = child.currency + totalItemPriceRoundOffAddon;
	                            } else {
	                                productPriceDetailsAddon.innerText = child.currency + totalItemPriceRoundOffAddon;
	                                productDetailWrapAddon.setAttribute('aria-label', productTitleAddon.innerText);
	                                addOnPriceInfoForAria = child.currency + totalItemPriceRoundOffAddon;
	                            }
	                            productDetailWrapAddon.appendChild(productPriceDetailsAddon);
	                            child.productAttributes.map(function (detail, i) {
	                                var productDetailAddon = productInfoAddon.cloneNode(true);
	                                productDetailAddon.children[0].innerText = detail.productAttrName;
	                                productDetailAddon.children[1].innerText = detail.productAttrValue;
	                                getArialabelForAddOnProduct(productDetailAddon.children[0].innerText, productDetailAddon.children[1].innerText, i, child.productAttributes.length, productDetailWrapAddon);
	
	                                productDetailWrapAddon.appendChild(productDetailAddon);
	                            });
	                            var productRemoveButtonAddon = productRemoveItemAddon.cloneNode(true);
	                            productDetailWrapAddon.appendChild(productRemoveButtonAddon);
	                            var productRemoveClickAddon = productRemoveButtonAddon.querySelector('.navigation-hdr-mini-bag__remove-item-add-on');
	                            productRemoveClickAddon.setAttribute('id', child.orderItemId);
	                            productRemoveClickAddon.setAttribute('aria-label', 'Remove ' + productTitleAddon.innerText + ' button');
	                            productRemoveClickAddon.setAttribute('data-productStroke', child.productStroke);
	                            productRemoveClickAddon.setAttribute('data-productUpc', child.productUPC);
	                            productRemoveClickAddon.setAttribute('data-productId', child.productId);
	                            productRemoveClickAddon.setAttribute('data-cost', addOnPriceInfoForAria);
	                            productRemoveClickAddon.setAttribute('data-quantity', child.quantity);
	                            if (product.productType === 'Furniture') {
	                                productRemoveClickAddon.setAttribute('style', 'display:none');
	                            }
	                        }
	                        productAddOnWrap.setAttribute('id', product.orderItemId);
	                        productAddOnList.appendChild(productAddOnRemoveWrap);
	                        productAddOnList.appendChild(productAddOnWrap);
	                        productAddOns.appendChild(productAddOnList);
	                    }
	                });
	            }
	            return el;
	        },
	
	        /**
	         * Returns basket size.
	         * @param {string} Cookie string
	         * @returns {string} Basket size value
	         */
	        getBasketSize: function getBasketSize() {
	            return cookieService.getBasketSizeCookieValue() || '0';
	        },
	
	        /**
	         * Returns template string for mini bag contents
	         * @returns {string} mini bag template
	         */
	        getMiniBagTemplate: function getMiniBagTemplate() {
	            var template = document.createElement('div');
	            template.innerHTML = document.getElementById('hdr-miniBagTemplate').innerHTML;
	            return template.children[0];
	        }
	    };
	
	    return MiniBagOverlay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (domQ) {
	    return {
	        init: function init() {
	            this.hamburgerMenu = document.querySelector('.navigation-res-nav-header__item--menu .navigation-hamburger-trigger');
	            this.searchIcon = document.querySelector('.navigation-btn__icon--search-container');
	            this.bodyEl = document.querySelector('body');
	            this.tempAcc = document.querySelector('.navigation-stick-temp-hold');
	            this.logo = document.querySelector('.navigation-mns-logo');
	            this.signInIcon = document.querySelector('.navigation-res-nav-header__login-link');
	            this.accountIcon = document.querySelector('.navigation-res-nav-header__icon--my-account');
	            this.bagIcon = document.querySelector('.navigation-res-nav-header__item--bag .navigation-header__link');
	            this.listCheveronIcons = document.querySelectorAll('.navigation-l1-chervonicon');
	            this.navItems = document.querySelectorAll('.nav-primary__menu-link');
	            this.minibagChevron = document.querySelector('.navigation-chevronicon__minibag');
	            this.acctChevron = document.querySelector('.navigation-accessibility__chevron-account');
	            this.countrylink = document.querySelector('.navigation-res-nav-header__icon--country');
	            this.helpLink = document.querySelector('.navigation-help a');
	            this.locationLink = document.querySelector('.navigation-res-nav-header__icon--location');
	            this.skipContent = document.querySelector('.navigation-skip-content button');
	            this.menulogo = document.querySelector('.navigation-burger__fixedtopmenu .navigation-mns-logo');
	            this.closeSearchButton = document.querySelector('.navigation-search-bar--clear');
	            this.insideLogo = document.querySelector('.navigation-burger__fixedtopmenu a');
	            this.closeMenuButton = document.querySelector('.navigation-burger__fixedtopmenu .navigation-burger-close');
	            this.tempStickySearch = document.querySelector('.navigation-temp-search-acc');
	            this.countryOverlay = document.querySelector('.navigation-mobile-country-header');
	            this.headerEl = document.getElementById('common-hdr-main');
	            this.tempL2Holder = document.querySelector('.navigation-temp-accessibility');
	            this.countryItems = document.querySelectorAll('.navigation-nav-country-selector select, .navigation-nav-country-selector a');
	            this.backClick = document.querySelector('.navigation-submenu__back-bar-link');
	            this.countryFocus = document.querySelector('.navigation-country-mobile--link');
	            this.submenuContainer = document.querySelector('.navigation-primary__submenu-container');
	            this.navContainer = document.querySelector('.navigation-primary__section');
	            this.signInCheveron = document.querySelector('.navigation-accessibility__chevron');
	            this.toggleCountryOverlay = this.toggleCountryOverlay.bind(this);
	            this.searchOverlay = this.searchOverlay.bind(this);
	            this.focusSearchOverlay = this.focusSearchOverlay.bind(this);
	            this.hamburgerMenuOpen = this.hamburgerMenuOpen.bind(this);
	            this.hamburgerMenuClose = this.hamburgerMenuClose.bind(this);
	            this.skiptoPage = this.skiptoPage.bind(this);
	            this.openl23 = this.openl23.bind(this);
	            this.closel23 = this.closel23.bind(this);
	            this.jumptoTopL23 = this.jumptoTopL23.bind(this);
	            this.backClickKeyup = this.backClickKeyup.bind(this);
	            this.escapeToClose = this.escapeToClose.bind(this);
	            this.bagIconFocus = this.bagIconFocus.bind(this);
	            this.bindAnchor = this.bindAnchor.bind(this);
	        },
	        bindAccessibility: function bindAccessibility(activeElement) {
	            this.init();
	            this.activeElement = activeElement;
	            if (activeElement === this.bodyEl || this.headerEl.contains(activeElement)) {
	                this.tempAcc.focus();
	            }
	            this.searchIcon.addEventListener('click', this.searchOverlay);
	            this.backClick.addEventListener('keyup', this.backClickKeyup);
	            this.closeSearchButton.addEventListener('keyup', this.focusSearchOverlay);
	            this.tempStickySearch.addEventListener('keyup', this.focusSearchOverlay);
	            this.hamburgerMenu.addEventListener('keyup', this.hamburgerMenuOpen);
	            this.closeMenuButton.addEventListener('keyup', this.hamburgerMenuClose);
	            this.minibagChevron.addEventListener('keyup', this.skiptoPage);
	            this.tempL2Holder.addEventListener('keyup', this.jumptoTopL23);
	            this.countryFocus.addEventListener('keyup', this.closel23);
	            this.headerEl.addEventListener('keyup', this.escapeToClose);
	            this.bagIcon.addEventListener('keyup', this.bagIconFocus);
	        },
	        unbindAccessibility: function unbindAccessibility() {
	            this.init();
	            this.backClick.removeAttribute('tabIndex');
	            this.tempL2Holder.removeAttribute('style');
	            this.minibagChevron.removeAttribute('style');
	            this.searchIcon.removeEventListener('click', this.searchOverlay);
	            this.closeSearchButton.removeEventListener('keyup', this.focusSearchOverlay);
	            this.tempStickySearch.removeEventListener('keyup', this.focusSearchOverlay);
	            this.hamburgerMenu.removeEventListener('keyup', this.hamburgerMenuOpen);
	            this.closeMenuButton.removeEventListener('keyup', this.hamburgerMenuClose);
	            this.minibagChevron.removeEventListener('keyup', this.skiptoPage);
	            this.tempL2Holder.removeEventListener('keyup', this.jumptoTopL23);
	            this.backClick.removeEventListener('keyup', this.backClickKeyup);
	            this.countryFocus.removeEventListener('keyup', this.closel23);
	            this.headerEl.removeEventListener('keyup', this.escapeToClose);
	            this.bagIcon.removeEventListener('keyup', this.bagIconFocus);
	        },
	        bagIconFocus: function bagIconFocus() {
	            this.minibagChevron.style.display = 'block';
	        },
	        toggleCountryOverlay: function toggleCountryOverlay(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 13 || keyPressed === 'Enter') {
	                this.countryOverlay.click();
	            }
	        },
	        searchOverlay: function searchOverlay(event) {
	            event.preventDefault();
	            document.querySelector('.navigation-btn__icon--search').click();
	        },
	        focusSearchOverlay: function focusSearchOverlay(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (event.target === this.closeSearchButton && (keyPressed === 13 || keyPressed === 'Enter')) {
	                this.searchIcon.focus();
	            } else if (event.target !== this.closeSearchButton) {
	                this.closeSearchButton.click();
	                this.searchIcon.focus();
	            }
	        },
	        hamburgerMenuOpen: function hamburgerMenuOpen(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 13 || keyPressed === 'Enter') {
	                if (domQ(this.submenuContainer).hasClass('navigation-is-active')) {
	                    document.querySelector('.navigation-submenu__back-bar-label a').focus();
	                } else {
	                    this.insideLogo.focus();
	                }
	                this.tempAcc.addEventListener('keyup', this.hamburgerMenuClose);
	                this.countryOverlay.addEventListener('keyup', this.toggleCountryOverlay);
	                for (var navI = 0; navI < this.navItems.length; navI++) {
	                    this.navItems[navI].addEventListener('keyup', this.openl23);
	                }
	            }
	        },
	        hamburgerMenuClose: function hamburgerMenuClose(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (event.target === this.tempAcc) {
	                this.closeMenuButton.click();
	                this.hamburgerMenu.focus();
	            }
	            if ((keyPressed === 13 || keyPressed === 'Enter') && event.target === this.closeMenuButton || event.target === this.tempAcc) {
	                this.insideLogo.removeAttribute('tabIndex');
	                this.closeMenuButton.removeAttribute('tabIndex');
	                this.countryOverlay.removeAttribute('tabIndex');
	                this.countryOverlay.removeAttribute('keyup', this.toggleCountryOverlay);
	                this.tempAcc.removeEventListener('keyup', this.hamburgerMenuClose);
	                for (var navI = 0; navI < this.navItems.length; navI++) {
	                    this.navItems[navI].removeEventListener('keyup', this.openl23);
	                }
	                this.hamburgerMenu.focus();
	            }
	        },
	
	        skiptoPage: function skiptoPage() {
	            var pageContent = this.headerEl.nextElementSibling;
	            if (pageContent && domQ(this.headerEl).hasClass('navigation-sticky')) {
	                var initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	                while (pageContent && pageContent !== null && !initialContentLink) {
	                    pageContent = pageContent.nextElementSibling;
	                    if (pageContent) {
	                        initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	                    }
	                }
	                if (initialContentLink) {
	                    window.navSkiptoPage = true;
	                    var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	                    if (userAgent.indexOf('MSIE') !== -1 || window.navigator.appVersion.indexOf('Trident/') > 0) {
	                        var evt = document.createEvent('UIEvents');
	                        evt.initUIEvent('scroll', true, false, window, 0);
	                        window.dispatchEvent(evt);
	                    } else {
	                        window.dispatchEvent(new Event('scroll')); // eslint-disable-line no-undef
	                    }
	                    initialContentLink.focus();
	                }
	            }
	        },
	
	        openl23: function openl23(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 13 || keyPressed === 'Enter') {
	                document.querySelector('.navigation-submenu__back-bar-label a').focus();
	                window.stickyActiveL1 = event.target;
	            }
	        },
	        closel23: function closel23(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (event.target === this.countryFocus && domQ(this.submenuContainer).hasClass('navigation-is-active')) {
	                this.backClick.click();
	                window.stickyActiveL1.focus();
	            } else if (event.target === this.countryFocus && (keyPressed === 13 || keyPressed === 'Enter') && this.countryFocus.href === 'javascript:;') {
	                this.insideLogo.removeAttribute('tabIndex');
	                this.closeMenuButton.removeAttribute('tabIndex');
	                this.countryOverlay.removeAttribute('tabIndex');
	                this.countryOverlay.removeAttribute('keyup', this.toggleCountryOverlay);
	                this.tempAcc.removeEventListener('keyup', this.hamburgerMenuClose);
	                for (var navI = 0; navI < this.navItems.length; navI++) {
	                    this.navItems[navI].removeEventListener('keyup', this.openl23);
	                }
	                this.hamburgerMenu.focus();
	            }
	        },
	        jumptoTopL23: function jumptoTopL23() {
	            this.backClick.focus();
	        },
	        backClickKeyup: function backClickKeyup(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 13 || keyPressed === 'Enter') {
	                this.backClick.click();
	                window.stickyActiveL1.focus();
	            }
	        },
	        escapeToClose: function escapeToClose(event) {
	            var keyPressed = event.key || event.keyCode;
	            if ((keyPressed === 27 || keyPressed === 'Escape') && domQ(this.submenuContainer).hasClass('navigation-is-active')) {
	                this.backClick.click();
	                window.stickyActiveL1.focus();
	            } else if ((keyPressed === 27 || keyPressed === 'Escape') && domQ(this.navContainer).hasClass('navigation-is-active')) {
	                this.insideLogo.removeAttribute('tabIndex');
	                this.closeMenuButton.removeAttribute('tabIndex');
	                this.countryOverlay.removeAttribute('tabIndex');
	                this.countryOverlay.removeAttribute('keyup', this.toggleCountryOverlay);
	                this.tempAcc.removeEventListener('keyup', this.hamburgerMenuClose);
	                for (var navI = 0; navI < this.navItems.length; navI++) {
	                    this.navItems[navI].removeEventListener('keyup', this.openl23);
	                }
	                this.closeMenuButton.click();
	                this.hamburgerMenu.focus();
	            }
	        },
	        bindAnchor: function bindAnchor() {
	            this.tempAcc.addEventListener('keyup', this.hamburgerMenuClose);
	            this.countryOverlay.addEventListener('keyup', this.toggleCountryOverlay);
	            for (var navI = 0; navI < this.navItems.length; navI++) {
	                this.navItems[navI].addEventListener('keyup', this.openl23);
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (cookieService) {
	
	    function Authentication() {}
	
	    Authentication.prototype = {
	        isAuthenticated: function isAuthenticated() {
	            return this.getCookieValue() !== null;
	        },
	
	        getCookieValue: function getCookieValue() {
	            var cookieValue = cookieService.getUserLoginCookieValue();
	
	            if (cookieValue) {
	                cookieValue = decodeURIComponent(cookieValue);
	            }
	
	            return cookieValue;
	        }
	    };
	
	    return Authentication;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util, config, CountryLinks) {
	    return {
	        init: function init() {
	            this.geooverlay = document.querySelector('.navigation-geooverlay');
	            this.countryNameFlag = document.querySelector('.navigation-geooverlaycountryname');
	            this.countryLink = document.querySelector('.navigation-geooverlay a');
	            this.closeBtn = document.querySelector('.navigation-navgeooverlayclose');
	            this.miniBagOverlay = document.querySelector('.navigation-minibag-dock-overlay');
	            this.headerVersion = document.querySelector('#nav-primary__header-version').innerText;
	            this.hostC = config.storeId === '10151' ? 'UK' : 'IE';
	            this.buildOverlay = this.buildOverlay.bind(this);
	            this.closeGeo = this.closeGeo.bind(this);
	            this.trackClick = this.trackClick.bind(this);
	            this.checkGeoLocation = this.checkGeoLocation.bind(this);
	            this.checkGeoLocation();
	        },
	        checkGeoLocation: function checkGeoLocation() {
	            var originCountryX = document.cookie.match('MS_ORIGIN_COUNTRY') ? document.cookie.match('MS_ORIGIN_COUNTRY').input : false;
	            var originCountryY = originCountryX ? originCountryX.indexOf('MS_ORIGIN_COUNTRY=') : -1;
	            this.originCountry = originCountryY !== -1 ? originCountryX[originCountryY + 18] + originCountryX[originCountryY + 19] : false;
	            if (this.originCountry && config.storeId === '10151' && this.originCountry !== 'GB' || config.storeId === '10451' && this.originCountry !== 'IE') {
	                if (window && window.localStorage && (window.localStorage.navoriginCountry !== this.originCountry || window.localStorage.navOriginHeaderVersion !== this.headerVersion)) {
	                    CountryLinks.loadCountryData(this.buildOverlay);
	                    window.localStorage.navOriginCountryName = '';
	                    window.localStorage.navOriginCountryUrl = '';
	                    window.localStorage.navOriginHeaderVersion = '';
	                } else if (window && window.localStorage && window.localStorage.navOriginCountryName && window.localStorage.navOriginCountryUrl) {
	                    this.countryNameFlag.innerHTML = '<i id="navigation-flags-overlay-geo" class="navigation-flags-overlay navigation-flags-overlay--' + this.originCountry + '" style="background-image: url(' + window.localStorage.navoriginCountryFlag + ');"></i>' + window.localStorage.navOriginCountryName + '?';
	                    var cLink = window.localStorage.navOriginCountryUrl + '?extid=' + this.hostC.toLowerCase() + '_header_country-redirect_' + this.originCountry.toLowerCase() + '_countrybanner';
	                    this.countryLink.href = cLink;
	                    util.removeClass(this.geooverlay, 'navigation-geooverlay--hidden');
	                    util.addClass(this.miniBagOverlay, 'navgeominibag');
	                    window.HIDE_MS_COMMON_HDR_STICKY = true;
	                    this.closeBtn.addEventListener('click', this.closeGeo);
	                    this.countryLink.addEventListener('click', this.trackClick);
	                } else {
	                    CountryLinks.loadCountryData(this.buildOverlay);
	                }
	
	                /*eslint-disable*/
	                var utag_link_data = {
	                    link_name: 'country selector banner:open',
	                    product_lightbox: 'country selector banner',
	                    country_selected: this.hostC.toLowerCase(),
	                    language_selected: 'english',
	                    event_name: 'generic_lightbox_open'
	                };
	                if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
	                    utag.link(utag_link_data);
	                }
	                /*eslint-enable*/
	            }
	        },
	        buildOverlay: function buildOverlay(data) {
	            var countryData = data.countryLinks;
	            if (countryData) {
	                for (var countryI = 0; countryI < countryData.length; countryI++) {
	                    if (this.originCountry === countryData[countryI].name) {
	                        this.countryNameFlag.innerHTML = '<i id="navigation-flags-overlay-geo" class="navigation-flags-overlay navigation-flags-overlay--' + this.originCountry + '" style="background-image: url(' + data.countryFlagLink + ');"></i>' + data.countryLinks[countryI].imgPath + '?';
	                        var cLink = countryData[countryI].url + '?extid=' + this.hostC.toLowerCase() + '_header_country-redirect_' + this.originCountry.toLowerCase() + '_countrybanner';
	                        this.countryLink.href = cLink;
	                        window.localStorage.navoriginCountry = this.originCountry;
	                        window.localStorage.navOriginCountryName = data.countryLinks[countryI].imgPath;
	                        window.localStorage.navOriginCountryUrl = data.countryLinks[countryI].url;
	                        window.localStorage.navoriginCountryFlag = data.countryFlagLink;
	                        window.localStorage.navOriginHeaderVersion = this.headerVersion;
	                        util.removeClass(this.geooverlay, 'navigation-geooverlay--hidden');
	                        util.addClass(this.miniBagOverlay, 'navgeominibag');
	                        window.HIDE_MS_COMMON_HDR_STICKY = true;
	                        this.closeBtn.addEventListener('click', this.closeGeo);
	                        this.countryLink.addEventListener('click', this.trackClick);
	                    }
	                }
	            }
	        },
	        closeGeo: function closeGeo() {
	            util.addClass(this.geooverlay, 'navigation-geooverlay--hidden');
	            util.removeClass(this.miniBagOverlay, 'navgeominibag');
	            var session = 'MS_PREFERRED_COUNTRY';
	            window.sessionStorage[session] = config.storeId === '10151' ? 'GB' : 'IE';
	            window.HIDE_MS_COMMON_HDR_STICKY = false;
	            /*eslint-disable*/
	            if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
	                utag.link({ link_name: 'header:country redirect banner:close', generic_lightbox: 'header:country redirect:' + this.originCountry.toLowerCase(), event_name: 'generic_lightbox_close' });
	            }
	            /*eslint-enable*/
	        },
	        trackClick: function trackClick(evt) {
	            evt.preventDefault();
	            /*eslint-disable*/
	            if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
	                utag.link({ link_name: 'header:country redirect banner:submit', generic_lightbox: 'header:country redirect:' + this.originCountry.toLowerCase(), event_name: 'generic_lightbox_close' });
	            }
	            /*eslint-enable*/
	            setTimeout(function () {
	                window.location = document.querySelector('.navigation-geooverlay a').href;
	            }, 100);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(3), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (breakpoint, utils, Constant) {
	    var STRIPELENGTHTWO = 2,
	        HOLD_TIME = 12,
	        TRANSITION_TIME = 1.3,
	        LOGIN = 'Login',
	        BASKET = 'Basket',
	        AGEVERIFY = 'AgeVerify',
	        PREV = 'prev',
	        NEXT = 'next';
	
	    return {
	        initHdrSiteStripeCarousel: function initHdrSiteStripeCarousel(storeId) {
	            var stripe = document.querySelectorAll('.navigation-sitestripe'),
	                headerEl = document.querySelector('.navigation-common-hdr-main');
	            if (stripe.length === STRIPELENGTHTWO) {
	                headerEl.removeChild(stripe[1]);
	            }
	            this.HOLD_TIME = document.getElementById('holdTime').value ? document.getElementById('holdTime').value : HOLD_TIME;
	            this.TRANSITION_TIME = document.getElementById('transSpeed').value ? document.getElementById('transSpeed').value : TRANSITION_TIME;
	
	            var loop = this.loop.bind(this),
	                identifyAnalyticsPageType = this.identifyAnalyticsPageType.bind(this),
	                breakpointSize = breakpoint.size(),
	                pageFeature = document.getElementById('featureData') ? document.getElementById('featureData').innerText : false,
	                userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera,
	                pageURL = window.location.href;
	
	            this.stripeBar = document.querySelector('.navigation-sitestripe');
	            this.pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : false;
	            this.slider = document.querySelector('.navigation-sitestripe__slider');
	            this.slides = document.querySelectorAll('.navigation-sitestripe__slide');
	            this.nextBtn = document.querySelector('.navigation-sitestripe__btn--next');
	            this.previousBtn = document.querySelector('.navigation-sitestripe__btn--previous');
	            this.defaultMsg = document.getElementById('defaultHdrStripeMsg');
	            this.slideCount = this.slides.length;
	            this.storeId = storeId;
	            window.runhdrpromo = true;
	            /*eslint func-style: ["error", "expression"]*/
	
	            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	                if (!breakpointSize || breakpointSize === '') {
	                    breakpointSize = 'xsmall';
	                }
	            }
	
	            this.pageType = pageURL.indexOf('MSResLogin') !== -1 ? LOGIN : this.pageType;
	            this.pageType = pageURL.indexOf('OrderCalculate') !== -1 ? BASKET : this.pageType;
	            this.pageType = pageURL.indexOf('MSAgeCaptureCmd') !== -1 ? AGEVERIFY : this.pageType;
	
	            pageFeature = pageFeature && this.pageType ? JSON.parse('{' + pageFeature + '"default":{}}') : false;
	            var siteStripeKey = pageFeature && pageFeature[this.pageType] ? pageFeature[this.pageType].mobileSiteStripe : true;
	
	            if (this.slideCount === 2) {
	                this.slider.innerHTML += this.slider.innerHTML;
	                this.slideCount = 4;
	                this.slides = document.querySelectorAll('.navigation-sitestripe__slide');
	            }
	            for (var i = 0; i < this.slideCount; i++) {
	                this.slides[i].style.transitionDuration = this.TRANSITION_TIME + 's';
	                this.slides[i].firstElementChild.rankID = i + 1;
	                if (this.slides[i].firstElementChild.href.indexOf('#intid') === -1) {
	                    this.slides[i].firstElementChild.addEventListener('click', identifyAnalyticsPageType);
	                }
	            }
	            if (this.defaultMsg && this.storeId === Constant.ieId) {
	                this.slides[0].firstElementChild.href = '/ie/c/offers';
	            }
	            if (breakpointSize !== 'xsmall') {
	                document.querySelector('.navigation-sitestripe').style.display = 'block';
	            }
	            window.siteStripeKey = siteStripeKey;
	            if (breakpointSize === 'xsmall' && !siteStripeKey) {
	                utils.addClass(document.querySelector('.navigation-sitestripe'), 'navigation-no-stripe');
	            }
	            if (breakpointSize === 'xsmall' && siteStripeKey || breakpointSize !== 'xsmall') {
	                utils.addClass(this.slides[0], 'navigation-sitestripe__active');
	                utils.removeClass(this.slider, 'navigation-sitestripe__loadslide');
	                utils.addClass(document.querySelector('.navigation-nav-veil'), 'navigation-hdrstripe-adjust');
	                this.slider.style.display = 'block';
	                if (this.slideCount === 1) {
	                    this.nextBtn.style.display = 'none';
	                    this.previousBtn.style.display = 'none';
	                    this.nextBtn.setAttribute('aria-hidden', true);
	                    this.previousBtn.setAttribute('aria-hidden', true);
	                    window.NavSingleInfinityLoop = true;
	                    setTimeout(function () {
	                        if (window.NavSingleInfinityLoop) {
	                            var scrollW = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
	                            var offsetW = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active');
	                            if (offsetW.offsetWidth < scrollW.scrollWidth) {
	                                var navigationSitestripeStyle = document.createElement('style');
	                                navigationSitestripeStyle.appendChild(document.createTextNode('@keyframes navigation-sitestripe_marquee {\
	                            0% { transform: translateX(' + offsetW.offsetWidth + 'px); }\
	                            100% { transform: translateX(-100%); }\
	                        }'));
	                                document.head.appendChild(navigationSitestripeStyle);
	                                offsetW.classList.add('navigation-sitestripe__animation');
	                            }
	                        }
	                    }, 300);
	                    var visibleMsg = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
	                    visibleMsg.tabIndex = '0';
	                    this.slider.style.overflow = 'visible';
	                    this.slides[0].style.overflow = 'visible';
	                    visibleMsg.style.width = 'fit-content';
	                    if (this.slides[0].offsetWidth < visibleMsg.scrollWidth) {
	                        var navigationSitestripeStyle = document.createElement('style');
	                        navigationSitestripeStyle.appendChild(document.createTextNode('@keyframes navigation-sitestripe_marquee {\
	                            0% { transform: translateX(' + this.slides[0].offsetWidth + 'px); }\
	                            100% { transform: translateX(-100%); }\
	                        }'));
	                        document.head.appendChild(navigationSitestripeStyle);
	                        this.slides[0].classList.add('navigation-sitestripe__animation');
	                        window.NavSingleInfinityLoop = false;
	                    } else {
	                        visibleMsg.style.width = '100%';
	                        this.slides[0].style.overflow = 'hidden';
	                        this.slider.style.overflow = 'hidden';
	                    }
	                } else if (this.slideCount >= 3) {
	                    var timeInterval = this.HOLD_TIME * 1000;
	                    this.slider.insertBefore(this.slides[this.slides.length - 1], this.slides[0]);
	                    var aLinks = document.querySelectorAll('.navigation-sitestripe__slide a');
	                    var visibleLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
	                    visibleLink.tabIndex = '0';
	                    if (visibleLink.offsetWidth < visibleLink.scrollWidth) {
	                        var scrollTime = parseInt(this.HOLD_TIME),
	                            scrollDistance = -visibleLink.offsetWidth - visibleLink.scrollWidth,
	                            transSpeed = parseInt(this.TRANSITION_TIME) + 1;
	                        visibleLink.firstElementChild.style.transition = 'all ' + scrollTime + 's ease-in-out ' + transSpeed + 's';
	                        visibleLink.firstElementChild.style.transform = 'translateX(' + scrollDistance + 'px)';
	                    }
	
	                    var Timer = this.Timer.bind(this);
	                    var timer = new Timer(function () {
	                        loop('auto');
	                    }, timeInterval);
	
	                    this.swipeDetect(this.stripeBar, function (swipeDirection) {
	                        if (swipeDirection === 'left') {
	                            timer.pause();
	                            loop(NEXT);
	                            timer.resume();
	                        }
	                        if (swipeDirection === 'right') {
	                            timer.pause();
	                            loop(PREV);
	                            timer.resume();
	                        }
	                    });
	
	                    this.nextBtn.addEventListener('click', function () {
	                        loop(PREV);
	                    });
	
	                    this.previousBtn.addEventListener('click', function () {
	                        loop(NEXT);
	                    });
	                    for (var ialinks = 0; ialinks < aLinks.length; ialinks++) {
	                        aLinks[ialinks].addEventListener('blur', timer.resume);
	                        aLinks[ialinks].addEventListener('focus', timer.pause);
	                    }
	
	                    this.slider.addEventListener('mouseover', timer.pause);
	
	                    this.slider.addEventListener('mouseout', timer.resume);
	
	                    this.nextBtn.addEventListener('mouseover', timer.pause);
	
	                    this.nextBtn.addEventListener('mouseout', timer.resume);
	
	                    this.previousBtn.addEventListener('mouseover', timer.pause);
	
	                    this.previousBtn.addEventListener('mouseout', timer.resume);
	                }
	            }
	        },
	
	        loop: function loop(direction) {
	            var slides = document.querySelectorAll('.navigation-sitestripe__slide'),
	                holdTime = document.getElementById('holdTime').value ? document.getElementById('holdTime').value : HOLD_TIME,
	                transSpeed = document.getElementById('transSpeed').value ? document.getElementById('transSpeed').value : TRANSITION_TIME,
	                clickSpeed = document.getElementById('clickSpeed').value ? document.getElementById('clickSpeed').value : TRANSITION_TIME,
	                activeSlide = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active');
	            if (direction === NEXT || direction === PREV) {
	                transSpeed = clickSpeed;
	            }
	            activeSlide.previousElementSibling.style.transitionDuration = transSpeed + 's';
	            activeSlide.style.transitionDuration = transSpeed + 's';
	            activeSlide.nextElementSibling.style.transitionDuration = transSpeed + 's';
	            if (direction === NEXT || direction === 'auto') {
	                slides[0].style.transitionDuration = 0 + 's';
	                activeSlide.firstElementChild.tabIndex = '-1';
	                this.slider.appendChild(slides[0]);
	                activeSlide.classList.remove('navigation-sitestripe__active');
	                activeSlide.nextElementSibling.classList.add('navigation-sitestripe__active');
	                activeSlide.nextElementSibling.firstElementChild.tabIndex = '0';
	            } else if (direction === PREV) {
	                slides[slides.length - 1].style.transitionDuration = 0 + 's';
	                activeSlide.firstElementChild.tabIndex = '-1';
	                this.slider.insertBefore(slides[slides.length - 1], slides[0]);
	                activeSlide.classList.remove('navigation-sitestripe__active');
	                activeSlide.previousElementSibling.classList.add('navigation-sitestripe__active');
	                activeSlide.previousElementSibling.firstElementChild.tabIndex = '0';
	            }
	            var activeLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
	            activeLink.firstElementChild.removeAttribute('style');
	            if (activeLink.offsetWidth < activeLink.scrollWidth && window.runhdrpromo) {
	                var scrollTime = parseInt(holdTime),
	                    scrollDistance = -activeLink.offsetWidth - activeLink.scrollWidth;
	                transSpeed = parseInt(transSpeed) + 1;
	                activeLink.firstElementChild.style.transition = 'all ' + scrollTime + 's ease-in-out ' + transSpeed + 's';
	                activeLink.firstElementChild.style.transform = 'translateX(' + scrollDistance + 'px)';
	            }
	        },
	
	        identifyAnalyticsPageType: function identifyAnalyticsPageType() {
	            var pageURL = window.location.href,
	                analyticsPageType = 'other';
	            if (pageURL.indexOf('MSResLogin') !== -1) {
	                analyticsPageType = 'login';
	            } else if (pageURL.indexOf('MSSinglePageCheckoutCmd') !== -1) {
	                analyticsPageType = 'spc';
	            } else if (pageURL.indexOf('MSResUserRegistration') !== -1) {
	                analyticsPageType = 'reg';
	            } else if (pageURL.indexOf('MSPaymentDisplayCmd') !== -1) {
	                analyticsPageType = 'pay';
	            } else if (pageURL.indexOf('MSOrderReviewDisplayCmd') !== -1) {
	                analyticsPageType = 'ordreview';
	            } else if (pageURL.indexOf('MSResOrderConfirmationCmd') !== -1) {
	                analyticsPageType = 'ordconf';
	            } else if (pageURL.indexOf('MSContactAddressDisplayCmd') !== -1 || pageURL.indexOf('MSAgeCaptureCmd') !== -1) {
	                analyticsPageType = 'chkout';
	            } else if (this.pageType === 'DLPFESK' || this.pageType === 'DLP_NONFEAR') {
	                analyticsPageType = 'dlp';
	            } else if (this.pageType) {
	                analyticsPageType = this.pageType.toLowerCase();
	            }
	
	            var aTag = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
	            var locSplit = aTag.dataset.href.split('?'),
	                message = aTag.innerText.replace(/ /g, '-'),
	                locSearch = [],
	                newSearch = [];
	            message = message.replace(/[^a-zA-Z0-9- ]/g, '');
	
	            if (locSplit.length > 1) {
	                locSearch = locSplit[1];
	                if (locSearch.indexOf('intid=') > -1) {
	                    // remove existing intid
	                    var params = locSearch.split('&');
	                    for (var ind = 0; ind < params.length; ind++) {
	                        if (params[ind].indexOf('intid=') === -1) {
	                            newSearch.push(params[ind]);
	                        }
	                    }
	                    locSearch = newSearch.join('&'); // rebuild query params without intid
	                }
	                aTag.href = locSplit[0] + '?' + locSearch + '#intid=' + analyticsPageType + '_stripe_' + aTag.rankID + '_' + message.substring(0, 20);
	            } else if (locSplit.length === 1) {
	                if (locSplit[0].indexOf('#intid') > -1) {
	                    locSplit[0] = locSplit[0].split('#intid')[0];
	                }
	                aTag.href = locSplit[0] + '#intid=' + analyticsPageType + '_stripe_' + aTag.rankID + '_' + message.substring(0, 20);
	            }
	            return true;
	        },
	
	        swipeDetect: function swipeDetect(el, callback) {
	            var touchsurface = el,
	                swipeDirection,
	                startX,
	                startY,
	                distX,
	                distY,
	                threshold = 50,
	                //required min distance traveled to be considered swipe
	            restraint = 50,
	                // maximum distance allowed at the same time in perpendicular direction
	            allowedTime = 300,
	                // maximum time allowed to travel that distance
	            elapsedTime,
	                startTime,
	                handleSwipe = callback;
	
	            touchsurface.addEventListener('touchstart', function (e) {
	                var touchobj = e.changedTouches[0];
	                swipeDirection = 'none';
	                startX = touchobj.pageX;
	                startY = touchobj.pageY;
	                startTime = new Date().getTime(); // record time when finger first makes contact with surface
	            }, false);
	
	            touchsurface.addEventListener('touchmove', function (e) {
	                e.preventDefault();
	            }, false);
	
	            touchsurface.addEventListener('touchend', function (e) {
	                var touchobj = e.changedTouches[0];
	                distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
	                distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
	                elapsedTime = new Date().getTime() - startTime; // get time elapsed
	                if (elapsedTime <= allowedTime) {
	                    // first condition for awipe met
	                    if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
	                        // 2nd condition for horizontal swipe met
	                        swipeDirection = distX < 0 ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
	                    } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
	                        // 2nd condition for vertical swipe met
	                        swipeDirection = distY < 0 ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
	                    }
	                }
	                handleSwipe(swipeDirection);
	            }, false);
	        },
	
	        Timer: function Timer(callback, delay) {
	            var timerId, visibleLink;
	
	            this.pause = function () {
	                window.clearInterval(timerId);
	                window.runhdrpromo = false;
	                visibleLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
	                visibleLink.firstElementChild.removeAttribute('style');
	            };
	
	            this.resume = function () {
	                var holdTime = document.getElementById('holdTime').value ? document.getElementById('holdTime').value : HOLD_TIME;
	                var transitionSpeed = document.getElementById('transSpeed').value ? document.getElementById('transSpeed').value : TRANSITION_TIME;
	                visibleLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
	                if (visibleLink.offsetWidth < visibleLink.scrollWidth) {
	                    var scrollTime = parseInt(holdTime),
	                        scrollDistance = -visibleLink.offsetWidth - visibleLink.scrollWidth,
	                        transSpeed = parseInt(transitionSpeed) + 1;
	                    visibleLink.firstElementChild.style.transition = 'all ' + scrollTime + 's ease-in-out ' + transSpeed + 's';
	                    visibleLink.firstElementChild.style.transform = 'translateX(' + scrollDistance + 'px)';
	                }
	                window.runhdrpromo = true;
	                window.clearInterval(timerId);
	                timerId = window.setInterval(callback, delay);
	            };
	
	            this.resume();
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(1), __webpack_require__(18), __webpack_require__(3), __webpack_require__(10), __webpack_require__(11), __webpack_require__(5), __webpack_require__(22), __webpack_require__(4), __webpack_require__(17), __webpack_require__(15), __webpack_require__(12), __webpack_require__(20), __webpack_require__(14), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_RESULT__ = function (config, domQ, Search, util, DropdownMenu, MiniBagOverlay, Breakpoint, HeaderLinks, mnsCookieService, MyBag, HdrSiteStripe, stickyHeader, cookieBanner, GeoOverlay, sparksDashboard) {
	
	    function Header() {
	
	        var requestParams = {
	            storeId: config.storeId,
	            langId: config.langId,
	            catalogId: config.catalogId
	        };
	        var CLEAR = 'Clear';
	        // toggle header links
	        new HeaderLinks(document.querySelector('#progressiveHeaderSection')).show();
	        var geoSession = 'MS_PREFERRED_COUNTRY';
	        if (window && window.sessionStorage && !window.sessionStorage[geoSession]) {
	            GeoOverlay.init();
	        }
	        // bag
	        new MyBag({
	            myBagCount: document.querySelector('.navigation-nav-header__bag-count'),
	            myBagElement: document.getElementsByClassName('navigation-res-nav-header__item--bag')[0],
	            checkoutElement: document.getElementsByClassName('navigation-res-nav-header__item--checkout')[0],
	            myBagIconElement: document.querySelector('.navigation-res-nav-header__item--bag .navigation-primary__menu-icon')
	        });
	
	        var basketHolder = '';
	        if (document.querySelector('.navigation-res-icon--empty-my-bag')) {
	            basketHolder = window.getComputedStyle(document.querySelector('.navigation-res-icon--empty-my-bag'), ':before');
	        }
	        if (document.querySelector('.navigation-res-icon--fill-my-bag')) {
	            basketHolder = window.getComputedStyle(document.querySelector('.navigation-res-icon--fill-my-bag'), ':before');
	        }
	        if (basketHolder && basketHolder.backgroundImage) {
	            basketHolder = basketHolder.backgroundImage;
	            var basketImgLen = basketHolder.length - 2;
	            var tempBasketImg = document.createElement('img');
	            tempBasketImg.src = basketHolder.substring(5, basketImgLen);
	            tempBasketImg.addEventListener('load', loadBagCount);
	            window.setTimeout(loadBagCount, 8000);
	        }
	        function loadBagCount() {
	            document.querySelector('.navigation-nav-header__bag-count').style.display = 'block';
	        }
	        //Cookie Banner
	        if (!document.cookie.match('CONSENTMGR') && !window.MS_ROI_COOKIE_BANNER_ENABLE) {
	            cookieBanner.bind();
	        }
	        document.addEventListener('touchend', touchHandlerForDropdown, true);
	
	        /* my account bindings */
	        var myAccountSparkLink = document.querySelector('.navigation-res-nav-header__item.navigation-myaccount  #myAccountSparkLink');
	        var signInSparkLink = document.querySelector('.navigation-header__sparks-link-signin');
	        var sparksUserLink = 'data-sparks-login-link';
	        if (mnsCookieService.isUserLoggedIn() && mnsCookieService.isUserSparksMember()) {
	            sparksUserLink = 'data-sparks-hub-link';
	        }
	
	        if (myAccountSparkLink) {
	            if (myAccountSparkLink.getAttribute(sparksUserLink).indexOf('intid') !== -1) {
	                var sparksUrl = myAccountSparkLink.getAttribute(sparksUserLink).replace(/(intid=).*?(#|$)/, '$1' + 'header_account_sparks');
	                myAccountSparkLink.setAttribute(sparksUserLink, sparksUrl);
	                myAccountSparkLink.setAttribute('href', myAccountSparkLink.getAttribute(sparksUserLink));
	            } else {
	                var sparksurl = myAccountSparkLink.getAttribute(sparksUserLink);
	                var newSparksurl = sparksurl + '#intid=header_account_sparks';
	                myAccountSparkLink.setAttribute(sparksUserLink, newSparksurl);
	                myAccountSparkLink.setAttribute('href', myAccountSparkLink.getAttribute(sparksUserLink));
	            }
	        }
	
	        if (signInSparkLink) {
	            if (signInSparkLink.getAttribute(sparksUserLink).indexOf('intid') !== -1) {
	                var sparksUrl1 = signInSparkLink.getAttribute(sparksUserLink).replace(/(intid=).*?(#|$)/, '$1' + 'header_sign-in_sparks');
	                signInSparkLink.setAttribute(sparksUserLink, sparksUrl1);
	                signInSparkLink.setAttribute('href', signInSparkLink.getAttribute(sparksUserLink));
	            } else {
	                var sparksurl1 = signInSparkLink.getAttribute(sparksUserLink);
	                var newSparksurl1 = sparksurl1 + '#intid=header_sign-in_sparks';
	                signInSparkLink.setAttribute(sparksUserLink, newSparksurl1);
	                signInSparkLink.setAttribute('href', signInSparkLink.getAttribute(sparksUserLink));
	            }
	        }
	        // SparksPay Binding
	        var getsparkspayIcon = document.querySelector('.navigation-icon--accountsparkspay');
	        var getSparksPayStatus = mnsCookieService.getUserSparkspayStatus();
	        var sparksPayLinkHref = document.querySelector('.navigation-res-nav-header__item.navigation-myaccount  #myAccountSparkPayLink');
	        if (sparksPayLinkHref) {
	            var sparksPayAccountLink = sparksPayLinkHref.getAttribute('data-sparks-accountservice-link');
	            var sparksPayLandingpageLink = sparksPayLinkHref.getAttribute('data-sparks-landingpage-link');
	        }
	        if (mnsCookieService.isUserLoggedIn() && getSparksPayStatus === 'COMPLETED') {
	            if (sparksPayLinkHref) {
	                sparksPayLinkHref.href = sparksPayAccountLink;
	            }
	        } else if (mnsCookieService.isUserLoggedIn() && (getSparksPayStatus !== 'COMPLETED' || getSparksPayStatus === null)) {
	            if (sparksPayLinkHref) {
	                sparksPayLinkHref.href = sparksPayLandingpageLink;
	            }
	        }
	        if (mnsCookieService.isUserLoggedIn() && getSparksPayStatus !== null && getsparkspayIcon) {
	            domQ(getsparkspayIcon).addClass('navigation-sparkspaygreendot');
	        }
	        // add toggle behavior to all #menuBarTop dropdowns (remove 'find a store' explicitly, 'search' & 'save for later' not included)
	        var dropdownMenu = new DropdownMenu(document.getElementById('menuBarTop'), {
	            menuItem: '.navigation-dropdown:not(.navigation-res-nav-header__item--location)',
	            menuItemLink: '.navigation-dropdown__menuitem-link',
	            menuDropdown: '.navigation-dropdown__panel-wrapper',
	            namespace: 'HEADER_DROPDOWN_MENU'
	        });
	
	        // Search typeahead
	        var searchContainer = document.querySelector('.navigation-res-nav-header__dropdown--search'),
	            searchCommand = searchContainer.querySelector('#searchSuggestionCmd').value,
	            navVeil = document.querySelector('.navigation-veil-search'),
	            searchContainerParentOverlay = document.querySelector('.navigation-search-overlay'),
	            searchButton = document.querySelector('.navigation-btn__icon--search-container');
	
	        var search = new Search({
	            'searchContainer': searchContainer,
	            'command': config.wcsBaseUrl + searchCommand,
	            'navVeil': navVeil,
	            'searchContainerParentOverlay': searchContainerParentOverlay,
	            'searchButton': searchButton
	        });
	        search.init(requestParams.storeId);
	
	        // add toggle behavior to 'search' & 'save for later' dropdowns for xsmall/small viewports
	        this.searchIconDisplay = document.querySelector('.navigation-dropdown__panel--search');
	        this.headerSection = document.getElementById('progressiveHeaderSection');
	        if (Breakpoint.size() === 'xsmall') {
	            //dropdown__panel-wrapper
	            if (this.searchIconDisplay) {
	                domQ(this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
	                domQ(this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
	                dropdownMenu.addMenuItemLink(document.querySelector('.res-nav-header__fav-icon.navigation-dropdown__menuitem-link'), document.querySelector('.navigation-res-nav-header__item--fav .navigation-dropdown__panel-wrapper'));
	            }
	            if (window.mobileSearchKey) {
	                // collapsed search view
	                domQ(this.headerSection).addClass('navigation-header-height');
	            } else {
	                // exposed search view
	                domQ(this.headerSection).removeClass('navigation-header-height');
	            }
	        } else if (Breakpoint.size() === 'small') {
	            if (this.searchIconDisplay) {
	                domQ(this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
	                domQ(this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
	            }
	        }
	        // add toggle behavior to 'find a store' dropdown for other than xsmall viewport
	        var findStoreItem = document.querySelector('.navigation-res-nav-header__item--location'),
	            findStoreIcon = findStoreItem ? findStoreItem.querySelector('.navigation-res-nav-header__icon--location') : null;
	        // Adding store location url parameters
	        if (findStoreIcon) {
	            findStoreIcon.href += '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId;
	        }
	
	        // add url params to 'find store' button in gnav for xsmall viewport
	        var findStoreItemBottom = document.querySelector('.navigation-bottom--find-store'),
	            findStoreIconBottom = findStoreItemBottom ? findStoreItemBottom.querySelector('.nav-primary__menu-link--find-store') : null;
	        // Adding store location url parameters
	        if (findStoreIconBottom) {
	            findStoreIconBottom.href += '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId;
	        }
	        setTimeout(function () {
	            if (window.mnsHeaderConfig && window.mnsHeaderConfig.adobeTargetTest) {
	                config = window.mnsHeaderConfig;
	            }
	            // initialize mini bag overlay for iPad/large viewport
	            if (Breakpoint.size() === 'small') {
	                MiniBagOverlay.initialize(document.querySelectorAll('#miniBagOverlayHeader'), {
	                    miniBagCMD: config.wcsBaseUrl + config.CMD.miniBasket + '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId
	                });
	            }
	            if (Breakpoint.size() === 'medium' || Breakpoint.size() === 'large') {
	                MiniBagOverlay.initialize(document.querySelectorAll('#miniBagOverlayHeader'), {
	                    miniBagCMD: config.wcsBaseUrl + config.CMD.miniBasket + '?langId=' + requestParams.langId + '&storeId=' + requestParams.storeId + '&catalogId=' + requestParams.catalogId
	                });
	                this.inputField = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search-wrap input');
	                this.inputField.addEventListener('keydown', function (evt) {
	                    var inputsearchIconblack = document.querySelector('.navigation-btn__blackicon--search');
	                    var recentClearTextelement = document.querySelector('.navigation-suggestion-item--clear-text');
	                    var overlaycrossIcon = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear');
	                    this.SuggessionListItem = document.querySelectorAll('.navigation-search-item--list a');
	                    this.lastSuggessionListItem = this.SuggessionListItem[this.SuggessionListItem.length - 1];
	                    overlaycrossIcon.tabIndex = '-1';
	                    var keyPressed = evt.key || evt.keyCode;
	                    if (keyPressed === 'Tab' || keyPressed === 9) {
	                        if (document.querySelector('.navigation-recentsearch--list li')) {
	                            recentClearTextelement.addEventListener('keydown', function (evt) {
	                                var overlayInputField = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search-wrap input');
	                                var keyPressed = evt.key || evt.keyCode;
	                                if (keyPressed === 'Tab' || keyPressed === 9) {
	                                    if (overlayInputField.value === '') {
	                                        overlayInputField.focus();
	                                        evt.preventDefault();
	                                    } else {
	                                        inputsearchIconblack.focus();
	                                        overlaycrossIcon.tabIndex = '0';
	                                        evt.preventDefault();
	                                    }
	                                }
	                            });
	                        } else if (!recentClearTextelement && this.lastSuggessionListItem) {
	                            this.lastSuggessionListItem.addEventListener('keydown', function (evt) {
	                                var keyPressed = evt.key || evt.keyCode;
	                                if (keyPressed === 'Tab' || keyPressed === 9) {
	                                    inputsearchIconblack.focus();
	                                    overlaycrossIcon.tabIndex = '0';
	                                    evt.preventDefault();
	                                }
	                            });
	                        } else if (!recentClearTextelement && !this.lastSuggessionListItem) {
	                            overlaycrossIcon.tabIndex = '0';
	                            overlaycrossIcon.addEventListener('keydown', function (evt) {
	                                var keyPressed = evt.key || evt.keyCode;
	                                if (keyPressed === 'Tab' || keyPressed === 9) {
	                                    search.resetSearchText();
	                                    search.formParams.q = '';
	                                    search.resetSuggestions(evt);
	                                    search.closeSuggestions();
	                                    search.hidePopup();
	                                    var dummySearchPanel = document.querySelector('.navigation-dropdown__panel--search');
	                                    dummySearchPanel.focus();
	                                    evt.preventDefault();
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	        }, 1000);
	
	        if (document.getElementById('sparksDropdown')) {
	            //toggle link for sparks in sign-in drop-down- mobile
	            var elMobile = document.querySelector('.navigation-header__sparks-link-signin-mobile');
	            if (elMobile) {
	                var url = mnsCookieService.isUserSparksMember() ? elMobile.getAttribute('data-sparks-hub-link') : elMobile.getAttribute('data-sparks-login-link');
	                elMobile.setAttribute('data-href', url);
	            }
	        }
	
	        // set tabindex for visually hidden elements
	        var notVisibleToAllBreakpoints = '.navigation-dropdown__panel-wrapper button[type=reset], .navigation-suggestion-item--recent';
	        var selectorsToRemoveMdToLrgBreakpoint = '.navigation-res-nav-header__icon--fav, .navigation-btn__icon--search-container';
	        var selectorsToRemoveSmallBreakpoints = '.navigation-dropdown__panel-wrapper input[type=search]';
	        var extraSelectors = Breakpoint.size() === 'medium' || Breakpoint.size() === 'large' ? selectorsToRemoveMdToLrgBreakpoint : selectorsToRemoveSmallBreakpoints;
	        var selectorsToRemove = document.querySelectorAll(notVisibleToAllBreakpoints + extraSelectors);
	        var navList = document.querySelector('.navigation-primary__section');
	        var navL23 = document.getElementById('navContainer');
	        util.setTabIndex(selectorsToRemove, -1);
	
	        HdrSiteStripe.initHdrSiteStripeCarousel(requestParams.storeId);
	        var _this = this;
	        // when tablet orientation changes
	        window.addEventListener('resize', onResizeEvent);
	
	        function onResizeEvent() {
	            var promoSlides = document.querySelectorAll('.navigation-sitestripe__slide');
	            var isIEorEdge = util.checkIeVersion();
	            var ipadMenu = document.querySelector('.navigation-hamburger-trigger');
	
	            for (var index = 0; index < promoSlides.length; index++) {
	                promoSlides[index].removeAttribute('style');
	                if (!isIEorEdge) {
	                    promoSlides[index].firstElementChild.removeAttribute('style');
	                }
	            }
	            // bind the 'search' dropdown
	            if (Breakpoint.size() === 'xsmall') {
	                var searchInput = document.querySelector('.navigation-search-overlay .navigation-res-nav-header__dropdown--search .navigation-search-bar--search');
	                searchInput.autofocus = true;
	                navList.style.transition = 'none';
	                _this.searchIconDisplay = document.querySelector('.navigation-dropdown__panel--search');
	                _this.searchButton = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--submit');
	                _this.headerSection = document.getElementById('progressiveHeaderSection');
	                document.querySelector('.navigation-btn__icon--search').innerText = '';
	                document.querySelector('.navigation-header__title-text__desktop').innerText = '';
	                if (_this.searchIconDisplay) {
	                    domQ(_this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
	                    domQ(_this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
	                }
	                if (!window.siteStripeKey) {
	                    document.querySelector('.navigation-sitestripe').style.display = 'none';
	                }
	                var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	                var dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                if (/iPad/.test(userAgent) && (window.innerWidth === 768 || window.innerWidth === 767)) {
	                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
	                    document.querySelector('.navigation-btn__icon--search').style.display = 'none';
	                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
	                    domQ(_this.headerSection).hasClass('navigation-header-height') ? domQ(_this.headerSection).removeClass('navigation-header-height') : '';
	                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    domQ(dummySearchBar).addClass('navigation-search-bar--search-wrap__full-width');
	                } else if (window.mobileSearchKey) {
	                    //collapsed on resize
	                    document.querySelector('.navigation-res-nav-header__search').style.display = 'none';
	                    document.querySelector('.navigation-dropdown__panel--search').style.display = 'none';
	                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'block';
	                    document.querySelector('.navigation-btn__icon--search').style.display = 'block';
	                    domQ(_this.headerSection).addClass('navigation-header-height');
	                } else {
	                    //exposed on resize
	                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
	                    document.querySelector('.navigation-dropdown__panel--search').style.display = 'block';
	                    document.querySelector('.navigation-btn__icon--search').style.display = 'none';
	                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
	                    domQ(_this.headerSection).hasClass('navigation-header-height') ? domQ(_this.headerSection).removeClass('navigation-header-height') : '';
	                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    domQ(dummySearchBar).addClass('navigation-search-bar--search-wrap__full-width');
	                }
	                if (window.innerWidth !== 767 || window.innerWidth !== 768) {
	                    _this.mnslogo = document.querySelector('.navigation-logo');
	                    domQ(_this.mnslogo).hasClass('navigation-logo-ipad-portrait') ? domQ(_this.mnslogo).removeClass('navigation-logo-ipad-portrait') : '';
	                    _this.ipadinput = document.querySelector('.navigation-dropdown__panel--search');
	                    if (_this.ipadinput) {
	                        domQ(_this.ipadinput).hasClass('navigation-search-bar-ipad-portrait') ? domQ(_this.ipadinput).removeClass('navigation-search-bar-ipad-portrait') : '';
	                    }
	                    _this.Ipadresize = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    if (_this.Ipadresize) {
	                        domQ(_this.Ipadresize).hasClass('navigation-search-warp-ipad-portrait') ? domQ(_this.Ipadresize).removeClass('navigation-search-warp-ipad-portrait') : '';
	                    }
	                    ipadMenu = document.querySelector('.navigation-hamburger-trigger');
	                    if (ipadMenu) {
	                        domQ(ipadMenu).hasClass('navigation-hamburger-ipad-portrait') ? domQ(ipadMenu).removeClass(ipadMenu, 'navigation-hamburger-ipad-portrait') : '';
	                    }
	                    if (_this.headerSection) {
	                        domQ(_this.headerSection).hasClass('navigation-header-ipad-height') ? domQ(_this.headerSection).removeClass('navigation-header-ipad-height') : '';
	                    }
	                }
	                var l1menuContainer = document.querySelector('.navigation-primary__section');
	                var innerHeight = window.innerHeight;
	                var aHeight = innerHeight - 61;
	                l1menuContainer.style.height = aHeight + 'px';
	                var bottompadding = document.querySelector('.navigation-primary__section');
	                bottompadding.style.paddingBottom = '0';
	            } else {
	                var body = document.querySelector('body');
	                var elementClearIndesktop = document.querySelector('.navigation-hdr-search-bar--clear');
	                body.addEventListener('click', activeElementListener);
	                navList.removeAttribute('style');
	                navL23.removeAttribute('style');
	                document.querySelector('.navigation-btn__icon--search-container').removeAttribute('style');
	                document.querySelector('.navigation-dropdown__panel--search').removeAttribute('style');
	                _this.searchIconDisplay = document.querySelector('.navigation-dropdown__panel-wrapper__new');
	                document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
	                document.querySelector('.navigation-header__title-text__desktop').innerText = '';
	                document.querySelector('.navigation-btn__icon--search').style.display = 'block';
	                domQ(_this.headerSection).hasClass('navigation-header-height') ? domQ(_this.headerSection).removeClass('navigation-header-height') : '';
	                if (_this.searchIconDisplay) {
	                    domQ(_this.searchIconDisplay).removeClass('navigation-dropdown__panel-wrapper__new', 'navigation-dropdown__panel--search');
	                    domQ(_this.searchIconDisplay).addClass('navigation-dropdown__panel-wrapper', 'navigation-dropdown__panel--search');
	                }
	                if (elementClearIndesktop.hasAttribute('style')) {
	                    elementClearIndesktop.removeAttribute('style');
	                }
	            }
	
	            if (document.querySelector('.navigation-sitestripe').classList.contains('navigation-no-stripe')) {
	                HdrSiteStripe.initHdrSiteStripeCarousel(requestParams.storeId);
	            } else if (Breakpoint.size() !== 'xsmall') {
	                document.querySelector('.navigation-sitestripe').style.display = 'block';
	            }
	            // Ipad portrait to land scape responsive code
	            if (Breakpoint.size() !== 'xsmall') {
	                _this.dockSearchPopup = document.querySelector('.navigation-dock-search-popup');
	                _this.searchBarSuggestion = document.querySelector('.navigation-search-bar--suggestion-dropdown');
	                _this.searchsuggestionList = document.querySelector('.navigation-search-item--list li');
	                _this.searchbardropdownDiv = document.querySelector('.navigation-search-bar--dropdowndiv');
	                _this.searchSuggestionTitle = document.querySelector('.navigation-suggestion-item--title');
	                _this.clearRecentSearchText = document.querySelector('.navigation-suggestion-item--clear-text');
	                _this.suggestionItemClear = document.querySelector('.navigation-suggestion-item--title .navigation-suggestion-item--clear');
	                _this.searchClearRecent = document.querySelector('.navigation-recentsearch--list .navigation-suggestion-item--recent');
	                if (_this.dockSearchPopup) {
	                    domQ(_this.dockSearchPopup).hasClass('navigation-hdr-sticky-class') ? domQ(_this.dockSearchPopup).removeClass('navigation-hdr-sticky-class') : '';
	                    if (_this.searchBarSuggestion) {
	                        document.querySelector('.navigation-search-bar--suggestion-dropdown').removeEventListener('touchstart', search.stickySearch);
	                    }
	                }
	                if (_this.searchBarSuggestion) {
	                    domQ(_this.searchBarSuggestion).hasClass('navigation-suggestion-list-padding') ? domQ(_this.searchBarSuggestion).removeClass('navigation-suggestion-list-padding') : '';
	                }
	                if (_this.SearchsuggestionList) {
	                    domQ(_this.searchbardropdownDiv).hasClass('navigation-scroll-height') ? domQ(_this.searchbardropdownDiv).removeClass('navigation-scroll-height') : '';
	                }
	                if (_this.suggestionItemClear) {
	                    _this.suggestionItemClear.innerText = '';
	                    domQ(_this.suggestionItemClear).hasClass('navigation-suggestion-item--clear') ? domQ(_this.suggestionItemClear).removeClass('navigation-suggestion-item--clear') : '';
	                }
	                if (_this.clearRecentSearchText && _this.searchClearRecent) {
	                    _this.clearRecentSearchText.innerText = 'Clear';
	                }
	                if (_this.searchSuggestionTitle && !_this.clearRecentSearchText) {
	                    _this.clearElement = document.createElement('div');
	                    _this.recentElement = document.querySelector('.navigation-suggestion-item--title');
	                    _this.recentSearchList = document.querySelector('.navigation-recentsearch--list');
	                    _this.clearElementdevice = document.createElement('span');
	                    _this.clearElementdevice.tabIndex = '-1';
	                    _this.clearElementdevice.setAttribute('aria-label', 'Clear');
	                    _this.clearElementdevice.innerHTML = 'Clear';
	                    domQ(_this.clearElementdevice).addClass('navigation-suggestion-item--clear-text');
	                    domQ(_this.clearElement).addClass('suggestion-item');
	                    domQ(_this.clearElement).addClass('navigation-suggestion-item--clear');
	                    _this.clearElement.appendChild(_this.clearElementdevice);
	                    if (_this.recentSearchList) {
	                        _this.recentSearchList.appendChild(_this.clearElement);
	                    }
	                    _this.clearElementdevice.addEventListener('click', clearElmntDevice);
	                }
	
	                //Ipad 767 view portrait to landscape
	                if (window.innerWidth !== 767 || window.innerWidth !== 768) {
	                    _this.mnslogo = document.querySelector('.navigation-logo');
	                    domQ(_this.mnslogo).hasClass('navigation-logo-ipad-portrait') ? domQ(_this.mnslogo).removeClass('navigation-logo-ipad-portrait') : '';
	                    _this.ipadinput = document.querySelector('.navigation-dropdown__panel--search');
	                    if (_this.ipadinput) {
	                        domQ(_this.ipadinput).hasClass('navigation-search-bar-ipad-portrait') ? domQ(_this.ipadinput).removeClass('navigation-search-bar-ipad-portrait') : '';
	                    }
	                    _this.Ipadresize = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    if (_this.Ipadresize) {
	                        domQ(_this.Ipadresize).hasClass('navigation-search-warp-ipad-portrait') ? domQ(_this.Ipadresize).removeClass('navigation-search-warp-ipad-portrait') : '';
	                    }
	                    ipadMenu = document.querySelector('.navigation-hamburger-trigger');
	                    if (ipadMenu) {
	                        domQ(ipadMenu).hasClass('navigation-hamburger-ipad-portrait') ? domQ(ipadMenu).removeClass(ipadMenu, 'navigation-hamburger-ipad-portrait') : '';
	                    }
	                    if (_this.headerSection) {
	                        domQ(_this.headerSection).hasClass('navigation-header-ipad-height') ? domQ(_this.headerSection).removeClass('navigation-header-ipad-height') : '';
	                    }
	                }
	            } else {
	                _this.searchBarSuggestion = document.querySelector('.navigation-search-bar--suggestion-dropdown');
	                _this.searchCleartext = document.querySelector('.navigation-suggestion-item--title .suggestion-item');
	                if (_this.searchBarSuggestion) {
	                    document.querySelector('.navigation-search-bar--suggestion-dropdown').addEventListener('touchstart', search.stickySearch);
	                }
	                if (!_this.searchCleartext) {
	                    _this.clearElementdevice = document.createElement('span');
	                    _this.clearElementdevice.innerHTML = 'Clear';
	                    domQ(_this.clearElementdevice).addClass('suggestion-item');
	                    domQ(_this.clearElementdevice).addClass('navigation-suggestion-item--clear');
	                    if (document.querySelector('.navigation-suggestion-item--title')) {
	                        document.querySelector('.navigation-suggestion-item--title').appendChild(_this.clearElementdevice);
	                    }
	                    _this.clearElementdevice.addEventListener('click', function () {
	                        _this.localStorage = window.localStorage;
	                        search.clearRecentSearches();
	                    });
	                }
	                if (_this.searchCleartext) {
	                    _this.searchCleartext.innerText = 'Clear';
	                    domQ(_this.searchCleartext).addClass('navigation-suggestion-item--clear');
	                }
	                if (_this.clearRecentSearchText) {
	                    _this.clearRecentSearchText.innerText = '';
	                }
	                //IPAD 767 landscape to portrait
	                if (/iPad/.test(userAgent) && (window.innerWidth === 768 || window.innerWidth === 767)) {
	                    _this.mnslogo = document.querySelector('.navigation-logo');
	                    _this.ipadinput = document.querySelector('.navigation-dropdown__panel--search');
	                    _this.Ipadresize = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    domQ(_this.mnslogo).addClass('navigation-logo-ipad-portrait');
	                    domQ(_this.ipadinput).addClass('navigation-search-bar-ipad-portrait');
	                    domQ(_this.Ipadresize).addClass('navigation-search-warp-ipad-portrait');
	                    domQ(_this.headerSection).addClass('navigation-header-ipad-height');
	                }
	            }
	            var recentSearchLength = document.querySelectorAll('.suggestion-item.navigation-suggestion-item--recent').length;
	            var clearElement = document.querySelector('.navigation-suggestion-item--clear');
	            var clearTextElement = document.querySelector('.navigation-suggestion-item--clear-text');
	
	            // search overlay design for desktop breakpoint
	            if (Breakpoint.size() === 'medium' || Breakpoint.size() === 'large') {
	                if (clearTextElement) {
	                    clearTextElement.innerHTML = CLEAR;
	                }
	                if (recentSearchLength === 1) {
	                    clearElement.style.top = '-7.8rem';
	                } else if (recentSearchLength === 2) {
	                    clearElement.style.top = '-11.5rem';
	                } else if (recentSearchLength === 2) {
	                    clearElement.style.top = '-15.2rem';
	                }
	
	                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
	                    suggestionListArray = document.querySelectorAll('.navigation-search-item--list li.suggestion-item'),
	                    suggestionList = document.querySelector('.navigation-search-item--list');
	                if (suggestionListArray.length !== 0) {
	                    if (recentElement) {
	                        domQ(suggestionList).addClass('navigation-recent-serach-underline');
	                    }
	                } else if (suggestionListArray.length === 0) {
	                    if (recentElement) {
	                        domQ(suggestionList).removeClass('navigation-recent-serach-underline');
	                    }
	                }
	                if (recentElement) {
	                    var recentSearchList = document.querySelector('.navigation-recentsearch--list');
	                    recentSearchList.style.maxHeight = '1000px';
	                    recentSearchList.style.opacity = 1;
	                    recentElement.style.maxHeight = '1000px';
	                    recentElement.style.opacity = 1;
	                }
	            } else if (Breakpoint.size() === 'small') {
	                if (recentSearchLength === 1) {
	                    clearElement.style.top = '-7.8rem';
	                } else if (recentSearchLength === 2) {
	                    clearElement.style.top = '-12.3rem';
	                } else if (recentSearchLength === 3) {
	                    clearElement.style.top = '-16.8rem';
	                }
	            }
	        }
	
	        function clearElmntDevice() {
	            _this.localStorage = window.localStorage;
	            search.clearRecentSearches();
	        }
	        // Ipad portrait to land scape responsive code --End here
	
	        function activeElementListener() {
	            window.activeElement = document.activeElement;
	        }
	
	        function touchHandlerForDropdown(e) {
	            if (e.target) {
	                if ((e.target.className !== 'navigation-res-nav-header__item navigation-res-nav-header__item--login' || e.target.className === '') && e.target.parentNode.className !== 'navigation-dropdown__list-container-signin') {
	                    domQ(document.querySelector('.navigation-signin-wrapper')).addClass('navigation-signin-wrapper-hidden');
	                }
	                if ((e.target.className !== 'navigation-res-nav-header__item navigation-res-nav-header__item--myaccount' || e.target.className === '') && e.target.parentNode.className !== 'navigation-dropdown__list-container-myaccount') {
	                    domQ(document.querySelector('.navigation-signacc-wrapper')).addClass('navigation-signacc-wrapper-hidden');
	                }
	                if (domQ(document.querySelector('.navigation-minibag-dock-overlay')).hasClass('navigation-dock-overlay--block') || e.target.parentNode.className !== 'navigation-dock-overlay__inner' || e.target.parentNode.className !== 'navigation-hdr-mini-bag__item-detail') {
	                    var hasBagOverlayParent = hasSomeParentTheClass(e.target.parentNode, 'navigation-dock-overlay__inner');
	                    if (!hasBagOverlayParent) {
	                        domQ(document.querySelector('.navigation-minibag-dock-overlay')).removeClass('navigation-dock-overlay--block');
	                        domQ(document.querySelector('.navigation-minibag-dock-overlay')).removeClass('navigation-dock-overlay--transition');
	                    }
	                }
	                var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	                if (/iPad/.test(userAgent)) {
	                    if ((e.target.className === 'navigation-primary__menu-icon navigation-icon--my-account' || e.target.className === 'navigation-res-nav-header__login-link') && (e.target.parentNode.className === 'navigation-res-nav-header__login-link' || e.target.parentNode.className === 'navigation-res-nav-header__item navigation-res-nav-header__item--login')) {
	                        domQ(document.querySelector('.navigation-signin-wrapper')).removeClass('navigation-signin-wrapper-hidden');
	                        domQ(document.querySelector('.navigation-header__signin')).addClass('navigation-header__sign-in');
	                    }
	                    if ((e.target.className === 'navigation-primary__menu-icon navigation-icon--account-active' || e.target.className === 'navigation-res-nav-header__icon--my-account') && (e.target.parentNode.className === 'navigation-res-nav-header__icon--my-account' || e.target.parentNode.className === 'navigation-res-nav-header__item navigation-res-nav-header__item--myaccount navigation-myaccount navigation-dropdown')) {
	                        domQ(document.querySelector('.navigation-signacc-wrapper')).removeClass('navigation-signacc-wrapper-hidden');
	                        domQ(document.querySelector('.navigation-header__sub-list-container--signacc')).addClass('navigation-header__sub-list-container--signacc-displayblock');
	                    }
	                }
	            }
	        }
	
	        // returns true if the element or one of it's parents has the given className
	        function hasSomeParentTheClass(element, classname) {
	            if (element && element.className && element.className.split(' ').indexOf(classname) >= 0) {
	                return true;
	            }
	            return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
	        }
	
	        // Skip to page content accessibility
	        //Accessibility for main page content
	
	        var headerEl = document.querySelector('#common-hdr-main');
	        var pageContent = headerEl ? headerEl.nextElementSibling : false;
	        var initialContentLink = '';
	        var navSkipLink = document.querySelector('.navigation-skip-content button');
	        if (pageContent) {
	            initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	            while (pageContent && pageContent !== null && !initialContentLink) {
	                pageContent = pageContent.nextElementSibling;
	                if (pageContent) {
	                    initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	                }
	            }
	            if (initialContentLink) {
	                navSkipLink.addEventListener('click', skipToMainEvnt);
	            }
	        }
	        function skipToMainEvnt() {
	            initialContentLink.focus();
	        }
	        //sticky header
	        window.addEventListener('scroll', navStickyScrollEvent);
	        window.addEventListener('resize', navStickyRemoveOnResize);
	        var lastScrollTop = 0;
	        var hamburgerMenu = document.querySelector('.navigation-primary__section');
	        var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	        var HeaderSticked = false;
	        var stickyHeaderDiv = document.querySelector('.navigation-tostick');
	        var stickyAddtoCartPDP = document.querySelector('.sticky-add-to-bag');
	
	        function navStickyRemoveOnResize() {
	            if (Breakpoint.size() !== 'xsmall' && HeaderSticked) {
	                headerEl.removeAttribute('style');
	                if (domQ(headerEl).hasClass('navigation-sticky')) {
	                    domQ(headerEl).removeClass('navigation-sticky-in');
	                    setTimeout(function () {
	                        domQ(headerEl).removeClass('navigation-sticky');
	                        headerEl.removeAttribute('style');
	                        stickyHeaderDiv.removeAttribute('style');
	                    }, 10);
	                }
	                if (stickyAddtoCartPDP && domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
	                    domQ(stickyAddtoCartPDP).removeClass('navigation-sticky-pdp-top');
	                }
	                stickyHeader.unbindAccessibility();
	                HeaderSticked = false;
	            }
	        }
	
	        function navStickyScrollEvent() {
	            if (/iPhone|iPod/.test(userAgent) && !window.MSStream) {
	                if (domQ(hamburgerMenu).hasClass('navigation-is-active')) {
	                    window.scrollTo(0, window.initialStickyScroll);
	                    return false;
	                }
	            }
	
	            if (window.HIDE_MS_COMMON_HDR_STICKY || userAgent.indexOf('MSIE') !== -1 || window.navigator.appVersion.indexOf('Trident/') > 0 || Breakpoint.size() !== 'xsmall') {
	                return false;
	            }
	
	            var pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : false;
	            var currentScrollTop = window.pageYOffset || document.documentElement.currentScrollTop;
	            var stickyFilterPLP = document.querySelector('.container--plp .sticky');
	            var srpSticky = document.querySelector('.search-result-content .sticky');
	            var findPages = document.querySelector('.filter-sticky-bar.filter-sticky-bar-sticky');
	
	            if (pageType === 'PLP' && stickyFilterPLP) {
	                stickyFilterPLP.style.transition = 'padding-top .5s ease';
	            }
	            if (pageType === 'SRP' && srpSticky) {
	                srpSticky.style.transition = 'padding-top .5s ease';
	            }
	            if (findPages) {
	                findPages.style.transition = 'padding-top .5s ease';
	            }
	
	            function addStickyToHeader() {
	                if (domQ(headerEl).hasClass('navigation-sticky-in') && !domQ(headerEl).hasClass('navigation-sticky')) {
	                    domQ(headerEl).removeClass('navigation-sticky-in');
	                    HeaderSticked = false;
	                    return false;
	                }
	                if (!HeaderSticked) {
	                    headerEl.style.height = headerEl.offsetHeight + 'px';
	                    domQ(headerEl).addClass('navigation-sticky');
	                    setTimeout(function () {
	                        domQ(headerEl).addClass('navigation-sticky-in');
	                    }, 10);
	                    if (stickyAddtoCartPDP && !domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
	                        domQ(stickyAddtoCartPDP).addClass('navigation-sticky-pdp-top');
	                    }
	                    stickyHeader.bindAccessibility(document.activeElement);
	                    setTimeout(function () {
	                        stickyHeaderDiv.style.transition = 'top .65s ease';
	                    }, 500);
	                    HeaderSticked = true;
	                }
	            }
	
	            function removeStickyHeader() {
	                if (HeaderSticked) {
	                    if (domQ(headerEl).hasClass('navigation-sticky')) {
	                        if (domQ(headerEl).hasClass('navigation-sticky-in')) {
	                            domQ(headerEl).removeClass('navigation-sticky-in');
	                        }
	                        setTimeout(function () {
	                            domQ(headerEl).removeClass('navigation-sticky');
	                            headerEl.removeAttribute('style');
	                            stickyHeaderDiv.removeAttribute('style');
	                        }, 500);
	                    }
	                    if (stickyAddtoCartPDP && domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
	                        domQ(stickyAddtoCartPDP).removeClass('navigation-sticky-pdp-top');
	                    }
	                    stickyHeader.unbindAccessibility();
	                    HeaderSticked = false;
	                }
	            }
	
	            function removeStickyHeaderWithoutDelay() {
	                if (HeaderSticked) {
	                    headerEl.removeAttribute('style');
	                    if (domQ(headerEl).hasClass('navigation-sticky')) {
	                        domQ(headerEl).removeClass('navigation-sticky-in');
	                        setTimeout(function () {
	                            domQ(headerEl).removeClass('navigation-sticky');
	                            headerEl.removeAttribute('style');
	                            stickyHeaderDiv.removeAttribute('style');
	                        }, 10);
	                    }
	                    if (stickyAddtoCartPDP && domQ(stickyAddtoCartPDP).hasClass('navigation-sticky-pdp-top')) {
	                        domQ(stickyAddtoCartPDP).removeClass('navigation-sticky-pdp-top');
	                    }
	                    stickyHeader.unbindAccessibility();
	                    HeaderSticked = false;
	                }
	            }
	
	            function stickyCondition() {
	                if (currentScrollTop > lastScrollTop) {
	                    removeStickyHeader();
	                    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
	                } else {
	                    if (lastScrollTop - currentScrollTop > 100) {
	                        addStickyToHeader();
	                        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
	                    }
	                }
	            }
	            if (window.navSkiptoPage === true) {
	                removeStickyHeaderWithoutDelay();
	                window.navSkiptoPage = false;
	            }
	            if (currentScrollTop > 600) {
	                if (headerEl && headerEl.style.display !== 'none') {
	                    stickyCondition();
	                }
	            }
	            if (currentScrollTop < 600) {
	                lastScrollTop = 0;
	                if (headerEl && headerEl.style.display !== 'none') {
	                    removeStickyHeaderWithoutDelay();
	                }
	            }
	            if (!currentScrollTop) {
	                removeStickyHeaderWithoutDelay();
	            }
	        }
	
	        /* providing display none to common header in mobile app web view pages */
	        var platformCookie = document.cookie.match('platform');
	        var commonHeaderSection = document.querySelector('.navigation-common-hdr-main');
	        if (platformCookie !== null && platformCookie.input && commonHeaderSection) {
	            platformCookie.input.indexOf('mobileapp') !== -1 ? commonHeaderSection.style.display = 'none' : false;
	        }
	
	        // AT dashboard welcom message
	        window.addEventListener('load', function () {
	            sparksDashboard.init();
	        });
	
	        var signinIconlabel = document.querySelector('.navigation-res-nav-header__item--login .navigation-icon--my-account');
	        var signinIconlabelText = document.querySelector('.navigation-signintext');
	        function triggeranimation(callback) {
	            if (signinIconlabel) {
	                var _this = callback;
	                setTimeout(function () {
	                    domQ(signinIconlabel).addClass('remove-login-icon');
	                    _this();
	                }, 3000);
	            }
	        }
	        function signanimate() {
	            if (signinIconlabelText) {
	                setTimeout(function () {
	                    domQ(signinIconlabelText).addClass('navigation-signintextanimate');
	                }, 500);
	            }
	        }
	
	        window.addEventListener('load', function () {
	            triggeranimation(signanimate);
	        });
	        if (window.innerWidth <= '768') {
	            var l1menuContainer = document.querySelector('.navigation-primary__section');
	            var innerHeight = window.innerHeight;
	            var aHeight = innerHeight - 61;
	            if (l1menuContainer) {
	                l1menuContainer.style.height = aHeight + 'px';
	            }
	            var bottompadding = document.querySelector('.navigation-primary__section');
	            if (bottompadding) {
	                bottompadding.style.paddingBottom = '0';
	            }
	        }
	    }
	
	    return Header;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(1), __webpack_require__(11), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (mnsCookieService, domQ, MiniBagOverlay, config) {
	
	    function MyBag(params) {
	        this.basketCount = mnsCookieService.getBasketSizeCookieValue();
	        this.miniBagOverlay = MiniBagOverlay;
	        this.updateCount(params);
	    }
	
	    MyBag.prototype = {
	
	        getByRegex: function getByRegex(key) {
	            var array = document.cookie.match(new RegExp(key + '=[^;]+', 'i'));
	            if (array && array.length === 1) {
	                return array[0].split('=')[1];
	            } else {
	                return 0;
	            }
	        },
	
	        updateCount: function updateCount(params) {
	            this.options = params;
	            var self = this;
	            // Update initial basket count
	            this.options.myBagCount.innerHTML = this.basketCount;
	            this.updateLayout();
	
	            window.addEventListener('updateItemCount', function (e) {
	                // Test For Minibag Sub Total
	                setTimeout(function () {
	                    if (window.mnsHeaderConfig && window.mnsHeaderConfig.adobeTargetTest) {
	                        config = window.mnsHeaderConfig;
	                    }
	                    self.updateBasket(e.myBagCount);
	                    self.miniBagOverlay.initialize(document.querySelectorAll('#miniBagOverlayHeader'), {
	                        miniBagCMD: config.wcsBaseUrl + config.CMD.miniBasket + '?langId=' + config.langId + '&storeId=' + config.storeId + '&catalogId=' + config.catalogId
	                    });
	                }, 1000);
	            });
	        },
	
	        updateLayout: function updateLayout() {
	            if (parseInt(this.basketCount) > 0) {
	                domQ(this.options.myBagElement).addClass('selected');
	                domQ(this.options.checkoutElement).removeClass('navigation-res-nav-header__item--hidden');
	                domQ(this.options.myBagIconElement).removeClass('navigation-res-icon--empty-my-bag');
	                domQ(this.options.myBagIconElement).addClass('navigation-res-icon--fill-my-bag');
	                domQ(this.options.myBagElement).removeClass('navigation-hdr-bag-unclick');
	                var minibagChevronElement = document.querySelector('.navigation-chevronicon__minibag');
	                if (minibagChevronElement && minibagChevronElement.classList.contains('navigation-minibag-empty')) {
	                    domQ(document.querySelector('.navigation-chevronicon__minibag')).removeClass('navigation-minibag-empty');
	                    domQ(document.querySelector('.navigation-chevronicon__minibag')).addClass('navigation-minibag-empty-display');
	                }
	            } else {
	                domQ(this.options.myBagElement).removeClass('selected');
	                domQ(this.options.checkoutElement).addClass('navigation-res-nav-header__item--hidden');
	                domQ(this.options.myBagIconElement).removeClass('navigation-res-icon--fill-my-bag');
	                domQ(this.options.myBagIconElement).addClass('navigation-res-icon--empty-my-bag');
	                domQ(this.options.myBagElement).addClass('navigation-hdr-bag-unclick');
	                if (document.querySelector('.navigation-chevronicon__minibag')) {
	                    domQ(document.querySelector('.navigation-chevronicon__minibag')).addClass('navigation-minibag-empty');
	                }
	            }
	        },
	
	        updateBasket: function updateBasket(myBagCount) {
	            this.options.myBagCount.innerHTML = myBagCount;
	            this.basketCount = myBagCount;
	            this.updateLayout();
	        }
	    };
	
	    return MyBag;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(3), __webpack_require__(4), __webpack_require__(5), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function (XhrPromise, utils, mnsCookieService, breakpoint, constant) {
	
	    /**
	     * creates a new Search component.
	     * @constructor
	     * @param {Object} params - searchContainer & searchCommand
	     */
	    var RECENT_SEARCHES = 'Your recent searches',
	        CLEAR = 'Clear',
	        CLR_RECENT_SEARCHES = 'Clear',
	        TAB_768 = 768,
	        TAB_767 = 767,
	        MAX_RECENT_SEARCH = 3;
	
	    function Search(params) {
	        this.options = params;
	    }
	
	    Search.prototype = {
	
	        /**
	         * initialize Search Component
	         */
	        init: function init(storeId) {
	            var pageFeature = document.getElementById('featureData') ? document.getElementById('featureData').innerText : false;
	            this.pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : false;
	            this.currentStoreId = storeId;
	            this.searchContainer = this.options.searchContainer;
	            this.searchOverlayBackground = this.options.navVeil;
	            this.command = this.options.command;
	            this.localStorage = this.options.localStorage || window.localStorage;
	            this.wrapperGenerated = false;
	            this.searchBar = this.searchContainer.querySelector('.navigation-search-bar--search');
	            this.searchContainerParentOverlay = this.options.searchContainerParentOverlay;
	            this.mobileSearchbarReset = this.searchContainerParentOverlay.querySelector('.navigation-dock-search-popup .navigation-search-bar--search');
	            this.searchBox = this.searchContainerParentOverlay.querySelector('.navigation-dock-search-popup');
	            this.resetPaddingTop = this.searchContainerParentOverlay.querySelector('.navigation-search-bar--suggestion-dropdown');
	            this.clearTextSearchOverlay = this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-hdr-search-bar--clear');
	            this.closeSearchOverlayButton = this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--clear');
	            this.overlaySearchInput = this.searchContainerParentOverlay.querySelector('#overlaysearch');
	            if (document.getElementById('navigation-dummySearch') && document.getElementById('navigation-dummySearch').hasAttribute('placeholder')) {
	                this.inputPlaceholder = document.getElementById('navigation-dummySearch').getAttribute('placeholder');
	            }
	            this.bodyEl = document.querySelector('body');
	            this.headerEl = document.querySelector('.navigation-common-hdr-main');
	            this.skipacc = document.querySelector('.navigation-temp-search-acc');
	            this.dummySearchPanel = document.querySelector('.navigation-dropdown__panel--search');
	            pageFeature = pageFeature && this.pageType ? JSON.parse('{' + pageFeature + '"default":{}}') : false;
	            var mobileSearchKey = pageFeature && pageFeature[this.pageType] ? pageFeature[this.pageType].mobileSearchExposed : false;
	            window.mobileSearchKey = mobileSearchKey;
	            this.topNavCheckBox = document.querySelectorAll('.navigation-dropdown__checkbox');
	            this.searchButton = this.options.searchButton;
	            this.stickySearch = this.stickySearch.bind(this);
	            this.submitButton = this.searchContainer.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--submit');
	            this.submitButton.disabled = true;
	
	            this.closeSuggestions = this.closeSuggestions.bind(this);
	            this.searchInputKeyUpHandler = this.searchInputKeyUpHandler.bind(this);
	            this.searchFormSubmitHandler = this.searchFormSubmitHandler.bind(this);
	            this.openSuggestions = this.openSuggestions.bind(this);
	            this.resetSuggestions = this.resetSuggestions.bind(this);
	            this.resetSearchText = this.resetSearchText.bind(this);
	            this.setValueSearchOverlayInput = this.setValueSearchOverlayInput.bind(this);
	            this.removeHeight = this.removeHeight.bind(this);
	            this.setPaddingTop = this.setPaddingTop.bind(this);
	            this.showPopup = this.showPopup.bind(this);
	            this.checkRecentelement = this.checkRecentelement.bind(this);
	            this.hidePopup = this.hidePopup.bind(this);
	            this.searchOverlayBackgroundClick = this.searchOverlayBackgroundClick.bind(this);
	            this.clearTextSearchOverlayClick = this.clearTextSearchOverlayClick.bind(this);
	            this.closeSearchOverlayButtonClick = this.closeSearchOverlayButtonClick.bind(this);
	            this.stopKeyStrockTracking = this.stopKeyStrockTracking.bind(this);
	            this.dummySearchPanelClick = this.dummySearchPanelClick.bind(this);
	            this.dummySearchPanelKeyUp = this.dummySearchPanelKeyUp.bind(this);
	            this.searchButtonClick = this.searchButtonClick.bind(this);
	            this.searchBarFocus = this.searchBarFocus.bind(this);
	            this.searchOverlayKeyUp = this.searchOverlayKeyUp.bind(this);
	            this.debounce = this.debounce.bind(this);
	            this.suggestionsCoordinator = this.suggestionsCoordinator.bind(this);
	            this.searchAccClose = this.searchAccClose.bind(this);
	            this.form = this.searchContainer.querySelector('form');
	            this.formParams = this.getFormParams();
	            this.formParams.q = '';
	
	            this.utils = utils;
	
	            if (breakpoint.size() === 'xsmall') {
	                document.querySelector('.navigation-btn__icon--search').innerText = '';
	                document.querySelector('.navigation-header__title-text__desktop').innerText = '';
	                var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	                var dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                if (/iPad/.test(userAgent) && window.innerWidth === TAB_768 || window.innerWidth === TAB_767) {
	                    window.mobileSearchKey = mobileSearchKey;
	                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
	                    this.searchButton.style.display = 'none';
	                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
	                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    utils.addClass(dummySearchBar, 'navigation-search-bar--search-wrap__full-width');
	                    var headerSectionLogo = document.querySelector('.navigation-logo');
	                    var headerSection = document.getElementById('progressiveHeaderSection');
	                    utils.addClass(headerSectionLogo, 'navigation-logo-ipad-portrait');
	
	                    utils.addClass(this.dummySearchPanel, 'navigation-search-bar-ipad-portrait');
	                    var searchPanelWarp = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    utils.addClass(searchPanelWarp, 'navigation-search-warp-ipad-portrait');
	
	                    var ipadMenu = document.querySelector('.navigation-hamburger-trigger');
	                    utils.addClass(ipadMenu, 'navigation-hamburger-ipad-portrait');
	                    utils.addClass(headerSection, 'navigation-header-ipad-height');
	                } else if (mobileSearchKey) {
	                    //collapsed
	                    window.mobileSearchKey = mobileSearchKey;
	                    document.querySelector('.navigation-res-nav-header__search').style.display = 'none';
	                    this.searchButton.style.display = 'block';
	                    this.dummySearchPanel.style.display = 'none';
	                } else {
	                    //collapsed
	                    document.querySelector('.navigation-res-nav-header__search').style.display = 'block';
	                    this.searchButton.style.display = 'none';
	                    this.dummySearchPanel.style.display = 'block';
	                    document.querySelector('.navigation-btn__icon--search-container').style.display = 'none';
	                    dummySearchBar = document.querySelector('.navigation-res-nav-header__search .navigation-search-bar--search-wrap');
	                    utils.addClass(dummySearchBar, 'navigation-search-bar--search-wrap__full-width');
	                }
	            } else {
	                this.searchButton.removeAttribute('style');
	                this.dummySearchPanel.removeAttribute('style');
	            }
	
	            this.bindEvents();
	            this.generateWrapper();
	        },
	
	        /**
	         * bind events with search input box & document
	         */
	        bindEvents: function bindEvents() {
	            this.searchOverlayBackground.addEventListener('click', this.searchOverlayBackgroundClick);
	            this.clearTextSearchOverlay.addEventListener('click', this.clearTextSearchOverlayClick);
	            this.closeSearchOverlayButton.addEventListener('click', this.closeSearchOverlayButtonClick);
	            this.closeSearchOverlayButton.addEventListener('mouseover', this.stopKeyStrockTracking);
	            this.closeSearchOverlayButton.addEventListener('touchstart', this.stopKeyStrockTracking);
	
	            this.dummySearchPanel.addEventListener('click', this.dummySearchPanelClick);
	            this.dummySearchPanel.addEventListener('keyup', this.dummySearchPanelKeyUp);
	            this.searchButton.addEventListener('click', this.searchButtonClick);
	            this.form.addEventListener('submit', this.searchFormSubmitHandler);
	            this.searchBar.addEventListener('focus', this.searchBarFocus);
	            this.searchContainerParentOverlay.addEventListener('keyup', this.searchOverlayKeyUp);
	            var debouncedKeyUp = this.debounce(this.suggestionsCoordinator, 200);
	            this.searchBar.addEventListener('keyup', this.searchInputKeyUpHandler);
	            this.searchBar.addEventListener('paste', this.searchInputKeyUpHandler);
	            this.searchBar.addEventListener('input', debouncedKeyUp);
	            if (this.skipacc) {
	                this.skipacc.addEventListener('focus', this.searchAccClose);
	            }
	        },
	
	        debounce: function debounce(func, delay) {
	            var debounceTimer;
	            return function () {
	                var context = this,
	                    args = arguments;
	                clearTimeout(debounceTimer);
	                debounceTimer = setTimeout(function () {
	                    func.apply(context, args);
	                }, delay);
	            };
	        },
	        /**
	         * Reset Searchbar text
	         */
	        resetSearchText: function resetSearchText() {
	            document.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').value = '';
	            if (breakpoint.size() === 'xsmall') {
	                document.querySelector('.navigation-dock-search-popup').classList.remove('navigation-hdr-sticky-class');
	            }
	        },
	        /**
	         * Creates search suggestions and opens/closes the list
	         */
	        suggestionsCoordinator: function suggestionsCoordinator() {
	            var createSuggestions = this.createSuggestions.bind(this);
	            this.fetchSuggestions(createSuggestions);
	        },
	        /**
	         * Resets suggestions in the overlay
	         */
	        resetSuggestions: function resetSuggestions(event) {
	            this.suggestionsCoordinator();
	            event.stopPropagation();
	        },
	        /**
	         * keyUp handler for search input box
	         */
	        searchInputKeyUpHandler: function searchInputKeyUpHandler(event) {
	
	            if (event.target.value.trim().length > 0) {
	                if (breakpoint.size() === 'xsmall') {
	                    this.clearTextSearchOverlay.style.display = 'block';
	                } else {
	                    this.clearTextSearchOverlay.style.display = 'none';
	                }
	            } else {
	                event.target.value = '';
	                this.clearTextSearchOverlay.removeAttribute('style');
	            }
	
	            if (event.target.value.trim().length > 1) {
	                this.enableSubmit();
	            } else {
	                this.disableSubmit();
	            }
	
	            if (event.type === 'paste') {
	                this.enableSubmit();
	                this.formParams.q = event.clipboardData.getData('Text');
	                this.suggestionsCoordinator();
	            }
	
	            if (event.shiftKey === false) {
	                this.formParams.q = event.target.value;
	
	                var keyPressed = event.key || event.keyCode;
	
	                if (keyPressed === 27 || keyPressed === 38 || keyPressed === 39 || keyPressed === 40 || keyPressed === 'Esc' || keyPressed === 'Escape' || keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown' || keyPressed === 'ArrowRight') {
	                    this.keyboardNavigateSuggestions(keyPressed, event);
	                }
	            }
	            if (breakpoint.size() === 'xsmall') {
	                if (this.mobileSearchbarReset.value === '' && this.searchBox.classList.contains('navigation-hdr-sticky-class')) {
	                    this.searchBox.classList.remove('navigation-hdr-sticky-class');
	                    this.removeHeight();
	                    this.resetPaddingTop.classList.remove('navigation-suggestion-list-padding');
	                }
	            }
	        },
	
	        /**
	         * navigate search suggestions using up/down/right arrows
	         */
	        keyboardNavigateSuggestions: function keyboardNavigateSuggestions(keyPressed, event) {
	            this.suggestionList = this.searchContainer.getElementsByClassName('navigation-search-bar__suggestion-list')[0];
	
	            if (this.suggestionList) {
	                var selectedSuggestion = this.suggestionList.getElementsByClassName('selected')[0],
	                    allSuggestions = this.suggestionList.getElementsByClassName('suggestion-item'),
	                    firstSuggestion = allSuggestions[0],
	                    lastSuggestion = allSuggestions[allSuggestions.length - 1],
	                    selectedSuggestionId;
	            }
	
	            switch (keyPressed) {
	                case 'ArrowUp': // up
	                case 38:
	                    event.stopPropagation();
	
	                    if (selectedSuggestion) {
	                        utils.removeClass(selectedSuggestion, 'selected');
	
	                        selectedSuggestionId = Array.prototype.indexOf.call(allSuggestions, selectedSuggestion);
	                        var prevSuggestion = allSuggestions[selectedSuggestionId - 1];
	
	                        if (prevSuggestion) {
	                            this.highlightSuggestion(prevSuggestion);
	                        } else {
	                            this.highlightSuggestion(lastSuggestion);
	                        }
	                    } else {
	                        this.highlightSuggestion(lastSuggestion);
	                    }
	
	                    break;
	                case 'ArrowDown': // down
	                case 40:
	                    event.stopPropagation();
	
	                    if (selectedSuggestion) {
	                        utils.removeClass(selectedSuggestion, 'selected');
	
	                        selectedSuggestionId = Array.prototype.indexOf.call(allSuggestions, selectedSuggestion);
	                        var nextSuggestion = allSuggestions[selectedSuggestionId + 1];
	
	                        if (nextSuggestion) {
	                            this.highlightSuggestion(nextSuggestion);
	                        } else {
	                            this.highlightSuggestion(firstSuggestion);
	                        }
	                    } else {
	                        this.highlightSuggestion(firstSuggestion);
	                    }
	                    break;
	                case 'ArrowRight': // right
	                case 39:
	                    if (selectedSuggestion) {
	                        if (!utils.hasClass(selectedSuggestion, 'navigation-suggestion-item--clear')) {
	                            this.setRecentSearches(selectedSuggestion.querySelector('a').dataset.keyword);
	                            window.location.href = selectedSuggestion.querySelector('a');
	                        }
	                    }
	                    break;
	                case 'Escape': // right
	                case 27:
	                    this.hidePopup();
	                    break;
	            }
	        },
	
	        /**
	         * highlight particular item in the suggestion list if it is visible
	         */
	        highlightSuggestion: function highlightSuggestion(item) {
	            if (!utils.hasClass(this.wrapper, 'navigation-search-bar--suggestion-dropdown__hidden')) {
	                utils.addClass(item, 'selected');
	
	                var itemText = item.querySelector('a');
	                if (itemText) {
	                    this.searchBar.value = item.querySelector('a').dataset.keyword;
	                }
	            }
	        },
	
	        // add hidden input element for user segment
	        addHidden: function addHidden(theForm, key, value) {
	            var input = document.createElement('input');
	            input.type = 'hidden';
	            input.name = key; // 'the key/name of the attribute/field that is sent to the server
	            input.value = value;
	            theForm.appendChild(input);
	        },
	
	        /*
	         * To check below conditions before appending usg to URL
	         * switch is enabled
	         * user logged in
	         * user segment cookie is not default
	         * search term is present in segments stored in local storage
	         */
	        checkUSG: function checkUSG(searchTerm) {
	            var localStorageTerms = this.localStorage.getItem('userSegmentSearch');
	            var searchTerms = [];
	            if (localStorageTerms) {
	                searchTerms = localStorageTerms.split(',');
	            }
	            if (mnsCookieService.isUserLoggedIn() && mnsCookieService.getUserSegmentCookieValue() !== 'default' && searchTerms.indexOf(searchTerm) > -1) {
	                return true;
	            }
	            return false;
	        },
	
	        /**
	         * submit handler for search form - if form submitted with selected suggestion
	         */
	        searchFormSubmitHandler: function searchFormSubmitHandler(event) {
	            var theForm = document.forms.productSearch;
	            var searchTermNoTrim = theForm.searchTerm.value;
	            var searchTerm = searchTermNoTrim.trim().replace(/[%><^[\],.()=]+/g, '');
	            theForm.searchTerm.value = searchTerm;
	            var usg = this.checkUSG(searchTerm);
	            if (usg) {
	                this.addHidden(theForm, 'usg', mnsCookieService.getUserSegmentCookieValue());
	            }
	            if (this.suggestionList) {
	                var selectedSuggestion = this.suggestionList.getElementsByClassName('selected')[0];
	                if (selectedSuggestion) {
	                    event.preventDefault();
	                    if (utils.hasClass(selectedSuggestion, 'navigation-suggestion-item--clear')) {
	                        this.clearRecentSearches(event);
	                    } else {
	                        this.setRecentSearches(selectedSuggestion.querySelector('a').dataset.keyword);
	                        window.location.href = selectedSuggestion.querySelector('a');
	                    }
	                }
	            } else {
	                this.setRecentSearches(searchTerm);
	            }
	            this.setValueSearchOverlayInput();
	        },
	
	        /**
	         * set value in input serach overlay text
	         */
	        setValueSearchOverlayInput: function setValueSearchOverlayInput() {
	            //hide placeholder on setting value
	            var elInput = this.searchBar.value;
	            var elInputSearchOverlay = this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search');
	
	            if (elInput) {
	                elInputSearchOverlay.value = elInput;
	            }
	        },
	
	        /**
	         * close suggestion box on click
	         */
	        closeSuggestions: function closeSuggestions() {
	            var _this = this;
	            if (_this.wrapper) {
	                _this.utils.addClass(_this.wrapper, 'navigation-search-bar--suggestion-dropdown__hidden');
	            }
	        },
	
	        /**
	         * show searchbox popup
	         */
	        checkRecentelement: function checkRecentelement() {
	            var recentElement = document.querySelector('.navigation-suggestion-item--title');
	            if (recentElement && !recentElement.hasAttribute('style')) {
	                var recentSearchList = document.querySelector('.navigation-recentsearch--list');
	                recentSearchList.style.maxHeight = '1000px';
	                recentSearchList.style.opacity = 1;
	                recentElement.style.maxHeight = '1000px';
	                recentElement.style.opacity = 1;
	                clearInterval(this.checkRecTimer);
	            }
	        },
	        showPopup: function showPopup() {
	            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
	            this.utils.removeClass(this.searchContainerParentOverlay, 'navigation-search-overlay-hidden');
	            this.utils.addClass(this.searchOverlayBackground, 'navigation-is-active-prompt');
	
	            this.skipacc.tabIndex = 0;
	            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                this.checkRecTimer = setInterval(this.checkRecentelement, 100);
	                var recentElementTitle = document.querySelector('.navigation-suggestion-item--title');
	                if (recentElementTitle) {
	                    var recentSearchListItems = document.querySelector('.navigation-recentsearch--list');
	                    recentSearchListItems.style.maxHeight = '1000px';
	                    recentSearchListItems.style.opacity = 1;
	                    recentElementTitle.style.maxHeight = '1000px';
	                    recentElementTitle.style.opacity = 1;
	                }
	            }
	
	            if (breakpoint.size() === 'xsmall') {
	                this.headerEl.style.zIndex = '2147483649';
	                if (this.utils.hasClass(document.getElementById('common-hdr-main'), 'navigation-sticky')) {
	                    this.utils.addClass(this.bodyEl, 'navigation-prevent-stickyscrolling');
	                    this.utils.addClass(document.querySelector('html'), 'navigation-prevent-stickyscrolling');
	                } else {
	                    this.utils.addClass(this.bodyEl, 'navigation-prevent-scrolling');
	                }
	            }
	            if (document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search')) {
	                document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search').tabIndex = '0';
	            }
	            if (document.querySelector('.navigation-suggestion-item--title')) {
	                document.querySelector('.navigation-suggestion-item--title').tabIndex = '0';
	            }
	            if (document.querySelector('.navigation-suggestion-item--clear-text')) {
	                document.querySelector('.navigation-suggestion-item--clear-text').tabIndex = '0';
	            }
	        },
	        /**
	         * hide searchbox popup
	         */
	        hidePopup: function hidePopup() {
	            this.utils.addClass(this.searchContainerParentOverlay, 'navigation-search-overlay-hidden');
	            this.utils.removeClass(this.searchOverlayBackground, 'navigation-is-active-prompt');
	            this.skipacc.tabIndex = -1;
	            if (breakpoint.size() === 'xsmall') {
	                this.headerEl.style.zIndex = '15';
	                this.utils.removeClass(this.bodyEl, 'navigation-prevent-stickyscrolling');
	                this.utils.removeClass(document.querySelector('html'), 'navigation-prevent-stickyscrolling');
	                this.utils.removeClass(this.bodyEl, 'navigation-prevent-scrolling');
	            }
	            if (document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search')) {
	                document.querySelector('.navigation-dock-search-popup .navigation-search-bar--search').tabIndex = '-1';
	            }
	            if (document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear')) {
	                document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear').tabIndex = '-1';
	            }
	            if (document.querySelector('.navigation-suggestion-item--title')) {
	                document.querySelector('.navigation-suggestion-item--title').tabIndex = '-1';
	            }
	            if (document.querySelector('.navigation-suggestion-item--clear-text')) {
	                document.querySelector('.navigation-suggestion-item--clear-text').tabIndex = '-1';
	            }
	            var recentElement = document.querySelector('.navigation-suggestion-item--title');
	            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                if (recentElement) {
	                    var recentSearchList = document.querySelector('.navigation-recentsearch--list');
	                    recentSearchList.style.maxHeight = '0';
	                    recentSearchList.style.opacity = 0;
	                    recentElement.style.maxHeight = '0';
	                    recentElement.style.opacity = 0;
	                }
	            }
	        },
	        /**
	         * open suggestion box on search input box focus
	         */
	        openSuggestions: function openSuggestions() {
	            if (this.wrapper) {
	                this.utils.removeClass(this.wrapper, 'navigation-search-bar--suggestion-dropdown__hidden');
	                this.headerSearchTypeRecent = document.querySelector('.reSearchHeader');
	                if (this.pageDiv && this.utils.hasClass(this.pageDiv, 'navigation-is-active-acc')) {
	                    this.utils.removeClass(this.myAccountContainer, 'navigation-header__sub-list-container--signacc-displayblock');
	                    this.utils.removeClass(this.pageDiv, 'navigation-is-active-acc');
	                    this.utils.removeClass(this.pageDivBorder, 'navigation-is-active');
	                    this.myAccButton.style.boxShadow = 'none';
	                }
	            }
	        },
	
	        /**
	         * generate wrapper around suggestion list
	         */
	        generateWrapper: function generateWrapper() {
	            this.wrapper = this.searchContainerParentOverlay.querySelector('.navigation-search-bar--suggestion-dropdown.navigation-search-bar--suggestion-dropdown__hidden');
	            this.SearchdropdownDiv = document.createElement('div');
	            this.SearchdropdownDiv.className = 'navigation-search-bar--dropdowndiv';
	            this.ul = document.createElement('ul');
	            this.recentSearchDiv = document.createElement('div');
	            this.recentsearchul = document.createElement('ul');
	            this.recentsearchul.className = 'navigation-search-bar__suggestion-list';
	            this.utils.addClass(this.recentsearchul, 'navigation-recentsearch--list');
	            this.ul.className = 'navigation-search-bar__suggestion-list';
	            this.utils.addClass(this.ul, 'navigation-search-item--list');
	            this.wrapper.appendChild(this.SearchdropdownDiv);
	            this.SearchdropdownDiv.appendChild(this.ul);
	            this.SearchdropdownDiv.appendChild(this.recentSearchDiv);
	            this.SearchdropdownDiv.appendChild(this.recentsearchul);
	            this.wrapperGenerated = true;
	            if (breakpoint.size() === 'xsmall') {
	                document.querySelector('.navigation-search-bar--suggestion-dropdown').addEventListener('touchstart', this.stickySearch);
	            }
	        },
	
	        appendUSG: function appendUSG(data) {
	            var splitLink = data.split('"');
	            var usg = this.checkUSG(splitLink[3]);
	            if (usg) {
	                splitLink[1] = splitLink[1] + '&usg=' + mnsCookieService.getUserSegmentCookieValue();
	            }
	            data = splitLink.join('"');
	            return data;
	        },
	
	        /**
	         * create suggestion list
	         * @param {Array} data suggestion list
	         */
	        createSuggestions: function createSuggestions(data) {
	            this.ul.innerHTML = '';
	
	            if (data.length > 0) {
	                var rows = data.length < 10 ? data.length : 10;
	                for (var x = 0; x < rows; x++) {
	                    if (data[x]) {
	                        data[x] = this.appendUSG(data[x]);
	                        this.ul.appendChild(this.createSuggestionItem(data[x]));
	                    }
	                }
	            }
	            if (!document.querySelector('.navigation-suggestion-item--title')) {
	                this.addRecentSearchSuggestions();
	            }
	            this.setCategorySection();
	            this.openSuggestions();
	
	            if (breakpoint.size() === 'small' || breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
	                    suggestionListArray = document.querySelectorAll('.navigation-search-item--list li.suggestion-item'),
	                    suggestionList = document.querySelector('.navigation-search-item--list');
	                if (suggestionListArray.length !== 0) {
	                    if (recentElement) {
	                        this.utils.addClass(suggestionList, 'navigation-recent-serach-underline');
	                    }
	                } else if (suggestionListArray.length === 0) {
	                    if (recentElement) {
	                        this.utils.removeClass(suggestionList, 'navigation-recent-serach-underline');
	                    }
	                }
	            }
	        },
	
	        /**
	         *  Add class to last suggestion in category
	         */
	        setCategorySection: function setCategorySection() {
	            var allSuggestions = this.searchContainer.getElementsByClassName('suggestion-item'),
	                lastCategoryIndex;
	
	            for (var i = 0; i < allSuggestions.length; i++) {
	                var suggestionLink = allSuggestions[i].firstChild;
	
	                if (suggestionLink && suggestionLink.nodeName === 'A' && suggestionLink.getAttribute('href').indexOf('categoryTypeAhead') !== -1) {
	                    lastCategoryIndex = i;
	                }
	            }
	
	            if (lastCategoryIndex) {
	                utils.addClass(allSuggestions[lastCategoryIndex], 'suggestion-item--category');
	            }
	        },
	
	        /**
	         * Add recent searches to the suggestions list
	         */
	        addRecentSearchSuggestions: function addRecentSearchSuggestions() {
	            var recentSearches = this.getRecentSearches();
	
	            if (recentSearches.length === 0) {
	                return;
	            }
	
	            var recentSearchLinks = this.createRecentSearchLinks(recentSearches);
	            var recentSearchBold = document.createElement('b');
	            this.recentSearchDiv.appendChild(recentSearchBold);
	            recentSearchBold.innerHTML = RECENT_SEARCHES;
	            this.recentSearchDiv.tabIndex = '-1';
	            this.utils.addClass(this.recentSearchDiv, 'navigation-suggestion-item--title');
	
	            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
	                    suggestionListArray = document.querySelectorAll('.navigation-search-bar__suggestion-list li'),
	                    suggestionList = document.querySelector('.navigation-search-item--list');
	                if (suggestionListArray.length !== 0) {
	                    if (recentElement) {
	                        this.utils.addClass(suggestionList, 'navigation-recent-serach-underline');
	                    }
	                }
	            }
	
	            for (var x = 0; x < recentSearchLinks.length; x++) {
	                var splitLink = recentSearchLinks[x].split('"');
	                var usg = this.checkUSG(splitLink[3]);
	                if (usg) {
	                    splitLink[1] = splitLink[1] + '&usg=' + mnsCookieService.getUserSegmentCookieValue();
	                }
	                recentSearchLinks[x] = splitLink.join('"');
	                var el = this.createSuggestionItem(recentSearchLinks[x]);
	                this.utils.addClass(el, 'navigation-suggestion-item--recent');
	                this.recentsearchul.appendChild(el);
	            }
	            var clearElement = document.createElement('div');
	            var recentSearchElement = document.querySelector('.navigation-suggestion-item--title'),
	                clearElementdevice = document.createElement('span'),
	                clearRecentSearches = this.clearRecentSearches.bind(this),
	                clearElementdeviceClick = this.clearElementdeviceClick.bind(this),
	                clearElementdeviceKeyUp = this.clearElementdeviceKeyUp.bind(this);
	            if (breakpoint.size() === 'xsmall') {
	                if (recentSearchElement) {
	                    clearElementdevice.innerHTML = CLEAR;
	                    this.utils.addClass(clearElementdevice, 'suggestion-item');
	                    this.utils.addClass(clearElementdevice, 'navigation-suggestion-item--clear');
	                    clearElementdevice.addEventListener('click', clearRecentSearches);
	                    recentSearchElement.appendChild(clearElementdevice);
	                }
	            } else {
	                clearElementdevice.addEventListener('click', clearElementdeviceClick);
	                clearElementdevice.addEventListener('keyup', clearElementdeviceKeyUp);
	                clearElementdevice.tabIndex = '-1';
	                clearElementdevice.setAttribute('aria-label', CLR_RECENT_SEARCHES);
	                if (breakpoint.size() === 'small' || breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                    clearElementdevice.innerHTML = CLEAR;
	                }
	                this.utils.addClass(clearElementdevice, 'navigation-suggestion-item--clear-text');
	                this.utils.addClass(clearElement, 'suggestion-item');
	                this.utils.addClass(clearElement, 'navigation-suggestion-item--clear');
	                clearElement.appendChild(clearElementdevice);
	                this.recentsearchul.appendChild(clearElement);
	                var recentSearchLength = document.querySelectorAll('.suggestion-item.navigation-suggestion-item--recent').length;
	                if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                    if (recentSearchLength === 1) {
	                        clearElement.style.top = '-7.8rem';
	                    } else if (recentSearchLength === 2) {
	                        clearElement.style.top = '-11.5rem';
	                    } else if (recentSearchLength === 3) {
	                        clearElement.style.top = '-15.2rem';
	                    }
	                } else if (breakpoint.size() === 'small') {
	                    if (recentSearchLength === 1) {
	                        clearElement.style.top = '-7.8rem';
	                    } else if (recentSearchLength === 2) {
	                        clearElement.style.top = '-12.3rem';
	                    } else if (recentSearchLength === 3) {
	                        clearElement.style.top = '-16.8rem';
	                    }
	                }
	            }
	        },
	        /**
	         * Return true if suggestions list is empty
	         */
	        checkSuggestionsListEmpty: function checkSuggestionsListEmpty() {
	            return this.ul.childNodes.length === 0;
	        },
	
	        /**
	         * Create <a> link elements for recent search suggestion items
	         */
	        createRecentSearchLinks: function createRecentSearchLinks(searchTerms) {
	            var searchLinks = [],
	                formParams = JSON.parse(JSON.stringify(this.formParams)),
	                searchCommand = this.currentStoreId === constant.ieId ? constant.ieSearch : constant.ukSearch;
	
	            delete formParams.typeAhead;
	            delete formParams.q;
	            delete formParams.intid;
	
	            for (var x = 0; x < searchTerms.length; x++) {
	                formParams.searchTerm = searchTerms[x];
	                var url = [searchCommand, this.utils.serialize(formParams)].join('?');
	                var aTag = document.createElement('a');
	                aTag.setAttribute('href', url);
	                aTag.setAttribute('class', 'reSearchHeader');
	                aTag.setAttribute('data-keyword', searchTerms[x]);
	                aTag.text = searchTerms[x];
	                searchLinks.push(aTag.outerHTML);
	            }
	            return searchLinks;
	        },
	
	        /**
	         * Get recent searches from local storage and format
	         * @returns Array
	         */
	        getRecentSearches: function getRecentSearches() {
	            var myRecentSearchItem = this.localStorage.getItem('myRecentSearch');
	
	            if (!myRecentSearchItem) {
	                return [];
	            }
	
	            return myRecentSearchItem.split('||');
	        },
	
	        /**
	         * Set recent searches in local storage in correct format
	         */
	        setRecentSearches: function setRecentSearches(searchTerm) {
	            var recentSearches = this.getRecentSearches();
	
	            if (recentSearches.indexOf(searchTerm) > -1) {
	                recentSearches.splice(recentSearches.indexOf(searchTerm), 1);
	            }
	
	            recentSearches.unshift(searchTerm);
	            if (recentSearches.length > MAX_RECENT_SEARCH) {
	                recentSearches.pop();
	            }
	
	            this.localStorage.setItem('myRecentSearch', recentSearches.join('||'));
	        },
	
	        /**
	         * Clear the recent searches in local storage
	         */
	        clearRecentSearches: function clearRecentSearches(evt) {
	            if (evt) {
	                evt.stopPropagation();
	                evt.preventDefault();
	            }
	            this.localStorage.removeItem('myRecentSearch');
	            var el = this.searchContainerParentOverlay.querySelector('.navigation-search-bar__suggestion-list.navigation-recentsearch--list');
	            var recentSearchTitle = document.querySelector('.navigation-suggestion-item--title');
	            var clearRecentSearch = document.querySelector('.navigation-suggestion-item--clear');
	            var _this = this;
	            if (recentSearchTitle) {
	                recentSearchTitle.innerHTML = '';
	                this.utils.removeClass(recentSearchTitle, 'navigation-suggestion-item--title');
	            }
	            if ((breakpoint.size() !== 'small' || breakpoint.size() !== 'xsmall') && document.querySelector('.navigation-suggestion-item--clear')) {
	                clearRecentSearch.parentNode.removeChild(clearRecentSearch);
	            }
	            var recentSearchElArr = this.searchContainerParentOverlay.querySelectorAll('.navigation-suggestion-item--recent');
	            for (var i = 0; i < recentSearchElArr.length; i++) {
	                el.removeChild(recentSearchElArr[i]);
	            }
	            if (breakpoint.size() === 'xsmall') {
	                var recentElement = document.querySelector('.navigation-suggestion-item--title'),
	                    suggestionListArray = document.querySelectorAll('.navigation-search-bar__suggestion-list li');
	                if (suggestionListArray.length !== 0) {
	                    if (!recentElement) {
	                        document.querySelector('.navigation-search-bar__suggestion-list').style.height = '100' + 'vh';
	                    }
	                }
	            }
	            var suggestionList = document.querySelector('.navigation-search-item--list');
	            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                this.utils.removeClass(suggestionList, 'navigation-recent-serach-underline');
	            }
	            _this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
	        },
	        /**
	         * create single suggestion item, append item to list, bind click event to item
	         * @param {String} suggestion item
	         * @returns {Element} single suggestion element
	         */
	        createSuggestionItem: function createSuggestionItem(item) {
	            var listItem,
	                selectSuggestion = this.selectSuggestion.bind(this);
	
	            listItem = document.createElement('li');
	            listItem.className = 'suggestion-item';
	            listItem.tabIndex = -1;
	
	            listItem.innerHTML = item;
	
	            listItem.addEventListener('click', selectSuggestion);
	
	            return listItem;
	        },
	
	        /**
	         * update search input box value based on selected suggestion
	         */
	        selectSuggestion: function selectSuggestion(event) {
	            this.searchBar.value = event.currentTarget.textContent;
	            this.setRecentSearches(this.searchBar.value);
	            var el = this.searchContainerParentOverlay.querySelector('.navigation-search-bar__suggestion-list.navigation-recentsearch--list');
	            var recentSearchTitle = this.searchContainerParentOverlay.querySelector('.navigation-suggestion-item--title');
	            el.innerHTML = '';
	            recentSearchTitle.innerHTML = '';
	            this.addRecentSearchSuggestions();
	        },
	
	        /**
	         * enable search submit button
	         */
	        enableSubmit: function enableSubmit() {
	            this.submitButton.disabled = false;
	        },
	
	        /**
	         * disable search submit button
	         */
	        disableSubmit: function disableSubmit() {
	            this.submitButton.disabled = true;
	        },
	
	        /**
	         * make ajax call for fetching suggestion list based on search input box value
	         */
	        fetchSuggestions: function fetchSuggestions(callback) {
	            window.sessionStorage.setItem('searchCharCount', this.formParams.q.length);
	            window.sessionStorage.setItem('searchChar', this.formParams.q);
	            if (this.formParams.q.length === 0) {
	                if (this.searchOverlayVsMessageEl) {
	                    this.utils.removeClass(this.searchOverlayVsMessageEl, 'navigation-searchoverlay-vs--prompt--hidden');
	                }
	                callback([]);
	            } else if (this.formParams.q.length === 1) {
	                if (this.searchOverlayVsMessageEl) {
	                    this.utils.addClass(this.searchOverlayVsMessageEl, 'navigation-searchoverlay-vs--prompt--hidden');
	                }
	                callback([]);
	            } else if (this.formParams.q.length < 2) {
	                callback([]);
	            } else {
	                var self = this;
	                var xhrp = new XhrPromise();
	
	                xhrp.send({
	                    url: self.getSuggestionsUrl(),
	                    method: 'GET'
	                }).then(function (response) {
	                    if (response.status === 200) {
	                        callback(response.responseText);
	                    }
	                }).catch(function () {
	                    //Handle errors here
	                    callback([]);
	                });
	            }
	        },
	
	        /**
	         * @returns {string} url with form get params
	         */
	        getSuggestionsUrl: function getSuggestionsUrl() {
	            /**Test for XSS issue**/
	            this.formParams.q = this.formParams.q.replace(/[%><^[\],.()=]+/g, '');
	            var url = [this.command, this.utils.serialize(this.formParams)];
	            return url.join('?');
	        },
	
	        /**
	         * convert search form elements into object
	         * @returns {Object} search form elements
	         */
	        getFormParams: function getFormParams() {
	            var searchForm = this.searchContainer.querySelector('form[name="productSearch"]');
	            searchForm.action = this.currentStoreId === constant.ieId ? constant.ieSearch : constant.ukSearch;
	            var formValues = {};
	
	            for (var i = 0, n = searchForm.length; i < n; i++) {
	                var e = searchForm.elements[i];
	                if (e.name) {
	                    formValues[e.name] = e.value;
	                }
	            }
	
	            delete formValues.searchTerm;
	
	            return formValues;
	        },
	
	        stickySearch: function stickySearch() {
	            if (this.mobileSearchbarReset.value !== '') {
	                document.querySelector('.navigation-dock-search-popup').classList.add('navigation-hdr-sticky-class');
	                document.querySelector('.navigation-search-bar--suggestion-dropdown').classList.add('navigation-suggestion-list-padding');
	                if (this.utils.hasClass(document.getElementById('common-hdr-main'), 'navigation-sticky')) {
	                    this.utils.addClass(this.bodyEl, 'navigation-prevent-stickyscrolling');
	                    this.utils.addClass(document.querySelector('html'), 'navigation-prevent-stickyscrolling');
	                } else {
	                    this.utils.addClass(this.bodyEl, 'navigation-prevent-scrolling');
	                }
	                var SearchsuggestionList = document.querySelector('.navigation-search-item--list li');
	                var searchbardropdownDiv = document.querySelector('.navigation-search-bar--dropdowndiv');
	                if (SearchsuggestionList) {
	                    this.utils.addClass(searchbardropdownDiv, 'navigation-scroll-height');
	                }
	            }
	            document.querySelector('.navigation-search-overlay .navigation-search-bar--search-wrap .navigation-search-bar--search').blur();
	        },
	
	        setPaddingTop: function setPaddingTop() {
	
	            if (this.resetPaddingTop.classList.contains('navigation-suggestion-list-padding')) {
	                document.querySelector('.navigation-search-bar--suggestion-dropdown').classList.remove('navigation-suggestion-list-padding');
	            }
	        },
	
	        removeHeight: function removeHeight() {
	
	            var searchbardropdownDiv = document.querySelector('.navigation-search-bar--dropdowndiv');
	            this.utils.removeClass(searchbardropdownDiv, 'navigation-scroll-height');
	        },
	
	        searchOverlayBackgroundClick: function searchOverlayBackgroundClick() {
	            this.resetSearchText();
	            this.hidePopup();
	            this.closeSuggestions();
	        },
	
	        clearTextSearchOverlayClick: function clearTextSearchOverlayClick(evt) {
	            evt.stopPropagation();
	            evt.preventDefault();
	            this.setPaddingTop();
	            this.resetSearchText();
	            this.removeHeight();
	            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
	            //call resetSuggestions only after clearing q params so that existing suggestions get cleared
	            // No need for this call if the focus() is getting called as it internally calls resetSuggestions
	            if (breakpoint.size() !== 'large') {
	                document.querySelector('.navigation-search-overlay .navigation-search-bar--search-wrap .navigation-search-bar--search').focus();
	            }
	            if (breakpoint.size() === 'large') {
	                this.formParams.q = '';
	                this.resetSuggestions(evt);
	            }
	        },
	
	        stopKeyStrockTracking: function stopKeyStrockTracking() {
	            window.sessionStorage.removeItem('ks');
	        },
	
	        closeSearchOverlayButtonClick: function closeSearchOverlayButtonClick(evt) {
	
	            evt.stopPropagation();
	            evt.preventDefault();
	            this.setPaddingTop();
	            this.resetSearchText();
	            this.removeHeight();
	
	            //call resetSuggestions only after clearing q params so that existing sugggestions get cleared
	            this.formParams.q = '';
	            this.resetSuggestions(evt);
	            this.hidePopup();
	            this.closeSuggestions();
	        },
	
	        searchAccClose: function searchAccClose(evt) {
	            this.setPaddingTop();
	            this.resetSearchText();
	            this.removeHeight();
	            //call resetSuggestions only after clearing q params so that existing sugggestions get cleared
	            this.formParams.q = '';
	            this.resetSuggestions(evt);
	            this.hidePopup();
	            this.closeSuggestions();
	            if (window.mobileSearchKey) {
	                this.dummySearchPanel.focus();
	            } else {
	                this.searchButton.focus();
	            }
	        },
	
	        searchOverlayKeyUp: function searchOverlayKeyUp(evt) {
	            if (!window.sessionStorage.getItem('ks') || window.sessionStorage.getItem('ks') === undefined) {
	                window.sessionStorage.setItem('ks', '1');
	            } else {
	                var keyStroke = parseInt(window.sessionStorage.getItem('ks'));
	                var keyStr = keyStroke + 1;
	                window.sessionStorage.setItem('ks', keyStr);
	            }
	
	            var keyPressed = evt.key || evt.keyCode;
	            if (keyPressed === 27 || keyPressed === 'Esc' || keyPressed === 'Escape') {
	                window.sessionStorage.removeItem('ks');
	                this.setPaddingTop();
	                this.resetSearchText();
	                this.removeHeight();
	                //call resetSuggestions only after clearing q params so that existing suggestions get cleared
	                this.formParams.q = '';
	                this.resetSuggestions(evt);
	                this.hidePopup();
	                this.closeSuggestions();
	                this.dummySearchPanel.focus();
	            }
	        },
	
	        dummySearchPanelClick: function dummySearchPanelClick(event) {
	            event.preventDefault();
	            this.showPopup();
	            this.openSuggestions();
	            event.stopPropagation();
	            if (breakpoint.size() !== 'xsmall' && breakpoint.size() !== 'small') {
	                for (var topNavItem = 0; topNavItem < this.topNavCheckBox.length; topNavItem++) {
	                    this.topNavCheckBox[topNavItem].checked = false;
	                }
	            }
	            this.setValueSearchOverlayInput();
	
	            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
	            var suggestionList = document.querySelector('.navigation-search-item--list'),
	                recentElement = document.querySelector('.navigation-suggestion-item--title');
	            if (breakpoint.size() === 'medium' || breakpoint.size() === 'large') {
	                if (recentElement) {
	                    this.utils.removeClass(suggestionList, 'navigation-recent-serach-underline');
	                }
	            }
	        },
	
	        dummySearchPanelKeyUp: function dummySearchPanelKeyUp(event) {
	            var keyPressed = event.key || event.keyCode;
	            switch (keyPressed) {
	                case 'Enter':
	                case ' ':
	                case 32:
	                case 13:
	                    event.preventDefault();
	                    this.showPopup();
	                    this.openSuggestions();
	                    event.stopPropagation();
	                    if (breakpoint.size() !== 'xsmall' && breakpoint.size() !== 'small') {
	                        for (var topNavItem = 0; topNavItem < this.topNavCheckBox.length; topNavItem++) {
	                            this.topNavCheckBox[topNavItem].checked = false;
	                        }
	                    }
	                    this.setValueSearchOverlayInput();
	
	                    this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
	                    break;
	                case 'Escape':
	                case 27:
	                    this.hidePopup();
	                    break;
	            }
	        },
	
	        searchButtonClick: function searchButtonClick(event) {
	            event.preventDefault();
	            event.stopPropagation();
	            this.showPopup();
	            this.setValueSearchOverlayInput();
	            this.openSuggestions();
	            if (breakpoint.size() !== 'xsmall' && breakpoint.size() !== 'small') {
	                for (var topNavItem = 0; topNavItem < this.topNavCheckBox.length; topNavItem++) {
	                    this.topNavCheckBox[topNavItem].checked = false;
	                }
	            }
	            this.searchContainerParentOverlay.querySelector('.navigation-res-nav-header__dropdown--search .navigation-search-bar--search').focus();
	        },
	
	        searchBarFocus: function searchBarFocus(evt) {
	            if (this.searchBar.value === '') {
	                this.formParams.q = '';
	            }
	            this.resetSuggestions(evt);
	        },
	
	        clearElementdeviceClick: function clearElementdeviceClick() {
	            this.clearRecentSearches();
	        },
	
	        clearElementdeviceKeyUp: function clearElementdeviceKeyUp(event) {
	            var keyPressed = event.key;
	            if (keyPressed === 'Enter' || keyPressed === '') {
	                this.clearRecentSearches();
	            }
	        }
	    };
	
	    return Search;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (domQ) {
	
	    function Carousel(el, options) {
	        this.carousel = el;
	        this.options = this.getOptions(options);
	    }
	
	    Carousel.TYPES = {
	        HORIZONTAL: 'horizontal',
	        VERTICAL: 'vertical'
	    };
	
	    Carousel.prototype = {
	
	        /*
	         * Set timer as 0 if no automatic transition required.
	         * Set disableBtnCss as 'hdr-infinite-loop' for looping the carousel.
	         */
	
	        /**
	         * Returns carousel configuration options
	         * @param {Object} custom configuration options
	         * @returns {Object} carousel configuration options
	         */
	        getOptions: function getOptions(options) {
	            var defaultOptions = {
	                wrapper: '.navigation-hdr-carousel__content',
	                slider: '.navigation-hdr-carousel__slides',
	                slide: '.navigation-hdr-carousel__slides li',
	                multiple: true,
	                previousBtn: '.navigation-hdr-carousel__btn--previous',
	                nextBtn: '.navigation-hdr-carousel__btn--next',
	                type: 'horizontal',
	                disableBtnCss: 'navigation-hdr-ctrl--link-disable'
	            };
	
	            return _extends(defaultOptions, options);
	        },
	
	        /**
	         * Initialize carousel component by setting initial state and behavior
	         */
	        init: function init() {
	            this.wrapper = this.carousel.querySelector(this.options.wrapper);
	            this.wrapperSize = this.options.type === Carousel.TYPES.HORIZONTAL ? this.wrapper.offsetWidth : this.wrapper.offsetHeight;
	
	            this.slider = this.carousel.querySelector(this.options.slider);
	
	            this.previousBtn = this.carousel.querySelector(this.options.previousBtn);
	            this.nextBtn = this.carousel.querySelector(this.options.nextBtn);
	
	            this.slideIndex = 0;
	
	            this.totalSlides = this.carousel.querySelectorAll(this.options.slide).length;
	
	            this.slideSize = this.options.type === Carousel.TYPES.HORIZONTAL ? this.carousel.querySelector(this.options.slide).offsetWidth : this.carousel.querySelector(this.options.slide).offsetHeight;
	            this.slidesinView = Math.floor(this.wrapperSize / this.slideSize);
	
	            // bind carousel events
	            this.bindEvents();
	
	            // set default next / previous link state
	            this.toggleNavBtnState();
	        },
	
	        bindEvents: function bindEvents() {
	            var slideNext = this.slideNext.bind(this),
	                slidePrevious = this.slidePrevious.bind(this);
	
	            this.nextBtn.addEventListener('click', slideNext);
	            this.previousBtn.addEventListener('click', slidePrevious);
	
	            /* TBD: need to undersatnd resizing logic
	            window.addEventListener('resize', function () {
	                self.width = self.slides.offsetWidth;
	            });
	            */
	        },
	
	        /**
	         * Toggles next and previous link states
	         */
	        toggleNavBtnState: function toggleNavBtnState() {
	            this.isFirstSlide() ? this.disablePreviousBtn() : this.enablePreviousBtn();
	            this.isLastSlide() ? this.disableNextBtn() : this.enableNextBtn();
	        },
	
	        /**
	         * Move carousel to next slide
	         * @returns {Boolean} slide status. Returns false if current slide is last slide in carousel
	         */
	        slideNext: function slideNext(evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            if (this.isLastSlide()) {
	                return false;
	            }
	
	            this.slideIndex += 1;
	            this.toggleNavBtnState();
	            this.animate();
	
	            return true;
	        },
	
	        /**
	         * Move carousel to previous slide
	         * @returns {Boolean} slide status. Returns false if current slide is first slide in carousel
	         */
	        slidePrevious: function slidePrevious(evt) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            if (this.isFirstSlide()) {
	                return false;
	            }
	
	            this.slideIndex -= 1;
	            this.toggleNavBtnState();
	            this.animate();
	
	            return true;
	        },
	
	        /**
	         * Checks if current slide is first slide of carousel
	         * @returns {Boolean} Returns true if current slide is first slide of carousel
	         */
	        isFirstSlide: function isFirstSlide() {
	            return this.slideIndex === 0;
	        },
	
	        /**
	         * Checks if current slide is last slide of carousel
	         * @returns {Boolean} Returns true if current slide is last slide of carousel
	         */
	        isLastSlide: function isLastSlide() {
	            if (this.options.multiple) {
	                return this.slideIndex >= Math.ceil(this.totalSlides / this.slidesinView) - 1;
	            } else {
	                return this.slideIndex >= this.totalSlides - 1;
	            }
	        },
	
	        /**
	         * Disable next slide link
	         */
	        disableNextBtn: function disableNextBtn() {
	            domQ(this.nextBtn).addClass(this.options.disableBtnCss);
	        },
	
	        /**
	         * Enable next slide link
	         */
	        enableNextBtn: function enableNextBtn() {
	            domQ(this.nextBtn).removeClass(this.options.disableBtnCss);
	        },
	
	        /**
	         * Disable previous slide link
	         */
	        disablePreviousBtn: function disablePreviousBtn() {
	            domQ(this.previousBtn).addClass(this.options.disableBtnCss);
	        },
	
	        /**
	         * Enable previous slide link
	         */
	        enablePreviousBtn: function enablePreviousBtn() {
	            domQ(this.previousBtn).removeClass(this.options.disableBtnCss);
	        },
	
	        /**
	         * Animate carousel slide
	         */
	        animate: function animate() {
	            if (this.options.type === Carousel.TYPES.HORIZONTAL) {
	                this.slider.style.transform = 'translateX(' + this.getPosition() + 'px)';
	            } else {
	                this.slider.style.transform = 'translateY(' + this.getPosition() + 'px)';
	            }
	        },
	
	        /**
	         * Returns animation value to slide carousel
	        * @returns {Number}
	         */
	        getPosition: function getPosition() {
	            var position = 0;
	
	            if (this.options.multiple) {
	                position = -(this.slideSize * this.slideIndex * this.slidesinView);
	            } else {
	                position = -(this.slideSize * this.slideIndex);
	            }
	
	            return position;
	        }
	    };
	
	    return Carousel;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        bind: function bind() {
	            this.navAcceptcookie = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner__accept') : document.querySelector('.navigation-cookiebbanner__submit');
	            this.navCookieOverlay = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner_roioverlay') : false;
	            this.navRejectcookiebutton = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner__reject') : false;
	            this.cookieBanner = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner_roi') : document.querySelector('.navigation-cookiebbanner');
	            if (this.cookieBanner) {
	                this.cookieBanner.style.display = 'flex';
	                this.cookieBanner.setAttribute('aria-hidden', false);
	            }
	            this.acceptCookieBanner = this.acceptCookieBanner.bind(this);
	            this.rejectCookieBanner = this.rejectCookieBanner.bind(this);
	            if (this.navRejectcookiebutton && this.navCookieOverlay) {
	                this.navRejectcookiebutton.addEventListener('click', this.rejectCookieBanner);
	                this.navCookieOverlay.classList.add('active');
	                this.navCookieOverlay.addEventListener('focus', function () {
	                    document.querySelector('.navigation-cookiebbanner_roititle').focus();
	                });
	            }
	            this.navAcceptcookie.addEventListener('click', this.acceptCookieBanner);
	        },
	        acceptCookieBanner: function acceptCookieBanner() {
	            if (typeof utag !== 'undefined' && typeof utag.gdpr !== 'undefined') {
	                // eslint-disable-line no-undef
	                utag.gdpr.setConsentValue(1); // eslint-disable-line no-undef
	            }
	            this.cookieBanner.style.display = 'none';
	            this.cookieBanner.setAttribute('aria-hidden', true);
	            if (this.navCookieOverlay) {
	                this.navCookieOverlay.classList.remove('active');
	            }
	        },
	        rejectCookieBanner: function rejectCookieBanner() {
	            if (typeof utag !== 'undefined' && typeof utag.gdpr !== 'undefined') {
	                // eslint-disable-line no-undef
	                utag.gdpr.setConsentValue(0); // eslint-disable-line no-undef
	            }
	            this.cookieBanner.style.display = 'none';
	            this.cookieBanner.setAttribute('aria-hidden', true);
	            if (this.navCookieOverlay) {
	                this.navCookieOverlay.classList.remove('active');
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (domQ) {
	
	    function DockOverlay(overlay, target, options) {
	        this.element = overlay;
	
	        this.target = target;
	        this.options = this.getOptions(options);
	
	        this.onInitShowCallbacks = [];
	        this.onShowCallbacks = [];
	        this.bindEvents();
	    }
	
	    DockOverlay.SHOW_HIDE_DELAY = 100;
	
	    DockOverlay.prototype = {
	
	        /**
	         * Show dock overlay
	         */
	        getOptions: function getOptions(options) {
	            var defaultOptions = {
	                align: 'center',
	                direction: 'down',
	                disableCss: 'navigation-dock-overlay--disabled',
	                displayCss: 'navigation-dock-overlay--block',
	                transitionCss: 'navigation-dock-overlay--transition',
	                contentWrapper: '.navigation-dock-overlay__inner'
	            };
	
	            return _extends(defaultOptions, options);
	        },
	
	        /**
	         * Executes dock overlay on show init event callbacks
	         */
	        bindEvents: function bindEvents() {
	            var dockOverlayInteractions = this.dockOverlayInteractions.bind(this),
	                dockOverlayKeyInteractions = this.dockOverlayKeyInteractions.bind(this),
	                dockOverlayMouseOut = this.dockOverlayMouseOut.bind(this),
	                stick = this.stick.bind(this),
	                hide = this.hide.bind(this);
	
	            // add mouseover event to target element
	            this.target.addEventListener('mouseover', dockOverlayInteractions);
	            if (this.target.nextElementSibling) {
	                if (window.mnsInlineData && (window.mnsInlineData.pageName === 'BASKET' || window.mnsInlineData.pageName === 'ORDERCONFIRM' || window.mnsInlineData.pageName === 'AGEVERIFICATION')) {
	                    this.target.nextElementSibling.style.display = 'none';
	                } else if (!window.miniBagKeyupFlag) {
	                    this.target.nextElementSibling.addEventListener('click', dockOverlayKeyInteractions);
	                    window.miniBagKeyupFlag = true;
	                }
	            }
	
	            // add mouseout event to target element
	            this.target.addEventListener('mouseout', dockOverlayMouseOut);
	
	            // add mouseover event to ovelay element
	            this.element.addEventListener('mouseover', stick);
	
	            // add mouseout event to ovelay element
	            this.element.addEventListener('mouseout', hide);
	        },
	
	        dockOverlayMouseOut: function dockOverlayMouseOut(evt) {
	            var hide = this.hide.bind(this);
	            evt.stopPropagation();
	            hide();
	        },
	
	        dockOverlayInteractions: function dockOverlayInteractions(evt) {
	            var self = this,
	                show = this.show.bind(this),
	                stick = this.stick.bind(this);
	            evt.stopPropagation();
	            // execute onInitShow callbacks in asynchronous manner
	            setTimeout(function () {
	                self.executeOnInitShowCallbacks();
	            }, 0);
	
	            // don't show overlay if it has disable css class'
	            if (domQ(self.element).hasClass(self.options.disableCss) || window.mnsInlineData && (window.mnsInlineData.pageName === 'BASKET' || window.mnsInlineData.pageName === 'ORDERCONFIRM' || window.mnsInlineData.pageName === 'AGEVERIFICATION' || window.mnsInlineData.userLogon && window.mnsInlineData.userLogon.action === 'MSCheckoutLogon')) {
	                return;
	            }
	
	            show();
	            stick();
	        },
	
	        dockOverlayKeyInteractions: function dockOverlayKeyInteractions(evt) {
	            var self = this,
	                show = this.show.bind(this),
	                hide = this.hide.bind(this),
	                miniBagOverlayAccessibility = this.miniBagOverlayAccessibility.bind(this);
	            evt.stopPropagation();
	            var keyPressed = evt.key || evt.keyCode;
	            if (keyPressed === 38 || keyPressed === 'ArrowUp' || keyPressed === 27 || keyPressed === 'Escape') {
	                this.target.nextElementSibling.blur();
	                hide();
	                this.target.nextElementSibling.focus();
	                window.minibagOpenFlag = 'false';
	            } else {
	                evt.stopPropagation();
	                // execute onInitShow callbacks in asynchronous manner
	                setTimeout(function () {
	                    self.executeOnInitShowCallbacks();
	                }, 0);
	
	                // don't show overlay if it has disable css class'
	                if (domQ(self.element).hasClass(self.options.disableCss) || window.mnsInlineData && (window.mnsInlineData.pageName === 'BASKET' || window.mnsInlineData.pageName === 'ORDERCONFIRM' || window.mnsInlineData.pageName === 'AGEVERIFICATION' || window.mnsInlineData.userLogon && window.mnsInlineData.userLogon.action === 'MSCheckoutLogon')) {
	                    return;
	                }
	                var minibagOverlayDiv = document.getElementById('miniBagOverlayHeader');
	                if (minibagOverlayDiv) {
	                    if (!minibagOverlayDiv.classList.contains('navigation-dock-overlay--block')) {
	                        show();
	                        this.target.nextElementSibling.blur();
	                        var chevronElement = this.target.nextElementSibling;
	                        chevronElement.setAttribute('aria-label', 'Shopping bag Button expanded');
	                        chevronElement.focus();
	                        window.minibagOpenFlag = 'true';
	                        setTimeout(function () {
	                            miniBagOverlayAccessibility();
	                        }, DockOverlay.SHOW_HIDE_DELAY * 3);
	                    } else if (window.minibagOpenFlag === 'true') {
	                        this.target.nextElementSibling.blur();
	                        hide();
	                        this.target.nextElementSibling.focus();
	                    }
	                }
	            }
	        },
	
	        /**
	         * Executes dock overlay on show init event callbacks
	         */
	        executeOnInitShowCallbacks: function executeOnInitShowCallbacks() {
	            this.onInitShowCallbacks.map(function (callback) {
	                callback();
	            });
	        },
	
	        /**
	         * Set dock overlay content
	         */
	        content: function content(html) {
	            this.element.querySelector(this.options.contentWrapper).innerHTML = html;
	            var alink = document.querySelector('.navigation-res-nav-header__item.navigation-res-nav-header__item--bag a');
	            if (alink && alink.querySelector(':hover')) {
	                this.show();
	            }
	        },
	
	        /**
	         * Show dock overlay
	         */
	        show: function show() {
	            var self = this,
	                innerEl = document.querySelector(self.options.contentWrapper);
	
	            if (innerEl.firstElementChild && innerEl.firstElementChild.firstElementChild) {
	
	                self.position();
	
	                domQ(self.element).addClass(self.options.displayCss);
	                domQ(self.element).addClass(self.options.transitionCss);
	
	                self.executeOnShowCallbacks();
	            }
	        },
	
	        /**
	         * Hide dock overlay
	         */
	        hide: function hide() {
	            var self = this;
	            function removeAddOnTitle(removeParam) {
	                if (removeParam.children.length === 2) {
	                    var addOnTitle = removeParam.children[0];
	                    removeParam.removeChild(addOnTitle);
	                }
	            }
	
	            self.hideOverlayTimeout = setTimeout(function () {
	                domQ(self.element).removeClass(self.options.transitionCss);
	                domQ(self.element).removeClass(self.options.displayCss);
	                self.hideOverlayTimeout = false;
	                if (self.element.id === 'miniBagOverlayHeader') {
	                    if (document.querySelector('.navigation-hdr-mini-bag__remove-element')) {
	                        var removeElement = document.querySelector('.navigation-hdr-mini-bag__remove-element').parentNode;
	                        if (domQ(removeElement).hasClass('navigation-hdr-mini-bag__add-on-container')) {
	                            removeAddOnTitle(removeElement.parentNode);
	                        }
	                        removeElement.parentNode.removeChild(removeElement);
	                        var listOfItems = document.querySelector('.navigation-hdr-mini-bag--list').children;
	                        var listOfAddons = document.querySelectorAll('.navigation-hdr-mini-bag__add-on-container').length;
	                        var noOfItems = listOfItems.length + listOfAddons;
	                        if (noOfItems === 2) {
	                            domQ(document.getElementById('miniBagOverlayHeader').children[0].children[1]).removeClass('navigation-hdr-mini-bag__carousel');
	                        }
	                    }
	                }
	            }, DockOverlay.SHOW_HIDE_DELAY);
	            window.minibagOpenFlag = 'false';
	            if (self.target.nextElementSibling) {
	                self.target.nextElementSibling.setAttribute('aria-label', 'Shopping bag button collapsed');
	            }
	        },
	
	        /* miniBagOverlayAccessibility function for minibaghide on tabing after checkout */
	
	        miniBagOverlayAccessibility: function miniBagOverlayAccessibility() {
	            var self = this,
	                hideoverlay = this.hideoverlay.bind(this),
	                minibagfocushideOverlay = this.minibagfocushideOverlay.bind(this),
	                escapeKeyTab = this.escapeKeyTab.bind(this),
	                bindAtagtoTitleDiv = this.bindAtagtoTitleDiv.bind(this);
	            if (self.element.id === 'miniBagOverlayHeader') {
	                var focusElement = document.querySelectorAll('.nav-primary__list a'),
	                    firstElement = focusElement[0] && focusElement[0].classList.contains('nav-primary-inspire-me') ? focusElement[1] : focusElement[0];
	                firstElement.addEventListener('keyup', hideoverlay);
	
	                self.target.addEventListener('keyup', minibagfocushideOverlay);
	                var minibagContainerElement = document.querySelector('.navigation-dock-overlay__inner');
	                minibagContainerElement.addEventListener('keyup', escapeKeyTab);
	                var minibagTitleElements = document.querySelectorAll('.navigation-hdr-mini-bag__item-detail');
	                if (minibagTitleElements) {
	                    var minibagTitleElementsLength = minibagTitleElements.length;
	                    for (var i = 0; i < minibagTitleElementsLength; i++) {
	                        minibagTitleElements[i].addEventListener('keyup', bindAtagtoTitleDiv);
	                    }
	                }
	            }
	        },
	
	        bindAtagtoTitleDiv: function bindAtagtoTitleDiv(evt) {
	            var keyPressed = evt.key || evt.keyCode;
	            if (keyPressed === 'Enter' || keyPressed === 13 || keyPressed === 32 || keyPressed === '') {
	                if (evt.target && evt.target.firstElementChild && evt.target.firstElementChild.href) {
	                    window.location.href = evt.target.firstElementChild.href;
	                }
	            }
	        },
	        hideoverlay: function hideoverlay() {
	            if (window.minibagOpenFlag === 'true') {
	                var hide = this.hide.bind(this);
	                hide();
	            }
	        },
	        /* shift+tab to bag icon */
	
	        minibagfocushideOverlay: function minibagfocushideOverlay() {
	            var hide = this.hide.bind(this);
	            if (window.minibagOpenFlag === 'true') {
	                hide();
	            }
	        },
	
	        /* When User click Esc key */
	        escapeKeyTab: function escapeKeyTab(evt) {
	            var keyPressed = evt.key || evt.keyCode,
	                self = this,
	                hide = this.hide.bind(this);
	
	            if (keyPressed === 'Escape' || keyPressed === 27) {
	                hide();
	                self.target.nextElementSibling.focus();
	            }
	        },
	        /**
	         * Stick dock overlay visible if overlay itself hovered
	         */
	        stick: function stick() {
	
	            if (!this.hideOverlayTimeout) {
	                return false;
	            }
	
	            clearTimeout(this.hideOverlayTimeout);
	            domQ(this.element).addClass(this.options.transitionCss);
	
	            return true;
	        },
	
	        /**
	         * Position overlay by calculating top and left position
	         */
	        position: function position() {
	
	            // force css reading for css animation
	            domQ(this.element).addClass(this.options.displayCss);
	
	            this.element.style.top = this.calcPositionY() + 'px';
	        },
	
	        /**
	         * Returns overlay calculated left position
	         * @returns {Number} X position
	         */
	        calcPositionX: function calcPositionX() {
	            var targetWidth = domQ(this.target).width(),
	                targetOffset = domQ(this.target).offset(),
	                overlayWidth = domQ(this.element).width(),
	                xPos;
	
	            switch (this.options.align.toUpperCase()) {
	                case 'CENTER':
	                    xPos = targetOffset.left + targetWidth - overlayWidth / 2;
	                    break;
	                case 'RIGHT':
	                    xPos = targetOffset.left + targetWidth - overlayWidth;
	                    break;
	                default:
	                    xPos = targetOffset.left;
	            }
	
	            return xPos;
	        },
	
	        /**
	         * Returns overlay calculated top position
	         * @returns {Number} Y position
	         */
	        calcPositionY: function calcPositionY() {
	            var targetHeight = domQ(this.target).height(),
	                targetOffset = domQ(this.target).offset(),
	                overlayHeight = domQ(this.element).height(),
	                yPos;
	
	            switch (this.options.direction.toUpperCase()) {
	                case 'DOWN':
	                    yPos = targetOffset.top + targetHeight;
	                    break;
	                default:
	                    yPos = targetOffset.top - overlayHeight;
	            }
	
	            return yPos;
	        },
	
	        /**
	         * Disable dock overlay by removing disable css class
	         */
	        enable: function enable() {
	            domQ(this.element).removeClass(this.options.disableCss);
	        },
	
	        /**
	         * Disable dock overlay by adding disable css class
	         */
	        disable: function disable() {
	            domQ(this.element).addClass(this.options.disableCss);
	        },
	
	        /**
	         * Executes dock overlay on show init event callbacks
	         */
	        executeOnShowCallbacks: function executeOnShowCallbacks() {
	            this.onShowCallbacks.map(function (callback) {
	                callback();
	            });
	        },
	
	        /**
	         * Executes dock overlay on show init event callbacks
	         */
	        onInitShowEvent: function onInitShowEvent(callback) {
	            var self = this;
	
	            this.onInitShowCallbacks.push(callback);
	
	            return function () {
	                self.onInitShowCallbacks = self.onInitShowCallbacks.filter(function (item) {
	                    return item !== callback;
	                });
	            };
	        },
	
	        /**
	         * Executes dock overlay on show init event callbacks
	         */
	        onShowEvent: function onShowEvent(callback) {
	            var self = this;
	
	            this.onShowCallbacks.push(callback);
	
	            return function () {
	                self.onShowCallbacks = self.onShowCallbacks.filter(function (item) {
	                    return item !== callback;
	                });
	            };
	        }
	    };
	
	    return DockOverlay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(4), __webpack_require__(5), __webpack_require__(3), __webpack_require__(2), __webpack_require__(7), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (domQ, mnsCookieService, breakpoint, utils, config, XhrPromise, analytics) {
	
	    function HeaderLinks(el) {
	        if (el) {
	            this.nav = el.querySelector('nav');
	            this.headerEl = document.getElementById('common-hdr-main');
	            this.signIn = el.querySelector('.navigation-res-nav-header__item--login');
	            this.signUp = el.querySelector('.navigation-res-nav-header__item--register');
	            this.signInLink = el.querySelector('.navigation-res-nav-header__login-link');
	            this.signInLoginLink = el.querySelector('.navigation-signin-login-link');
	            this.myAccount = el.querySelector('.navigation-res-nav-header__item--myaccount');
	            this.welcomeMessage = el.querySelector('.navigation-header__welcome');
	            this.atwelcomediv = document.querySelector('.dashboardwelcometext');
	            this.tabletCheckout = el.querySelector('.navigation-res-nav-header__item--checkout');
	            this.viewBagCount = el.querySelector('.navigation-nav-header__bag-count');
	            this.help = el.querySelector('.help');
	            this.signoutIcon = el.querySelector('.navigation-primary__menu-icon__account.navigation-icon-signout');
	            this.countrySelectorDesktop = el.querySelector('.navigation-res-nav-header__icon--country');
	            this.countrySelectorMobile = document.querySelector('.navigation-mobile-country-header');
	            this.finalLinkMobile = document.querySelector('.navigation-country-mobile--link');
	            this.countryDomMobile = document.querySelector('.navigation-country-mobile--country-list');
	            this.languageDomMobile = document.querySelector('.navigation-country-mobile--language-list');
	            this.countryDom = el.querySelector('.navigation-country-overlay--country-list');
	            this.languageDom = el.querySelector('.navigation-country-overlay--language-list');
	            this.finalLink = el.querySelector('.navigation-country-overlay--link');
	            this.storeLocatorIcon = el.querySelector('.navigation-res-nav-header__icon--location');
	            this.storeLocatorItem = el.querySelector('.navigation-res-nav-header__item--location');
	            this.logo = el.querySelector('.navigation-logo');
	            this.headerSearchTypeDirect = el.querySelector('.navigation-search-bar--submit');
	            this.headerNewcollapsedSearch = el.querySelector('.navigation-search_analytics');
	            this.headerNewExposedSearch = el.querySelector('.navigation-exposed_search_analytics');
	            this.bottomSparksLink = document.querySelector('.navigation-pane-one-navbottom .navigation-sparks-analytics a');
	            this.bottomSparksLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-sparks-analytics a');
	            this.bottomMyAccountLink = document.querySelector('.navigation-pane-one-navbottom .navigation-myaccount-analytics a');
	            this.bottomMyAccountPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-myaccount-analytics a');
	            this.bottomHelpLink = document.querySelector('.navigation-pane-one-navbottom .navigation-bottom-help-analytics');
	            this.bottomHelpLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-bottom-help-analytics');
	            this.bottomContactUs = document.querySelector('.navigation-pane-one-navbottom .navigation-bottom-contactus');
	            this.bottomContactUsPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-bottom-contactus');
	            this.bottomSignOutLink = document.querySelector('.navigation-pane-one-navbottom .navigation-signout-register a');
	            this.bottomSignOutLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-signout-register a');
	            this.bottomRegisterLink = document.querySelector('.navigation-pane-one-navbottom .navigation-register-analytics a');
	            this.bottomRegisterLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-register-analytics a');
	            this.bottomFindaStoreLink = document.querySelector('.navigation-pane-one-navbottom .navigation-find-store-analytics a');
	            this.bottomFindaStoreLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-find-store-analytics a');
	            this.hamburgerEl = document.querySelector('.navigation-res-nav-header__item--menu');
	            this.backBarLink = document.querySelector('.navigation-submenu__back-bar-link');
	        }
	    }
	    HeaderLinks.prototype = {
	        /**
	         * Show header navigation
	         */
	        show: function show() {
	            this.toggleLoginLink();
	            this.toggleCheckoutLink();
	            this.updateViewBagCount();
	            this.redirectSignInLink();
	            domQ(this.nav).removeClass('navigation-top-links--hidden');
	            this.bindHeaderLinkEvents();
	            if (this.getUserSegmentSearchSwitch() && mnsCookieService.isUserLoggedIn() && !mnsCookieService.getUserSegmentCookieValue()) {
	                this.loadUserSegment();
	            }
	        },
	
	        /**
	         * user segment feature switch
	         */
	        getUserSegmentSearchSwitch: function getUserSegmentSearchSwitch() {
	            if (typeof window.userSegmentSearchEnabled !== 'undefined') {
	                return window.userSegmentSearchEnabled;
	            }
	        },
	
	        /**
	         * user segment cookie gets dropped if user is logged in
	         */
	        loadUserSegment: function loadUserSegment() {
	            var localStorage = window.localStorage;
	            var xhrp = new XhrPromise();
	            return xhrp.send({
	                url: config.wcsBaseUrl + '/MSUserSegment?storeId=' + config.storeId + '&catalogId=' + config.catalogId,
	                method: 'GET'
	            }).then(function (response) {
	                if (response.status === 200) {
	                    localStorage.setItem('userSegmentSearch', response.responseText.userSegmentSearch);
	                }
	            }).catch(function () {
	                //Handle errors here
	            });
	        },
	
	        /**
	         * toggle header sign-in, register and my account links
	         */
	        toggleLoginLink: function toggleLoginLink() {
	            var welcomeMsg;
	
	            if (mnsCookieService.isUserLoggedIn()) {
	
	                // toggle my account links
	                domQ(this.myAccount).removeClass('navigation-res-nav-header__item--hidden');
	                domQ(this.welcomeMessage).removeClass('navigation-res-nav-header__item--hidden');
	                // set welcome message
	                welcomeMsg = mnsCookieService.getUsername();
	                domQ(this.welcomeMessage).text(welcomeMsg);
	            } else {
	                // toggle signin / register links
	                domQ(this.signIn).removeClass('navigation-res-nav-header__item--hidden');
	            }
	        },
	
	        /**
	         * toggle tablet checkout links
	         */
	        toggleCheckoutLink: function toggleCheckoutLink() {
	            if (breakpoint.size() === 'small' && mnsCookieService.getBasketSizeCookieValue() > 0) {
	                domQ(this.tabletCheckout).removeClass('navigation-res-nav-header__item--hidden');
	            }
	        },
	
	        /**
	         * Updates view count DOM content based on basket size cookie
	         */
	        updateViewBagCount: function updateViewBagCount() {
	            var bagCount = mnsCookieService.getBasketSizeCookieValue();
	            domQ(this.viewBagCount).text(bagCount);
	        },
	
	        /**
	         * Bind click event to sign in link to redirect to target
	         * url appended with source url
	         */
	        redirectSignInLink: function redirectSignInLink() {
	            this.signInLink.addEventListener('click', this.redirectSignInLinkSetup);
	            this.signInLoginLink.addEventListener('click', this.redirectSignInLinkSetup);
	        },
	
	        redirectSignInLinkSetup: function redirectSignInLinkSetup(e) {
	            e.preventDefault();
	            window.location.href = utils.appendSourceUrl(this.getAttribute('href'), window.location.href);
	        },
	        /**
	         * Bind header links analytics events
	         */
	        bindHeaderLinkEvents: function bindHeaderLinkEvents() {
	            window.analyticsNavCountryLanguage = 'English';
	            window.analyticsNavCountryName = config.storeId === '10451' ? 'IE' : 'GB';
	            // Bind click event to M&S logo link on header
	            analytics.bind(this.logo, [{
	                functionName: 'analyticsHeaderLinkTracking',
	                event: 'click',
	                data: 'header: logo'
	            }]);
	            // Bind 'click' event to 'HELP' link on header
	            analytics.bind(this.help, [{
	                functionName: 'analyticsHeaderLinkTracking',
	                event: 'click',
	                data: 'header: help'
	            }]);
	            // Bind 'click' event to 'REGISTER' link on header
	            if (this.signUp) {
	                analytics.bind(this.signUp, [{
	                    functionName: 'analyticsHeaderLinkTracking',
	                    event: 'click',
	                    data: 'header: register'
	                }]);
	            }
	            // Bind 'click' event in country selection dropdown links in header
	            if (this.countrySelectorDesktop) {
	                analytics.bind(this.countrySelectorDesktop, [{
	                    functionName: 'analyticsYourCountrySelectionNav',
	                    event: 'click'
	                }]);
	            }
	            if (this.countrySelectorMobile) {
	                analytics.bind(this.countrySelectorMobile, [{
	                    functionName: 'analyticsYourCountrySelectionNav',
	                    event: 'click'
	                }]);
	            }
	            // Bind 'change' event in country selection dropdown links in header
	            analytics.bind(this.countryDomMobile, [{
	                functionName: 'analyticsYourCountryChange',
	                event: 'change'
	            }]);
	            analytics.bind(this.languageDomMobile, [{
	                functionName: 'analyticsYourCountryLanguageChange',
	                event: 'change'
	            }]);
	            analytics.bind(this.countryDom, [{
	                functionName: 'analyticsYourCountryChangeDesktop',
	                event: 'change'
	            }]);
	            analytics.bind(this.languageDom, [{
	                functionName: 'analyticsYourCountryLanguageChangeDesktop',
	                event: 'change'
	            }]);
	            analytics.bind(this.finalLinkMobile, [{
	                functionName: 'analyticsYourCountrySumbit',
	                event: 'click'
	            }]);
	            analytics.bind(this.finalLink, [{
	                functionName: 'analyticsYourCountrySumbit',
	                event: 'click'
	            }]);
	            // Bind 'click' event in store locator icon
	            analytics.bind(this.storeLocatorIcon, [{
	                functionName: 'analyticsHeaderLinkTracking',
	                event: 'click',
	                data: 'header: store locater'
	            }]);
	            // Bind 'click' event in store locator item
	            analytics.bind(this.storeLocatorItem, [{
	                functionName: 'analyticsHeaderLinkTracking',
	                event: 'click',
	                data: 'header: store locater'
	            }]);
	            // Bind 'click' event in search button in header
	            analytics.bind(this.headerSearchTypeDirect, [{
	                functionName: 'analyticsHeaderSearchTypeDirect',
	                event: 'click'
	            }]);
	            // Bind 'click' event in burger menu button in header
	            if (this.hamburgerEl) {
	                analytics.bind(this.hamburgerEl, [{
	                    functionName: 'analyticsOpenBurgerMenu',
	                    event: 'click'
	                }]);
	            }
	            if (this.backBarLink) {
	                analytics.bind(this.backBarLink, [{
	                    functionName: 'analyticsBackToDepartment',
	                    event: 'click'
	                }]);
	            }
	            // Bind 'click' event in collapsed search icon in header for analytics
	            if (this.headerNewcollapsedSearch) {
	                analytics.bind(this.headerNewcollapsedSearch, [{
	                    functionName: 'analyticsheaderNewsearch',
	                    event: 'click'
	                }]);
	            }
	            // Bind 'click' event in exposed search icon in header for analytics
	            if (this.headerNewExposedSearch) {
	                analytics.bind(this.headerNewExposedSearch, [{
	                    functionName: 'analyticsheaderNewsearch',
	                    event: 'click'
	                }]);
	            }
	            // Bind 'click' event in Sparks link in mobile pane1
	            if (this.bottomSparksLink) {
	                this.bottomSparksLink.addEventListener('click', this.analyticsBottomsparksLink);
	            }
	            // Bind 'click' event in Sparks link in mobile pane2
	            if (this.bottomSparksLinkPaneTwo) {
	                this.bottomSparksLinkPaneTwo.addEventListener('click', this.analyticsBottomsparksLink);
	            }
	            // Bind 'click' event in myAccount pane1
	            if (this.bottomMyAccountLink) {
	                this.bottomMyAccountLink.addEventListener('click', this.analyticsBottomMyAccountLink);
	            }
	            // Bind 'click' event in myAccount pane2
	            if (this.bottomMyAccountPaneTwo) {
	                this.bottomMyAccountPaneTwo.addEventListener('click', this.analyticsBottomMyAccountLink);
	            }
	            // Bind 'click' event in help link pane1
	            if (this.bottomHelpLink) {
	                this.bottomHelpLink.addEventListener('click', this.analyticsbottomHelpLink);
	            }
	            // Bind 'click' event in help link pane2
	            if (this.bottomHelpLinkPaneTwo) {
	                this.bottomHelpLinkPaneTwo.addEventListener('click', this.analyticsbottomHelpLink);
	            }
	            // Bind 'click' event in contactUs link pane1
	            if (this.bottomContactUs) {
	                this.bottomContactUs.addEventListener('click', this.analyticsbottomContactUsLink);
	            }
	            // Bind 'click' event in contactUs link pane2
	            if (this.bottomContactUsPaneTwo) {
	                this.bottomContactUsPaneTwo.addEventListener('click', this.analyticsbottomContactUsLink);
	            }
	            // Bind 'click' event in signOut link pane1
	            if (this.bottomSignOutLink) {
	                this.bottomSignOutLink.addEventListener('click', this.analyticsbottomSignOutLink);
	            }
	            // Bind 'click' event in signOut link pane2
	            if (this.bottomSignOutLinkPaneTwo) {
	                this.bottomSignOutLinkPaneTwo.addEventListener('click', this.analyticsbottomSignOutLink);
	            }
	            if (this.signoutIcon) {
	                this.signoutIcon.parentElement.addEventListener('click', this.analyticsbottomSignOutLink);
	            }
	            // Bind 'click' event in Register link pane1
	            if (this.bottomRegisterLink) {
	                this.bottomRegisterLink.addEventListener('click', this.analyticsbottomRegisterLink);
	            }
	            // Bind 'click' event in Register link pane2
	            if (this.bottomRegisterLinkPaneTwo) {
	                this.bottomRegisterLinkPaneTwo.addEventListener('click', this.analyticsbottomRegisterLink);
	            }
	            // Bind 'click' event in Find A Store  link in mobile pane1
	            if (this.bottomFindaStoreLink) {
	                this.bottomFindaStoreLink.addEventListener('click', this.analyticsBottomFindaStoreLink);
	            }
	            // Bind 'click' event in Find A Store  link in mobile pane2
	            if (this.bottomFindaStoreLinkPaneTwo) {
	                this.bottomFindaStoreLinkPaneTwo.addEventListener('click', this.analyticsBottomFindaStoreLink);
	            }
	        },
	
	        //Tracks the click of Sparks button from header on mobile nav
	        analyticsBottomsparksLink: function analyticsBottomsparksLink(evt) {
	            var element = evt.target;
	            var newhref = element.dataset.href;
	            if (element) {
	                // strip out existing intid query or hash parameter
	                if (element.dataset.href.indexOf('intid') > -1) {
	                    newhref = element.dataset.href.split('?intid')[0].split('&intid')[0].split('#intid')[0];
	                    if (element.dataset.href.split('intid')[1].indexOf('&') > -1) {
	                        newhref = newhref + (newhref.indexOf('?') === -1 ? '?' : '&') + element.dataset.href.split('intid')[1].split('&').splice(1).join('&');
	                    }
	                } else {
	                    newhref = element.dataset.href;
	                }
	                // append #intid tracking code
	                element.href = newhref + '#intid=gnav_mob_sparks_sticky';
	            }
	        },
	
	        //Tracks the click of help button from header on mobile nav
	        analyticsbottomHelpLink: function analyticsbottomHelpLink(evt) {
	            var element = evt.target;
	            if (element) {
	                element.href = element.dataset.href + '?intid=gnav_mob_help_sticky';
	            }
	        },
	
	        //Tracks the click of Contact Us button from header on mobile nav
	        analyticsbottomContactUsLink: function analyticsbottomContactUsLink(evt) {
	            var element = evt.target;
	            if (element) {
	                element.href = element.dataset.href + '?intid=gnav_mob_contact-us_sticky';
	            }
	        },
	
	        //Tracks the click of Sign Out button from header on mobile nav
	        analyticsbottomSignOutLink: function analyticsbottomSignOutLink() {
	            window.sessionStorage.setItem('aa_account_action', 'myaccount:sign out');
	        },
	
	        //Tracks the click of Register button from header on mobile nav
	        analyticsbottomRegisterLink: function analyticsbottomRegisterLink(evt) {
	            var element = evt.target;
	            if (element) {
	                element.href = element.dataset.href + '&intid=gnav_mob_register_sticky';
	            }
	        },
	        //Tracks the click of Find A Store button from header on mobile nav
	        analyticsBottomFindaStoreLink: function analyticsBottomFindaStoreLink(evt) {
	            var element = evt.target;
	            if (element) {
	                if (element.href.indexOf('&intid') === -1) {
	                    element.href = element.href + '&intid=gnav_mob_find-a-store_sticky';
	                } else if (element.href.split('&intid')[0] !== null) {
	                    element.href = element.href.split('&intid')[0] + '&intid=gnav_mob_find-a-store_sticky';
	                }
	            }
	        }
	
	    };
	
	    return HeaderLinks;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        /*eslint-disable*/
	        init: function init() {
	            this.dashboard_housing = this.dashboard_housing.bind(this);
	            this.flikerless = this.flikerless.bind(this);
	            this.timer = window.setInterval(this.flikerless, 500);
	            this.counter = 0;
	        },
	        flikerless: function flikerless() {
	            this.counter = this.counter + 1;
	            if (document.querySelector('.execute_dashboard')) {
	                this.dashboard_housing();
	                window.clearInterval(this.timer);
	            }
	            if (this.counter === 16) {
	                window.clearInterval(this.timer);
	            }
	        },
	        dashboard_housing: function dashboard_housing() {
	            /* slight timeout function delay to allow for the user cookie data to be read by the browser*/
	            setTimeout(function () {
	                if (document.querySelector("[class*='show_dashboard'")) {
	                    /* console.log('IF statement check - if at least one of the cards is ready to show, the script will continue - dashboard housing');
	                    create #home_dashboard as a variable  */
	                    var home_dashboard = document.querySelector('#home_dashboard');
	                    home_dashboard.classList.remove('hide');
	                    /* create .page__site-stripe as a variable*/
	                    var page__site_stripe = window.NavDashboardPos ? window.NavDashboardPos : document.querySelector('.page__site-stripe');
	                    page__site_stripe = page__site_stripe ? page__site_stripe : document.querySelector('.promo-strip');
	                    var pageType = document.querySelector('#pageType');
	                    if (!page__site_stripe && pageType && pageType.innerText && pageType.innerText.trim() === 'PDP') {
	                        page__site_stripe = document.querySelector('.header.navigation-common-hdr-main ~ .row');
	                    }
	                    if (page__site_stripe) {
	                        /* moves #home_dashboard into .page__site-stripe*/
	                        page__site_stripe.after(home_dashboard);
	                    }
	
	                    /* tales the users name/welcome message and stores into a variable*/
	                    var user_first_name = document.querySelector('#userNameText').textContent;
	                    /* places the welcome message into an element*/
	                    var welcome_message = document.querySelector('.navigation-welcome_message');
	                    welcome_message.textContent = 'Welcome back, ' + user_first_name;
	                    /* reveals the homepage dashboard block*/
	                    setTimeout(function () {
	                        home_dashboard.classList.add('navigation-reveal_home_dashboard');
	                    }, 1000);
	                    /* necessary functions/steps to make the dashboard smoothly transition into the canvas due to the way that Target loads late*/
	                    setTimeout(function () {
	                        var white_mask = document.querySelector('.white_mask');
	                        white_mask.classList.add('remove_white_mask');
	                        home_dashboard.classList.add('lift_home_dashboard');
	                        welcome_message.classList.add('welcome_message_reveal');
	                    }, 1250);
	                    /* dashboard bug fix*/
	                    setTimeout(function () {
	                        var svg_bug_fix = document.querySelector('#home_dashboard .inner ul li svg');
	                        svg_bug_fix.classList.add('relative');
	                    }, 1500);
	                } /* else { console.log('Neither of the dashboard cards are qualified for the user - dashboard housing'); }*/
	            }, 1);
	
	            /* moves #dashboard_sparks_card into #dashboard_offers*/
	            setTimeout(function () {
	                var dashboard_offers = document.querySelector('#dashboard_offers');
	                var dashboard_sparks_card = document.querySelector('#dashboard_sparks_card');
	                var close_sparks_card = document.querySelector('#close_sparks_card');
	                if (dashboard_offers && dashboard_sparks_card && close_sparks_card) {
	                    dashboard_offers.insertBefore(dashboard_sparks_card, close_sparks_card);
	                    dashboard_sparks_card.classList.add('show_important');
	                }
	            }, 500);
	            /* moves #dashboard_basket_btn into #dashboard_basket*/
	            setTimeout(function () {
	                var dashboard_basket = document.querySelector('#dashboard_basket');
	                var dashboard_basket_card = document.querySelector('#dashboard_basket_btn');
	                var close_basket_card = document.querySelector('#close_basket_card');
	                if (dashboard_basket && dashboard_basket_card && close_basket_card) {
	                    dashboard_basket.insertBefore(dashboard_basket_card, close_basket_card);
	                    dashboard_basket_card.classList.add('show_important');
	                }
	            }, 500);
	            /* moves #dashboard_app_download_card into #dashboard_app_download*/
	            setTimeout(function () {
	                if ('#dashboard_app_download_card') {
	                    /* console.log('#dashboard_app_download_card is present and will now be moved into the dashboard housing');*/
	                    var dashboard_app_download = document.querySelector('#dashboard_app_download');
	                    var dashboard_app_download_card = document.querySelector('#dashboard_app_download_card');
	                    var close_app_download_card = document.querySelector('#close_app_download_card');
	                    if (dashboard_app_download && dashboard_app_download_card && close_app_download_card) {
	                        dashboard_app_download.insertBefore(dashboard_app_download_card, close_app_download_card);
	                        dashboard_app_download_card.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_four_card into #dashboard_item_four*/
	            setTimeout(function () {
	                if ('#dashboard_card_four') {
	                    /* console.log('#dashboard_card_four is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_four = document.querySelector('#dashboard_item_four');
	                    var dashboard_card_four = document.querySelector('#dashboard_card_four');
	                    var close_dashboard_item_four = document.querySelector('#close_dashboard_item_four');
	
	                    if (dashboard_item_four && dashboard_card_four && close_dashboard_item_four) {
	                        dashboard_item_four.insertBefore(dashboard_card_four, close_dashboard_item_four);
	                        dashboard_card_four.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_five_card into #dashboard_item_five*/
	            setTimeout(function () {
	                if ('#dashboard_card_five') {
	                    /*console.log('#dashboard_card_five is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_five = document.querySelector('#dashboard_item_five');
	                    var dashboard_card_five = document.querySelector('#dashboard_card_five');
	                    var close_dashboard_item_five = document.querySelector('#close_dashboard_item_five');
	                    if (dashboard_item_five && dashboard_card_five && close_dashboard_item_five) {
	                        dashboard_item_five.insertBefore(dashboard_card_five, close_dashboard_item_five);
	                        dashboard_card_five.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_six_card into #dashboard_item_six*/
	            setTimeout(function () {
	                if ('#dashboard_card_six') {
	                    /*console.log('#dashboard_card_six is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_six = document.querySelector('#dashboard_item_six');
	                    var dashboard_card_six = document.querySelector('#dashboard_card_six');
	                    var close_dashboard_item_six = document.querySelector('#close_dashboard_item_six');
	                    if (dashboard_item_six && dashboard_card_six && close_dashboard_item_six) {
	                        dashboard_item_six.insertBefore(dashboard_card_six, close_dashboard_item_six);
	                        dashboard_card_six.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_seven_card into #dashboard_item_seven*/
	            setTimeout(function () {
	                if ('#dashboard_card_seven') {
	                    /*console.log('#dashboard_card_seven is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_seven = document.querySelector('#dashboard_item_seven');
	                    var dashboard_card_seven = document.querySelector('#dashboard_card_seven');
	                    var close_dashboard_item_seven = document.querySelector('#close_dashboard_item_seven');
	                    if (dashboard_item_seven && dashboard_card_seven && close_dashboard_item_seven) {
	                        dashboard_item_seven.insertBefore(dashboard_card_seven, close_dashboard_item_seven);
	                        dashboard_card_seven.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_eight_card into #dashboard_item_eight*/
	            setTimeout(function () {
	                if ('#dashboard_card_eight') {
	                    /*console.log('#dashboard_card_eight is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_eight = document.querySelector('#dashboard_item_eight');
	                    var dashboard_card_eight = document.querySelector('#dashboard_card_eight');
	                    var close_dashboard_item_eight = document.querySelector('#close_dashboard_item_eight');
	                    if (dashboard_item_eight && dashboard_card_eight && close_dashboard_item_eight) {
	                        dashboard_item_eight.insertBefore(dashboard_card_eight, close_dashboard_item_eight);
	                        dashboard_card_eight.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_nine_card into #dashboard_item_nine*/
	            setTimeout(function () {
	                if ('#dashboard_card_nine') {
	                    /*console.log('#dashboard_card_nine is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_nine = document.querySelector('#dashboard_item_nine');
	                    var dashboard_card_nine = document.querySelector('#dashboard_card_nine');
	                    var close_dashboard_item_nine = document.querySelector('#close_dashboard_item_nine');
	                    if (dashboard_item_nine && dashboard_card_nine && close_dashboard_item_nine) {
	                        dashboard_item_nine.insertBefore(dashboard_card_nine, close_dashboard_item_nine);
	                        dashboard_card_nine.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_ten_card into #dashboard_item_ten*/
	            setTimeout(function () {
	                if ('#dashboard_card_ten') {
	                    /*console.log('#dashboard_card_ten is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_ten = document.querySelector('#dashboard_item_ten');
	                    var dashboard_card_ten = document.querySelector('#dashboard_card_ten');
	                    var close_dashboard_item_ten = document.querySelector('#close_dashboard_item_ten');
	                    if (dashboard_item_ten && dashboard_card_ten && close_dashboard_item_ten) {
	                        dashboard_item_ten.insertBefore(dashboard_card_ten, close_dashboard_item_ten);
	                        dashboard_card_ten.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_eleven_card into #dashboard_item_eleven*/
	            setTimeout(function () {
	                if ('#dashboard_card_eleven') {
	                    /*console.log('#dashboard_card_eleven is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_eleven = document.querySelector('#dashboard_item_eleven');
	                    var dashboard_card_eleven = document.querySelector('#dashboard_card_eleven');
	                    var close_dashboard_item_eleven = document.querySelector('#close_dashboard_item_eleven');
	                    if (dashboard_item_eleven && dashboard_card_eleven) {
	                        dashboard_item_eleven.insertBefore(dashboard_card_eleven, close_dashboard_item_eleven);
	                        dashboard_card_eleven.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_twelve_card into #dashboard_item_twelve*/
	            setTimeout(function () {
	                if ('#dashboard_card_twelve') {
	                    /*console.log('#dashboard_card_twelve is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_twelve = document.querySelector('#dashboard_item_twelve');
	                    var dashboard_card_twelve = document.querySelector('#dashboard_card_twelve');
	                    var close_dashboard_item_twelve = document.querySelector('#close_dashboard_item_twelve');
	                    if (dashboard_item_twelve && dashboard_card_twelve && close_dashboard_item_twelve) {
	                        dashboard_item_twelve.insertBefore(dashboard_card_twelve, close_dashboard_item_twelve);
	                        dashboard_card_twelve.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_thirteen_card into #dashboard_item_thirteen*/
	            setTimeout(function () {
	                if ('#dashboard_card_thirteen') {
	                    /*console.log('#dashboard_card_thirteen is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_thirteen = document.querySelector('#dashboard_item_thirteen');
	                    var dashboard_card_thirteen = document.querySelector('#dashboard_card_thirteen');
	                    var close_dashboard_item_thirteen = document.querySelector('#close_dashboard_item_thirteen');
	                    if (dashboard_item_thirteen && dashboard_card_thirteen) {
	                        dashboard_item_thirteen.insertBefore(dashboard_card_thirteen, close_dashboard_item_thirteen);
	                        dashboard_card_thirteen.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_fourteen_card into #dashboard_item_fourteen*/
	            setTimeout(function () {
	                if ('#dashboard_card_fourteen') {
	                    /*console.log('#dashboard_card_fourteen is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_fourteen = document.querySelector('#dashboard_item_fourteen');
	                    var dashboard_card_fourteen = document.querySelector('#dashboard_card_fourteen');
	                    var close_dashboard_item_fourteen = document.querySelector('#close_dashboard_item_fourteen');
	                    if (dashboard_item_fourteen && dashboard_card_fourteen) {
	                        dashboard_item_fourteen.insertBefore(dashboard_card_fourteen, close_dashboard_item_fourteen);
	                        dashboard_card_fourteen.classList.add('show_important');
	                    }
	                }
	            }, 500);
	            /* moves #dashboard_card_fifteen_card into #dashboard_item_fifteen*/
	            setTimeout(function () {
	                if ('#dashboard_card_fifteen') {
	                    /*console.log('#dashboard_card_fifteen is present and will now be moved into the dashboard housing');*/
	                    var dashboard_item_fifteen = document.querySelector('#dashboard_item_fifteen');
	                    var dashboard_card_fifteen = document.querySelector('#dashboard_card_fifteen');
	                    var close_dashboard_item_fifteen = document.querySelector('#close_dashboard_item_fifteen');
	                    if (dashboard_item_fifteen && dashboard_card_fifteen) {
	                        dashboard_item_fifteen.insertBefore(dashboard_card_fifteen, close_dashboard_item_fifteen);
	                        dashboard_card_fifteen.classList.add('show_important');
	                    }
	                }
	            }, 500);
	        }
	
	        /*eslint-enable*/
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = function (XhrPromise) {
	
	    var changeListeners = [];
	
	    /**
	     * Add basket update callbacks
	     * @param {Function} callback Callback method
	     */
	    function onChange(callback) {
	        changeListeners.push(callback);
	    }
	
	    /**
	     * Initiate request to load basket detail
	     */
	    function load(miniBagCMD, requestParams) {
	        var xhrp = new XhrPromise();
	        return xhrp.send({
	            url: miniBagCMD,
	            method: 'POST',
	            body: _extends({ resJSON: true }, {
	                requestParams: requestParams
	            })
	        }).then(function (response) {
	            if (response.status === 200) {
	                update(response.responseText);
	            }
	        }).catch(function () {
	            //Handle errors here
	        });
	    }
	
	    function removeItem(removeUrl) {
	        var xhrp = new XhrPromise();
	        return xhrp.send({
	            url: removeUrl,
	            method: 'POST'
	        }).then(function () {}).catch(function () {
	            //Handle errors here
	        });
	    }
	
	    /**
	     * Execute basket update callback list
	     * @param {Object} data Basket details
	     */
	    function update(data) {
	        changeListeners.map(function (callback) {
	            callback(data);
	        });
	    }
	
	    // service API
	    return {
	        load: load,
	        onChange: onChange,
	        removeItem: removeItem
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(1), __webpack_require__(2), __webpack_require__(6), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (TopNavDropdown, domQ, config, constant, countryLinkDropDown) {
	
	    var TOUCH_START = 'touchstart',
	        BAGLABEL1 = 'Shopping bag with ',
	        BAGLABEL2 = ' items',
	        DEFAULT_L1ARIA = 'Sub menu. Button collapsed.',
	        PREVENT_SCROLLING = 'navigation-prevent-scrolling';
	
	    function DesktopDevice(level2, level3) {
	        this.level2 = level2;
	        this.level3 = level3;
	        this.menuOverFlag = false;
	        this.panelOverFlag = false;
	        this.myaccountFlag = false;
	        this.signInFlag = false;
	        this.bodyEl = document.querySelector('body');
	        this.closeButtonList = document.querySelectorAll('.nav-submenu__close-button');
	        this.searchButtonReset = document.querySelector('.navigation-search-bar--clear');
	        this.searchOverlayClose = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear');
	        this.searchiconButton = document.querySelector('.navigation-search-bar--submit');
	        this.searchBarSuggession = document.querySelector('.navigation-search-bar--suggestion-dropdown');
	        this.menuOver = this.menuOver.bind(this);
	        this.menuAccKeyup = this.menuAccKeyup.bind(this);
	        this.menuOut = this.menuOut.bind(this);
	        this.panelOver = this.panelOver.bind(this);
	        this.panelOut = this.panelOut.bind(this);
	        this.setMenuTabindex = this.setMenuTabindex.bind(this);
	        this.interactionEvent = 'click';
	        this.myaccbutton = document.querySelector('.navigation-res-nav-header__item--myaccount');
	        this.signInIcon = document.querySelector('.navigation-res-nav-header__item--login');
	        this.signInChevron = document.querySelector('.navigation-accessibility__chevron');
	        this.accountChevron = document.querySelector('.navigation-accessibility__chevron-account');
	        this.countryLink = document.querySelector('.navigation-res-nav-header__icon--country');
	        this.myaccountButton = document.querySelector('.navigation-header__sub-list-container--signacc');
	        this.signInButton = document.querySelector('.navigation-header__signin');
	        this.pageDiv = document.querySelector('.navigation-nav-veil');
	        this.navSection = document.querySelector('.navigation-primary__section');
	        this.signInDropdown = document.querySelector('.navigation-signin-wrapper');
	        this.accountDropdown = document.querySelector('.navigation-signacc-wrapper');
	        this.navPrimaryListEl = document.querySelectorAll('.nav-primary__list li');
	        this.countrySelectorOverlay = document.querySelector('.navigation-country-selector--overlay');
	        this.countrybackgroundOverlay = document.querySelector('.navigation-country-background--overlay');
	        this.countrySelectorClose = document.querySelector('.navigation-country-overlay--close');
	        this.bagElementUrl = document.querySelector('.navigation-res-nav-header__item--bag a');
	        this.miniBagWithItemUrl = this.bagElementUrl.getAttribute('data-href');
	        this.gotoCountryLink = document.querySelector('.navigation-country-overlay--link');
	        this.firstNavLinkEl = this.navPrimaryListEl[0] && this.navPrimaryListEl[0].classList.contains('.nav-primary-inspire-me') ? this.navPrimaryListEl[1] : this.navPrimaryListEl[0];
	        this.headerEl = document.getElementById('common-hdr-main');
	        this.focusElement = document.querySelectorAll('.nav-primary__list a');
	        this.signInElements = document.querySelectorAll('.navigation-header__sub-list.navigation-header__sub-list--signin');
	        this.MyAccountElements = document.querySelectorAll('.navigation-header__sub-list.navigation-header__sub-list--my-account');
	        this.countryOverlayExitSpan = document.querySelector('.navigation-country-overlay-exit');
	        this.searchButtonResetClick = this.searchButtonResetClick.bind(this);
	        this.closeCountryOverlayForDefault = this.closeCountryOverlayForDefault.bind(this);
	        this.myaccountButtonClick = this.myaccountButtonClick.bind(this);
	        this.myaccountButtonClickOut = this.myaccountButtonClickOut.bind(this);
	        this.signInButtonClick = this.signInButtonClick.bind(this);
	        this.signInButtonClickOut = this.signInButtonClickOut.bind(this);
	        this.takeToNextLevel1 = this.takeToNextLevel1.bind(this);
	        this.bagCountSet = this.bagCountSet.bind(this);
	        this.countryLinkClick = this.countryLinkClick.bind(this);
	        this.countryOverlayTransEnd = this.countryOverlayTransEnd.bind(this);
	        this.countryLinkKeyUp = this.countryLinkKeyUp.bind(this);
	        this.signInIconKeyUp = this.signInIconKeyUp.bind(this);
	        this.myaccbuttonKeyUp = this.myaccbuttonKeyUp.bind(this);
	        this.myEmptybagDisable = this.myEmptybagDisable.bind(this);
	        this.focusToSubMenuElement = this.focusToSubMenuElement.bind(this);
	        this.takeBacktoL1 = this.takeBacktoL1.bind(this);
	        this.escapeToClose = this.escapeToClose.bind(this);
	        this.tabCloseCountryOverlay = this.tabCloseCountryOverlay.bind(this);
	        //Sign in dropdown links
	        this.signInLinkClick = this.signInLinkClick.bind(this);
	        this.createAccLinkClick = this.createAccLinkClick.bind(this);
	        this.signInSparksLinkClick = this.signInSparksLinkClick.bind(this);
	        //My account dropdown links
	        this.yourOrdersLinkClick = this.yourOrdersLinkClick.bind(this);
	        this.myAccSparksLinkClick = this.myAccSparksLinkClick.bind(this);
	        this.cardsLinkClick = this.cardsLinkClick.bind(this);
	        this.myAccLinkClick = this.myAccLinkClick.bind(this);
	        this.signOutLinkClick = this.signOutLinkClick.bind(this);
	        this.countrySelectorOverlayClose = this.countrySelectorOverlayClose.bind(this);
	        this.countrySelectorOverlayCloseOnResize = this.countrySelectorOverlayCloseOnResize.bind(this);
	
	        this.cardsLinkClickIE = this.cardsLinkClickIE.bind(this);
	        this.myAccLinkClickIE = this.myAccLinkClickIE.bind(this);
	        this.signOutLinkClickIE = this.signOutLinkClickIE.bind(this);
	        this.searchOverlayCloseEvnt = this.searchOverlayCloseEvnt.bind(this);
	    }
	    DesktopDevice.prototype.searchButtonResetClick = function () {
	        domQ(this.searchBarSuggession).addClass('navigation-search-bar--suggestion-dropdown__hidden');
	        // domQ(this.searchiconButton).removeClass('navigation-search-bar--submit__active');
	    };
	
	    DesktopDevice.prototype.myaccountButtonClick = function () {
	        var bagVar = document.querySelector('.navigation-minibag-dock-overlay.navigation-dock-overlay--block.navigation-dock-overlay--transition');
	        if (bagVar) {
	            domQ(bagVar).removeClass('navigation-dock-overlay--block');
	            domQ(bagVar).removeClass('navigation-dock-overlay--transition');
	        }
	        if (!this.myaccountFlag) {
	            this.myaccountFlag = true;
	            domQ(this.accountDropdown).removeClass('navigation-signacc-wrapper-hidden');
	            domQ(this.myaccountButton).addClass('navigation-header__sub-list-container--signacc-displayblock');
	        } else {
	            this.myaccountFlag = false;
	            domQ(this.accountDropdown).addClass('navigation-signacc-wrapper-hidden');
	            domQ(this.myaccountButton).removeClass('navigation-header__sub-list-container--signacc-displayblock');
	        }
	    };
	    DesktopDevice.prototype.signInButtonClick = function () {
	        var bagVar = document.querySelector('.navigation-minibag-dock-overlay.navigation-dock-overlay--block.navigation-dock-overlay--transition');
	        if (bagVar) {
	            domQ(bagVar).removeClass('navigation-dock-overlay--block');
	            domQ(bagVar).removeClass('navigation-dock-overlay--transition');
	        }
	        if (!this.signInFlag) {
	            this.signInFlag = true;
	            domQ(this.signInDropdown).removeClass('navigation-signin-wrapper-hidden');
	            domQ(this.signInButton).addClass('navigation-header__sign-in');
	        } else {
	            this.signInFlag = false;
	            domQ(this.signInDropdown).addClass('navigation-signin-wrapper-hidden');
	            domQ(this.signInButton).removeClass('navigation-header__sign-in');
	        }
	    };
	    DesktopDevice.prototype.signInButtonClickOut = function () {
	        this.signInFlag = false;
	        if (!domQ(document.querySelector('.navigation-signin-wrapper')).hasClass('navigation-signin-wrapper-hidden')) {
	            domQ(this.signInDropdown).addClass('navigation-signin-wrapper-hidden');
	            domQ(this.signInButton).removeClass('navigation-header__sign-in');
	        }
	    };
	    DesktopDevice.prototype.myaccountButtonClickOut = function () {
	        this.myaccountFlag = false;
	        domQ(this.accountDropdown).addClass('navigation-signacc-wrapper-hidden');
	        domQ(this.myaccountButton).removeClass('navigation-header__sub-list-container--signacc-displayblock');
	    };
	    DesktopDevice.prototype.countryLinkClick = function () {
	        countryLinkDropDown.buildDropDown();
	        domQ(this.countrybackgroundOverlay).addClass('navigation-country-overlay-visible');
	        domQ(this.countrySelectorOverlay).addClass('navigation-country-overlay-visible');
	        domQ(this.myaccountButton).removeClass('navigation-header__sub-list-container--signacc-displayblock');
	        domQ(this.pageDiv).removeClass('navigation-is-active-acc');
	        domQ(this.navSection).removeClass('navigation-add-border');
	        this.countrybackgroundOverlay.style.visibility = 'visible';
	        this.countrySelectorOverlay.style.visibility = 'visible';
	        domQ(this.bodyEl).addClass(PREVENT_SCROLLING);
	        this.countrySelectorOverlay.focus();
	    };
	    DesktopDevice.prototype.closeCountryOverlayForDefault = function () {
	        var countryDropdown = document.querySelector('.navigation-country-overlay--country-list');
	        if (countryDropdown && countryDropdown.value === '0') {
	            this.countrySelectorOverlayClose();
	        }
	    };
	
	    DesktopDevice.prototype.countrySelectorOverlayCloseOnResize = function () {
	        domQ(this.bodyEl).removeClass(PREVENT_SCROLLING);
	        domQ(this.countrybackgroundOverlay).removeClass('navigation-country-overlay-visible');
	        domQ(this.countrySelectorOverlay).removeClass('navigation-country-overlay-visible');
	        if (!domQ(this.countrySelectorOverlay).hasClass('navigation-country-overlay-visible')) {
	            this.countrybackgroundOverlay.style.visibility = 'hidden';
	            this.countrySelectorOverlay.style.visibility = 'hidden';
	            countryLinkDropDown.resetDropDown();
	        }
	    };
	    DesktopDevice.prototype.countrySelectorOverlayClose = function () {
	        domQ(this.bodyEl).removeClass(PREVENT_SCROLLING);
	        domQ(this.countrybackgroundOverlay).removeClass('navigation-country-overlay-visible');
	        domQ(this.countrySelectorOverlay).removeClass('navigation-country-overlay-visible');
	    };
	    DesktopDevice.prototype.countryOverlayTransEnd = function () {
	        if (!domQ(this.countrySelectorOverlay).hasClass('navigation-country-overlay-visible')) {
	            this.countrybackgroundOverlay.style.visibility = 'hidden';
	            this.countrySelectorOverlay.style.visibility = 'hidden';
	            countryLinkDropDown.resetDropDown();
	        }
	    };
	    DesktopDevice.prototype.countryLinkKeyUp = function (event) {
	        var keyPressed = event.key || event.keyCode;
	        if (keyPressed === 13 || keyPressed === 'Enter' || keyPressed === 32 || keyPressed === ' ') {
	            this.countryLinkClick();
	            this.countrySelectorOverlay.focus();
	        } else if (domQ(this.countrySelectorOverlay).hasClass('navigation-country-overlay-visible')) {
	            this.countrySelectorOverlayClose();
	            this.countryLink.focus();
	        }
	    };
	    DesktopDevice.prototype.tabCloseCountryOverlay = function (event) {
	        var keyPressed = event.key || event.keyCode;
	        if ((domQ(event.target).hasClass('navigation-country-overlay--link') || domQ(event.target).hasClass('navigation-country-overlay--close')) && (keyPressed === 13 || keyPressed === 'Enter')) {
	            this.countrySelectorOverlayClose();
	            this.countryLink.focus();
	        } else if (domQ(event.target).hasClass('navigation-country-overlay-exit') && (keyPressed === 'Tab' || keyPressed === 9)) {
	            this.countrySelectorOverlayClose();
	            this.countryLink.focus();
	        } else if (keyPressed === 27 || keyPressed === 'Escape') {
	            this.countrySelectorOverlayClose();
	            this.countryLink.focus();
	        }
	    };
	    DesktopDevice.prototype.bind = function () {
	        var _this = this;
	        this.searchButtonReset.addEventListener(this.interactionEvent, this.searchButtonResetClick);
	        this.myaccbutton.addEventListener('mouseover', this.myaccountButtonClick);
	        this.myaccbutton.addEventListener('mouseout', this.myaccountButtonClickOut);
	        this.signInIcon.addEventListener('mouseover', this.signInButtonClick);
	        this.signInIcon.addEventListener('mouseout', this.signInButtonClickOut);
	        this.pageDiv.addEventListener('touchstart', this.level2.checkClickToClose);
	        this.searchOverlayClose.addEventListener('keyup', this.searchOverlayCloseEvnt);
	        this.gotoCountryLink.addEventListener('click', this.closeCountryOverlayForDefault);
	
	        this.countryLink.addEventListener(this.interactionEvent, this.countryLinkClick);
	        this.gotoCountryLink.addEventListener('blur', this.closeCountryOverlayForDefault);
	        this.countrySelectorOverlay.addEventListener('keyup', this.tabCloseCountryOverlay);
	        this.countrybackgroundOverlay.addEventListener(this.interactionEvent, this.countrySelectorOverlayClose);
	        this.countrySelectorClose.addEventListener(this.interactionEvent, this.countrySelectorOverlayClose);
	        this.countrySelectorClose.addEventListener('keyup', this.tabCloseCountryOverlay);
	        this.countryOverlayExitSpan.addEventListener('keyup', this.tabCloseCountryOverlay);
	
	        this.countrySelectorOverlay.addEventListener('transitionend', this.countryOverlayTransEnd);
	        this.countrySelectorOverlay.addEventListener('webkitTransitionEnd', this.countryOverlayTransEnd);
	        this.countrySelectorOverlay.addEventListener('mozTransitionEnd', this.countryOverlayTransEnd);
	        this.countrySelectorOverlay.addEventListener('oTransitionEnd', this.countryOverlayTransEnd);
	        function signInIconEvent() {
	            if (_this.signInFlag) {
	                _this.signInButtonClickOut();
	                _this.signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
	            }
	        }
	
	        function signInIconKeyUpEvent() {
	            var signInIcon = document.querySelector('.navigation-res-nav-header__login-link');
	            signInIcon.addEventListener('keyup', signInIconEvent);
	        }
	
	        function miniBagEvent() {
	            if (_this.signInFlag) {
	                _this.signInButtonClickOut();
	                _this.signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
	            } else if (_this.myaccountFlag) {
	                _this.myaccountButtonClickOut();
	                _this.accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
	            }
	        }
	        var cheveronlist = document.querySelectorAll('.navigation-l1-chervonicon');
	        for (var chevi = 0; chevi < cheveronlist.length; chevi++) {
	            cheveronlist[chevi].setAttribute('aria-expanded', 'false');
	        }
	
	        function signInContainerEvent(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 27 || keyPressed === 'Escape') {
	                if (_this.signInFlag) {
	                    _this.signInButtonClickOut();
	                    _this.signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
	                    _this.signInChevron.focus();
	                }
	            }
	        }
	
	        function siginInChevronEvent(event) {
	            event.preventDefault();
	            _this.signInButtonClick();
	            event.stopPropagation();
	            var signInChevron = document.querySelector('.navigation-accessibility__chevron');
	            if (!domQ(document.querySelector('.navigation-signin-wrapper')).hasClass('navigation-signin-wrapper-hidden')) {
	                signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button expanded');
	                signInChevron.blur();
	                signInChevron.focus();
	            } else {
	                signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
	                signInChevron.blur();
	                signInChevron.focus();
	            }
	            signInIconKeyUpEvent();
	
	            var miniBagLink = document.querySelector('.navigation-header__link');
	            miniBagLink.addEventListener('keyup', miniBagEvent);
	
	            var signInContainer = document.querySelector('.navigation-dropdown__list-container-signin');
	            signInContainer.addEventListener('keyup', signInContainerEvent);
	        }
	
	        function accountIconEvent() {
	            if (_this.myaccountFlag) {
	                _this.myaccountButtonClickOut();
	                _this.accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
	            }
	        }
	
	        function accountIconKeyUpEvent() {
	            var myaccountIcon = document.querySelector('.navigation-res-nav-header__icon--my-account');
	            myaccountIcon.addEventListener('keyup', accountIconEvent);
	        }
	
	        function accountContainerEvent(event) {
	            var keyPressed = event.key || event.keyCode;
	            if (keyPressed === 27 || keyPressed === 'Escape') {
	                if (_this.myaccountFlag) {
	                    _this.myaccountButtonClickOut();
	                    _this.accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
	                    _this.accountChevron.focus();
	                }
	            }
	        }
	
	        function accountChevronEvent(event) {
	
	            event.preventDefault();
	            _this.myaccountButtonClick();
	            event.stopPropagation();
	            var accountChevron = document.querySelector('.navigation-accessibility__chevron-account');
	            if (!domQ(document.querySelector('.navigation-signacc-wrapper')).hasClass('navigation-signacc-wrapper-hidden')) {
	                accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button expanded');
	                accountChevron.blur();
	                accountChevron.focus();
	            } else {
	                accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
	                accountChevron.blur();
	                accountChevron.focus();
	            }
	            accountIconKeyUpEvent();
	
	            var miniBagLink = document.querySelector('.navigation-header__link');
	            miniBagLink.addEventListener('keyup', miniBagEvent);
	
	            var myAccountContainer = document.querySelector('.navigation-dropdown__list-container-myaccount');
	            myAccountContainer.addEventListener('keyup', accountContainerEvent);
	        }
	
	        this.accountChevron.addEventListener('click', accountChevronEvent);
	
	        this.signInChevron.addEventListener('click', siginInChevronEvent);
	        this.bagElementUrl.addEventListener('keyup', this.myEmptybagDisable);
	
	        for (var iListItem = 0; iListItem < this.level2.navPrimaryAList.length; iListItem++) {
	            var aListEl = _this.level2.navPrimaryAList[iListItem];
	            aListEl.addEventListener('mouseover', _this.menuOver);
	            aListEl.addEventListener('mouseout', _this.menuOut);
	            aListEl.addEventListener('keyup', _this.menuOut);
	            aListEl.removeAttribute('aria-expanded');
	            if (aListEl.nextElementSibling) {
	                var lbl = aListEl.nextElementSibling.getAttribute('aria-label');
	                if (lbl === DEFAULT_L1ARIA) {
	                    var elCont = aListEl.innerText + ' ' + lbl;
	                    aListEl.nextElementSibling.setAttribute('aria-label', elCont);
	                }
	                aListEl.nextElementSibling.addEventListener('keyup', _this.menuAccKeyup);
	            }
	        }
	
	        for (var iSubMenuItem = 0; iSubMenuItem < this.level3.navPrimarySubmenuList.length; iSubMenuItem++) {
	            var el = _this.level3.navPrimarySubmenuList[iSubMenuItem];
	            el.addEventListener('mouseover', _this.panelOver);
	            el.addEventListener('mouseout', _this.panelOut);
	        }
	
	        for (var closeButtons = 0, len = _this.closeButtonList.length; closeButtons < len; closeButtons++) {
	            _this.closeButtonList[closeButtons].addEventListener('click', _this.level2.checkClickToClose);
	        }
	
	        _this.bagCountSet();
	        var navLinkList = document.querySelectorAll('.navigation-primary__section>ul>li>a');
	        for (var navLink = 0; navLink < navLinkList.length; navLink++) {
	            navLinkList[navLink].tabIndex = '0';
	            navLinkList[navLink].removeAttribute('aria-expanded');
	        }
	        if (this.signInElements) {
	            this.signInElements[0].addEventListener(TOUCH_START, this.signInLinkClick);
	            this.signInElements[1].addEventListener(TOUCH_START, this.createAccLinkClick);
	            if (config && config.storeId === constant.ukId) {
	                this.signInElements[2].addEventListener(TOUCH_START, this.signInSparksLinkClick);
	            }
	        }
	        if (this.MyAccountElements) {
	            this.MyAccountElements[0].addEventListener(TOUCH_START, this.yourOrdersLinkClick);
	            if (config && config.storeId === constant.ukId) {
	                this.MyAccountElements[1].addEventListener(TOUCH_START, this.myAccSparksLinkClick);
	                this.MyAccountElements[2].addEventListener(TOUCH_START, this.cardsLinkClick);
	                this.MyAccountElements[3].addEventListener(TOUCH_START, this.myAccLinkClick);
	                this.MyAccountElements[4].addEventListener(TOUCH_START, this.signOutLinkClick);
	            } else if (config && config.storeId === constant.ieId) {
	                this.MyAccountElements[1].addEventListener(TOUCH_START, this.cardsLinkClickIE);
	                this.MyAccountElements[2].addEventListener(TOUCH_START, this.myAccLinkClickIE);
	                this.MyAccountElements[3].addEventListener(TOUCH_START, this.signOutLinkClickIE);
	            }
	        }
	    };
	    DesktopDevice.prototype.signInLinkClick = function () {
	        window.location = this.signInElements[0] ? this.signInElements[0].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.createAccLinkClick = function () {
	        window.location = this.signInElements[1] ? this.signInElements[1].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.signInSparksLinkClick = function () {
	        window.location = this.signInElements[2] ? this.signInElements[2].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.yourOrdersLinkClick = function () {
	        window.location = this.MyAccountElements[0] ? this.MyAccountElements[0].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.myAccSparksLinkClick = function () {
	        window.location = this.MyAccountElements[1] ? this.MyAccountElements[1].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.cardsLinkClick = function () {
	        window.location = this.MyAccountElements[2] ? this.MyAccountElements[2].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.myAccLinkClick = function () {
	        window.location = this.MyAccountElements[3] ? this.MyAccountElements[3].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.signOutLinkClick = function () {
	        window.location = this.MyAccountElements[4] ? this.MyAccountElements[4].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.cardsLinkClickIE = function () {
	        window.location = this.MyAccountElements[1] ? this.MyAccountElements[1].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.myAccLinkClickIE = function () {
	        window.location = this.MyAccountElements[2] ? this.MyAccountElements[2].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.signOutLinkClickIE = function () {
	        window.location = this.MyAccountElements[3] ? this.MyAccountElements[3].firstElementChild.href : '';
	    };
	    DesktopDevice.prototype.unbind = function () {
	        var _this = this;
	        this.myaccbutton.removeEventListener('mouseover', this.myaccountButtonClick);
	        this.myaccbutton.removeEventListener('mouseout', this.myaccountButtonClickOut);
	        this.signInIcon.removeEventListener('mouseover', this.signInButtonClick);
	        this.signInIcon.removeEventListener('mouseout', this.signInButtonClickOut);
	
	        for (var iListItem = 0; iListItem < this.level2.navPrimaryAList.length; iListItem++) {
	            var aListEl = _this.level2.navPrimaryAList[iListItem];
	            aListEl.removeEventListener('mouseover', _this.menuOver);
	            aListEl.removeEventListener('mouseout', _this.menuOut);
	            aListEl.removeEventListener('keyup', _this.menuOut);
	        }
	
	        for (var iSubMenuItem = 0; iSubMenuItem < this.level3.navPrimarySubmenuList.length; iSubMenuItem++) {
	            var el = _this.level3.navPrimarySubmenuList[iSubMenuItem];
	            el.removeEventListener('mouseover', _this.panelOver);
	            el.removeEventListener('mouseout', _this.panelOut);
	        }
	
	        for (var closeButtons = 0, len = _this.closeButtonList.length; closeButtons < len; closeButtons++) {
	            _this.closeButtonList[closeButtons].removeEventListener('click', _this.level2.checkClickToClose);
	        }
	
	        clearTimeout(this.timeoutId);
	    };
	    DesktopDevice.prototype.menuOver = function (e) {
	        this.menuOverFlag = true;
	        var _this = this;
	        function timeoutFunc() {
	            if (_this.menuOverFlag) {
	                _this.level2.activate(e.target);
	            }
	        }
	        this.timeoutId = setTimeout(timeoutFunc, 100);
	        TopNavDropdown.close();
	    };
	
	    DesktopDevice.prototype.menuOut = function () {
	        this.menuOverFlag = false;
	        this.deactivate();
	        var tempSpan = document.getElementById('navigation-temp-span');
	        if (tempSpan) {
	            tempSpan.parentElement.removeChild(tempSpan);
	        }
	    };
	    DesktopDevice.prototype.panelOver = function () {
	        this.panelOverFlag = true;
	    };
	    DesktopDevice.prototype.panelOut = function () {
	        this.panelOverFlag = false;
	        this.deactivate();
	    };
	    DesktopDevice.prototype.deactivate = function () {
	        var _this = this;
	        function timeoutFunc() {
	            if (!_this.menuOverFlag && !_this.panelOverFlag) {
	                _this.level2.deactivate();
	            }
	        }
	        this.timeoutId = setTimeout(timeoutFunc, 100);
	    };
	
	    DesktopDevice.prototype.menuAccKeyup = function (event) {
	        var keyPressed = event.key || event.keyCode;
	        var areaLbl = event.target.getAttribute('aria-label');
	        var _this = this;
	        areaLbl = areaLbl.replace('expanded', 'collapsed');
	        event.target.setAttribute('aria-label', areaLbl);
	        if (keyPressed === 13 || keyPressed === 'Enter' || keyPressed === ' ' || keyPressed === 32) {
	            var openMenu = document.querySelector('.navigation-open-submenu');
	            var tempSpan2 = document.getElementById('navigation-temp-span');
	            if (openMenu && tempSpan2) {
	                tempSpan2.parentElement.removeChild(tempSpan2);
	            }
	            if (openMenu) {
	                _this.level2.deactivate();
	                areaLbl = event.target.getAttribute('aria-label');
	                areaLbl = areaLbl.replace('expanded', 'collapsed');
	                event.target.setAttribute('aria-label', areaLbl);
	            } else {
	                _this.menuOverFlag = true;
	                _this.level2.activate(event.target.previousElementSibling);
	                if (!event.target.nextElementSibling) {
	                    var tempSpan = document.createElement('SPAN');
	                    var element = event.target.parentElement;
	                    tempSpan.tabIndex = '0';
	                    tempSpan.id = 'navigation-temp-span';
	                    element.appendChild(tempSpan);
	                    tempSpan.addEventListener('keyup', _this.focusToSubMenuElement);
	                }
	                areaLbl = event.target.getAttribute('aria-label');
	                areaLbl = areaLbl.replace('collapsed', 'expanded');
	                event.target.setAttribute('aria-label', areaLbl);
	                event.target.blur();
	                event.target.focus();
	                TopNavDropdown.close();
	            }
	        }
	    };
	
	    DesktopDevice.prototype.focusToSubMenuElement = function (event) {
	        var backLink = document.querySelector('.navigation-back-accessibility');
	        backLink.tabIndex = '0';
	        backLink.addEventListener('keyup', this.takeBacktoL1);
	        var openMenu = document.querySelector('.navigation-open-submenu');
	        openMenu.addEventListener('keyup', this.escapeToClose);
	        var clickableList = openMenu.querySelectorAll('.nav-submenu__l2-header, .copy div, .nav-submenu__style-and-living div:first-child, a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	        this.setMenuTabindex(clickableList, 0);
	        clickableList[0].focus();
	        var tempHolder = document.querySelector('.navigation-temp-accessibility');
	        tempHolder.style.display = 'block';
	        tempHolder.addEventListener('keyup', this.takeToNextLevel1);
	        var tempSpan = event.target;
	        tempSpan.parentNode.removeChild(tempSpan);
	    };
	
	    DesktopDevice.prototype.takeBacktoL1 = function () {
	        var activeItem = document.querySelector('.nav-primary__menu-link.navigation-is-active');
	        if (activeItem && activeItem.nextElementSibling) {
	            this.menuOverFlag = false;
	            activeItem.nextElementSibling.focus();
	            this.level2.deactivate();
	            var backLink = document.querySelector('.navigation-back-accessibility');
	            backLink.tabIndex = '-1';
	            var tempHolder = document.querySelector('.navigation-temp-accessibility');
	            tempHolder.style.display = 'none';
	            var areaLbl = activeItem.nextElementSibling.getAttribute('aria-label');
	            areaLbl = areaLbl.replace('expanded', 'collapsed');
	            activeItem.nextElementSibling.setAttribute('aria-label', areaLbl);
	        }
	    };
	
	    DesktopDevice.prototype.escapeToClose = function (event) {
	        var keyPressed = event.key || event.keyCode;
	        if (keyPressed === 27 || keyPressed === 'Esc' || keyPressed === 'Escape') {
	            this.takeBacktoL1();
	        }
	    };
	
	    DesktopDevice.prototype.takeToNextLevel1 = function () {
	        var backLink = document.querySelector('.navigation-back-accessibility');
	        backLink.tabIndex = '-1';
	        var currentLi = document.querySelector('li.navigation-is-active');
	        var nextElement = currentLi.nextElementSibling;
	        var initialContentLink = null;
	        var pageContent = this.headerEl ? this.headerEl.nextElementSibling : false;
	        if (pageContent) {
	            initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	            while (pageContent && pageContent !== null && !initialContentLink) {
	                pageContent = pageContent.nextElementSibling;
	                if (pageContent) {
	                    initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
	                }
	            }
	        }
	        if (nextElement && nextElement.classList.contains('nav-primary-inspire-me')) {
	            nextElement = nextElement.nextElementSibling ? nextElement.nextElementSibling : null;
	        }
	        var focusEl = nextElement ? nextElement.firstElementChild : initialContentLink;
	        this.menuOverFlag = false;
	        this.level2.deactivate();
	        var tempHolder = document.querySelector('.navigation-temp-accessibility');
	        tempHolder.style.display = 'none';
	        tempHolder.removeEventListener('keyup', this.takeToNextLevel1);
	        if (focusEl) {
	            focusEl.focus();
	        }
	    };
	
	    DesktopDevice.prototype.setMenuTabindex = function (elList, tabValue) {
	        for (var i = 0; i < elList.length; i++) {
	            elList[i].tabIndex = tabValue;
	        }
	    };
	
	    DesktopDevice.prototype.bagCountSet = function () {
	        //Aria-Label for bag
	        var bag = document.querySelector('.navigation-res-nav-header__item--bag a');
	        var count = document.querySelector('.navigation-res-nav-header__item--bag .navigation-nav-header__bag-count').innerText;
	        bag.setAttribute('aria-label', BAGLABEL1 + count + BAGLABEL2);
	    };
	
	    DesktopDevice.prototype.searchOverlayCloseEvnt = function (event) {
	        var keyPressed = event.key;
	        if (keyPressed === 'Enter') {
	            var dummySearch = document.querySelector('.navigation-dropdown__panel--search');
	            dummySearch.focus();
	        }
	    };
	
	    DesktopDevice.prototype.signInIconKeyUp = function (event) {
	        var keyPressed = event.key || event.keyCode;
	        if (keyPressed === 40 || keyPressed === 'ArrowDown') {
	            event.preventDefault();
	            this.signInFlag = false;
	            this.signInButtonClick();
	            event.stopPropagation();
	        } else if (keyPressed === 38 || keyPressed === 'ArrowUp') {
	            this.signInFlag = false;
	            this.signInButtonClickOut();
	            event.stopPropagation();
	        }
	    };
	    DesktopDevice.prototype.myaccbuttonKeyUp = function (event) {
	        var keyPressed = event.key || event.keyCode;
	        if (keyPressed === 40 || keyPressed === 'ArrowDown') {
	            event.preventDefault();
	            this.myaccountFlag = false;
	            this.myaccountButtonClick();
	            event.stopPropagation();
	        } else if (keyPressed === 38 || keyPressed === 'ArrowUp') {
	            this.myaccountFlag = false;
	            this.myaccountButtonClickOut();
	            event.stopPropagation();
	        }
	    };
	
	    //Accessibility disabling empty bag Enter
	
	    DesktopDevice.prototype.myEmptybagDisable = function () {
	        if (document.querySelector('.navigation-nav-header__bag-count').innerText === '0') {
	            this.bagElementUrl.setAttribute('href', 'javascript:void(0)');
	        } else {
	            this.bagElementUrl.setAttribute('href', this.miniBagWithItemUrl);
	        }
	    };
	
	    //Page reload on Safari  on back button click
	    var userAgent = window.navigator.userAgent;
	    var isSafari = userAgent.indexOf('Safari');
	    var isChrome = userAgent.indexOf('Chrome');
	    if (isSafari !== -1 && isChrome === -1) {
	        window.onpageshow = function (event) {
	            if (event.persisted) {
	                window.location.reload();
	            }
	        };
	    }
	
	    return DesktopDevice;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13), __webpack_require__(28), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Authentication, Level2, config) {
	
	    function Navigation() {
	        var auth = new Authentication();
	        new Level2(config, auth);
	    }
	    return Navigation;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (domQ) {
	
	    function Lazyload() {}
	
	    Lazyload.prototype.bind = function () {
	        this.imageList = document.querySelectorAll('#common-hdr-main img[data-original]');
	
	        for (var iImage = 0; iImage < this.imageList.length; iImage++) {
	            var image = this.imageList[iImage];
	            domQ(image).addClass('loader');
	            domQ(image.parentNode).addClass('loader__spinner--image');
	        }
	    };
	    Lazyload.prototype.load = function () {
	        var _this = this;
	        for (var iImage = 0; iImage < this.imageList.length; iImage++) {
	            var image = this.imageList[iImage];
	            if (image.attributes['data-original'] && _this.isImageVisible(image)) {
	                _this.bindEvents(image);
	            }
	        }
	    };
	    Lazyload.prototype.bindEvents = function (image) {
	        image.addEventListener('load', function () {
	            domQ(this.parentNode).removeClass('loader__spinner--image');
	            this.removeEventListener('load', this);
	        });
	        image.src = image.attributes['data-original'].value;
	    };
	    Lazyload.prototype.isImageVisible = function (image) {
	        var boundingRect = image.getBoundingClientRect();
	        return boundingRect.top > 0 && boundingRect.left >= 0 && boundingRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && boundingRect.right <= (window.innerWidth || document.documentElement.clientWidth);
	    };
	
	    return Lazyload;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(27), __webpack_require__(1), __webpack_require__(29), __webpack_require__(31), __webpack_require__(25), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Lazyload, domQ, Level3, XSmallDevice, DesktopDevice, breakpoint) {
	
	    var IS_LEVEL2_ACTIVE = 'navigation-is-level2-active';
	    var IS_ACTIVE = 'navigation-is-active';
	    var ARIA_EXPANDED = 'aria-expanded';
	    var IS_ACTIVE_SUBMENU = 'navigation-is-active-submenu';
	    var IS_ACTIVE_ANCHOR = 'navigation-is-active-anchor';
	    var clickedMenu;
	    var menuBarOver = false;
	    function Level2(config, auth) {
	        this.config = config;
	        this.auth = auth;
	        this.navPrimarySectionEl = document.querySelector('.navigation-primary__section');
	        this.navPaneOneBottomEl = document.querySelector('.navigation-pane-one-navbottom');
	        this.navContainerEl = document.getElementById('navContainer');
	        this.navPrimaryAList = document.querySelectorAll('.navigation-primary__section > .nav-primary__list a[id$=_menu]');
	        this.searchDropdown = document.querySelector('.navigation-search-bar--suggestion-dropdown');
	        this.navVeilEl = document.querySelector('.navigation-nav-veil');
	        this.primaryList = document.querySelector('.nav-primary__list');
	        this.headerEL = document.querySelector('.navigation-common-hdr-main');
	        this.bindForDevice = this.bindForDevice.bind(this);
	        this.checkClickToClose = this.checkClickToClose.bind(this);
	        this.lazyload = new Lazyload();
	        this.init();
	        this.activateBarMenu = this.activateBarMenu.bind(this);
	        this.load = this.load.bind(this);
	    }
	    Level2.prototype.init = function () {
	        var _this = this;
	        this.level3 = new Level3(this.config);
	        var NavL23DataDate = 'NavL23DateUK';
	        var urlloc = window.location.href.split('.')[0];
	        if (urlloc === 'https://store' || urlloc === 'https://cs') {
	            window.MS_COMMON_L23CMDCALL = false;
	        }
	        if (window.mnsHeaderConfig && window.mnsHeaderConfig.storeId === '10451') {
	            NavL23DataDate = 'NavL23DateIE';
	        }
	        if (window && window.MS_COMMON_L23CMDCALL) {
	            if (window.localStorage && window.localStorage[NavL23DataDate]) {
	                var today = new Date();
	                var timeDiff = Math.round((today.getTime() - Date.parse(window.localStorage[NavL23DataDate])) / (1000 * 60));
	                if (!window.navXhrDuration) {
	                    window.navXhrDuration = 15;
	                }
	                if (timeDiff < window.navXhrDuration) {
	                    this.level3.loadStatic();
	                    this.load();
	                } else {
	                    return this.level3.load().then(_this.load.bind(_this)).catch(function () {
	                        //Handle errors here
	                    });
	                }
	            } else {
	                return this.level3.load().then(_this.load.bind(_this)).catch(function () {
	                    //Handle errors here
	                });
	            }
	        }
	        if (!window.MS_COMMON_L23CMDCALL) {
	            this.level3.load();
	            this.load();
	        }
	    };
	    Level2.prototype.load = function () {
	        var _this = this;
	        window.addEventListener('resize', _this.bindForDevice);
	        _this.bindForDevice();
	        _this.lazyload.bind();
	        _this.activateBarMenu();
	        _this.newTag();
	        /* Identify single column in six column nav submenu and allocate 100 percent width using fullwidth class*/
	        var navSubmenu = document.querySelectorAll('.nav-submenu__span--one-fifth');
	        for (var navSubmenuIndex = 0; navSubmenuIndex < navSubmenu.length; navSubmenuIndex++) {
	            var subMenuColElements = navSubmenu[navSubmenuIndex].getElementsByClassName('nav-submenu__col');
	            if (subMenuColElements.length === 1) {
	                subMenuColElements[0].classList.add('fullwidth');
	            }
	        }
	    };
	    Level2.prototype.newTag = function () {
	        var today = new Date();
	        var newTagEl = document.querySelectorAll('.new-tag');
	        for (var indivEl = 0; indivEl < newTagEl.length; indivEl++) {
	            if (newTagEl[indivEl].hasAttribute('data-newtagdate')) {
	                var newTagDataAttr = newTagEl[indivEl].getAttribute('data-newtagdate');
	                var newTagData = new Date(newTagDataAttr);
	                var diffTime = today - newTagData;
	                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	                if (diffDays >= 1 && diffDays <= 21) {
	                    newTagEl[indivEl].setAttribute('aria-label', newTagEl[indivEl].innerText + ' new brand');
	                    newTagEl[indivEl].innerText = newTagEl[indivEl].innerText + ' ';
	                    newTagEl[indivEl].classList.add('new-tag-style');
	                }
	            }
	        }
	    };
	    Level2.prototype.bindForDevice = function () {
	        if (breakpoint.size() === 'xsmall') {
	            if (!this.xSmallDevice) {
	                this.xSmallDevice = new XSmallDevice(this);
	            }
	            this.xSmallDevice.bind();
	            if (this.desktopDevice) {
	                this.desktopDevice.unbind();
	                this.desktopDevice.countrySelectorOverlayCloseOnResize();
	            }
	        } else {
	            if (!this.desktopDevice) {
	                this.desktopDevice = new DesktopDevice(this, this.level3);
	            }
	            this.desktopDevice.bind();
	            this.desktopDevice.countrySelectorOverlayCloseOnResize();
	            if (this.xSmallDevice) {
	                this.xSmallDevice.unbind();
	            }
	        }
	    };
	    /*Identify the menu value in windows path url which need to be highlighted  in menu bar*/
	    Level2.prototype.identifyMenu = function () {
	        if (window.location && window.location.pathname && window.location.pathname.indexOf('/ie') !== -1) {
	            if (window.pdpData && window.pdpData.breadcrumb && window.pdpData.breadcrumb[1] && window.pdpData.breadcrumb[1].categoryUrl) {
	                clickedMenu = window.pdpData.breadcrumb[1].categoryUrl.split('/')[3];
	            } else if (window.utag_data && window.utag_data.page_type && window.utag_data.project_type && window.utag_data.page_type === 'Product Detail Page' && window.utag_data.project_type === 'fesk') {
	                window.navAnchorPdpData = { breadcrumb: [] };
	                window.navAnchorPdpData.breadcrumb = document.querySelectorAll('.breadcrumb li [href]');
	                clickedMenu = window.navAnchorPdpData.breadcrumb && window.navAnchorPdpData.breadcrumb[1].pathname ? window.navAnchorPdpData.breadcrumb[1].pathname.split('/')[3] : null;
	            } else if (window.location.pathname.split('/ie')[1] && window.location.pathname.split('/')[2] !== 'sitemaps' && window.location.pathname.split('/')[2] !== 'Sitemaps') {
	                clickedMenu = window.location.pathname.split('/ie')[1].split('/')[2];
	            }
	        } else {
	            if (window.pdpData && window.pdpData.breadcrumb && window.pdpData.breadcrumb[1] && window.pdpData.breadcrumb[1].categoryUrl) {
	                clickedMenu = window.pdpData.breadcrumb[1].categoryUrl.split('/')[2];
	            } else if (window.utag_data && window.utag_data.page_type && window.utag_data.project_type && window.utag_data.page_type === 'Product Detail Page' && window.utag_data.project_type === 'fesk') {
	                window.navAnchorPdpData = { breadcrumb: [] };
	                window.navAnchorPdpData.breadcrumb = document.querySelectorAll('.breadcrumb li [href]');
	                clickedMenu = window.navAnchorPdpData.breadcrumb && window.navAnchorPdpData.breadcrumb[1].pathname ? window.navAnchorPdpData.breadcrumb[1].pathname.split('/')[2] : null;
	            } else if (window.location && window.location.pathname && window.location.pathname.split('/')[1] !== 'sitemaps' && window.location.pathname.split('/')[1] !== 'Sitemaps') {
	                clickedMenu = window.location.pathname.split('/')[2];
	            }
	        }
	        //Differes the sale and offers menu url value
	        if (clickedMenu === 'offers' && 'sale' === window.location.pathname.split('/')[3]) {
	            clickedMenu = 'sale';
	        }
	    },
	    /*Remove the active bar class for other menus*/
	    Level2.prototype.removeActiveMenu = function (element) {
	        if (element.classList.contains(IS_ACTIVE_SUBMENU)) {
	            element.classList.remove(IS_ACTIVE_SUBMENU);
	            element.parentElement.classList.remove(IS_ACTIVE);
	        }
	    },
	    /**
	     * Method is using to highlit the GNAV bar
	     * Identify the menu value in windows path url which need to be highlighted  in menu bar
	     * compare the menu value to menu bar list and add the active bar class
	     */
	    Level2.prototype.activateBarMenu = function () {
	        this.identifyMenu();
	        for (var iCount = 0; iCount < this.navPrimaryAList.length; iCount++) {
	            var element = this.navPrimaryAList[iCount];
	            var categoryEl = '';
	            if (element.getAttribute('href') && element.getAttribute('href').indexOf('/ie') !== -1) {
	                categoryEl = element.getAttribute('href').split('/ie')[1];
	                categoryEl = categoryEl.split('#')[0];
	            } else {
	                categoryEl = element.getAttribute('href');
	                if (categoryEl) {
	                    categoryEl = categoryEl.split('#')[0];
	                }
	            }
	            if (clickedMenu && 'offers' !== clickedMenu && clickedMenu === categoryEl.split('/')[2] || ('sale' === clickedMenu || 'offers' === clickedMenu) && clickedMenu === element.innerText.toLowerCase()) {
	                domQ(element).addClass(IS_ACTIVE_SUBMENU);
	                domQ(element).addClass(IS_ACTIVE_ANCHOR);
	                domQ(element.parentElement).addClass(IS_ACTIVE);
	            } else {
	                this.removeActiveMenu(element);
	            }
	        }
	    };
	    Level2.prototype.checkClickToClose = function (e) {
	        if (!e.target.classList.contains('nav-primary__menu-link')) {
	            this.deactivate();
	        }
	    };
	
	    Level2.prototype.activate = function (el) {
	        var searchDropPassive = this.searchDropdown ? this.searchDropdown.classList.contains('navigation-search-bar--suggestion-dropdown__hidden') : true;
	        if (!searchDropPassive) {
	            this.searchDropdown.classList.add('navigation-search-bar--suggestion-dropdown__hidden');
	        }
	        this.level3.hideAllPanels();
	        this.level3.showPanel(this.level3.getPanelId(el.id));
	        domQ(this.navPrimarySectionEl).addClass(IS_LEVEL2_ACTIVE);
	        domQ(this.navContainerEl).addClass(IS_ACTIVE);
	        domQ(this.navPaneOneBottomEl).addClass(IS_LEVEL2_ACTIVE);
	        menuBarOver = true;
	        this.deactivateAllMenus();
	        domQ(el).addClass(IS_ACTIVE);
	        domQ(el.parentElement).addClass(IS_ACTIVE);
	        this.navVeilEl.classList.add(IS_ACTIVE);
	        if (breakpoint.size() === 'xsmall') {
	            el.setAttribute(ARIA_EXPANDED, true);
	        }
	        this.lazyload.load();
	        this.primaryList.style.zIndex = '90001';
	    };
	    Level2.prototype.deactivate = function () {
	        domQ(this.navPrimarySectionEl).removeClass(IS_LEVEL2_ACTIVE);
	        domQ(this.navContainerEl).removeClass(IS_ACTIVE);
	        domQ(this.navPaneOneBottomEl).removeClass(IS_LEVEL2_ACTIVE);
	        menuBarOver = false;
	        this.deactivateAllMenus();
	        this.activateBarMenu();
	        this.level3.hideAllPanels();
	        this.primaryList.removeAttribute('style');
	    };
	    Level2.prototype.deactivateAllMenus = function () {
	        for (var iCount = 0; iCount < this.navPrimaryAList.length; iCount++) {
	            var el = this.navPrimaryAList[iCount];
	            domQ(el).removeClass(IS_ACTIVE);
	            domQ(el.parentElement).removeClass(IS_ACTIVE);
	            if (breakpoint.size() !== 'xsmall') {
	                this.navVeilEl.classList.remove(IS_ACTIVE);
	            }
	            if (breakpoint.size() === 'xsmall') {
	                el.setAttribute(ARIA_EXPANDED, false);
	            }
	            if (menuBarOver) {
	                domQ(el).removeClass(IS_ACTIVE_SUBMENU);
	            }
	        }
	    };
	
	    return Level2;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(3), __webpack_require__(8), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (XhrPromise, util, analytics, domQ) {
	
	    var MENU_ID_PART = '_menu';
	    var HAMBURGER_MENU_TOP_HEIGHT = 207;
	    var NON_FESK_MENU_TOP_HEIGHT = 6;
	    var PANE_TWO_IPAD_BOTTOM = 9;
	    var DOCK_POS_NOL23 = 90;
	    var MOBILE_BREAKPOINT = 320;
	    var TABLET_BREAKPOINT = 768;
	
	    function Level3(config) {
	        this.config = config;
	        this.navContainerEl = document.getElementById('navContainer');
	    }
	
	    Level3.prototype.attachToDom = function (html) {
	        this.navContainerEl.children[2].innerHTML = html;
	    };
	    Level3.prototype.loadStatic = function () {
	        var _this = this;
	        var NavL23Data = 'NavL23DataUK';
	        if (window.mnsHeaderConfig && window.mnsHeaderConfig.storeId === '10451') {
	            NavL23Data = 'NavL23DataIE';
	        }
	        _this.attachToDom(window.localStorage[NavL23Data]);
	        _this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
	        _this.hideAllPanels();
	        _this.analytics();
	    };
	    Level3.prototype.load = function () {
	        var _this = this;
	        var NavL23Data = 'NavL23DataUK';
	        var NavL23Date = 'NavL23DateUK';
	        if (window.mnsHeaderConfig && window.mnsHeaderConfig.storeId === '10451') {
	            NavL23Data = 'NavL23DataIE';
	            NavL23Date = 'NavL23DateIE';
	        }
	        if (window && window.MS_COMMON_L23CMDCALL) {
	            var xhrp = new XhrPromise();
	            var host = this.config.wcsBaseUrl + this.config.CMD.navigation23;
	            var params = {
	                storeId: this.config.storeId,
	                langId: this.config.langId
	            };
	
	            return xhrp.send({
	                url: util.constructUrl(host, params),
	                method: 'GET'
	            }).then(function (response) {
	                if (response.status === 200) {
	                    if (response.responseText.indexOf('Generic Error Page') === -1 && response.responseText.indexOf('500 Internal Server Error') === -1 && response.responseText !== '' && response.responseText.indexOf('Sorry, something went wrong') === -1) {
	                        window.localStorage[NavL23Data] = response.responseText;
	                        window.localStorage[NavL23Date] = new Date();
	                        _this.attachToDom(response.responseText);
	                        _this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
	                        _this.hideAllPanels();
	                        _this.analytics();
	                    } else if (window.localStorage[NavL23Data]) {
	                        _this.attachToDom(window.localStorage[NavL23Data]);
	                        _this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
	                        _this.hideAllPanels();
	                        _this.analytics();
	                    }
	                }
	            });
	        } else if (!window.MS_COMMON_L23CMDCALL) {
	            this.navPrimarySubmenuList = document.querySelectorAll('#navContainer > div > div');
	            this.hideAllPanels();
	            this.analytics();
	        }
	    };
	    Level3.prototype.analytics = function () {
	        var analyticActions = [{
	            functionName: 'analyticsTopNav',
	            event: 'click'
	        }];
	        analytics.bind(document.querySelectorAll('.navigation-primary a'), analyticActions);
	    };
	    Level3.prototype.dockNavBottom = function (el) {
	        if (window.innerHeight < MOBILE_BREAKPOINT) {
	            // bottom value adjustments iPhone devices with height<320
	            el.style.bottom = window.innerHeight - MOBILE_BREAKPOINT + 'px';
	        } else if (window.innerWidth === TABLET_BREAKPOINT) {
	            // bottom value adjustments for iPadmini
	            el.style.bottom = -(window.innerHeight - HAMBURGER_MENU_TOP_HEIGHT - PANE_TWO_IPAD_BOTTOM) + 'px';
	        } else if (window.innerHeight > MOBILE_BREAKPOINT) {
	            el.style.bottom = -(window.innerHeight - HAMBURGER_MENU_TOP_HEIGHT + NON_FESK_MENU_TOP_HEIGHT) + 'px';
	        }
	    };
	    Level3.prototype.showPanel = function (id) {
	        var panel = document.getElementById(id);
	        var el = document.querySelector('.navigation-pane-two-navbottom');
	        if (panel) {
	            panel.style.display = 'block';
	            panel.setAttribute('aria-hidden', false);
	            panel.classList.add('navigation-open-submenu');
	            if (el) {
	                this.dockNavBottom(el);
	                if (domQ(el).hasClass('navigation-dock-pos')) {
	                    domQ(el).removeClass('navigation-dock-pos');
	                }
	            }
	        } else {
	            if (el) {
	                domQ(el).addClass('navigation-dock-div');
	                el.style.top = window.innerHeight - DOCK_POS_NOL23 + 'px';
	                if (!domQ(el).hasClass('navigation-dock-pos')) {
	                    domQ(el).addClass('navigation-dock-pos');
	                }
	            }
	        }
	    };
	    Level3.prototype.hideAllPanels = function () {
	        var subMenuEl = this.navPrimarySubmenuList;
	        if (subMenuEl) {
	            for (var iSubItem = 0; iSubItem < subMenuEl.length; iSubItem++) {
	                if (!subMenuEl[iSubItem].classList.contains('navigation-bottom-container')) {
	                    subMenuEl[iSubItem].style.display = 'none';
	                    subMenuEl[iSubItem].setAttribute('aria-hidden', true);
	                }
	                if (subMenuEl[iSubItem].classList.contains('navigation-open-submenu')) {
	                    subMenuEl[iSubItem].classList.remove('navigation-open-submenu');
	                }
	            }
	        }
	    };
	    Level3.prototype.getPanelId = function (menuid) {
	        return menuid.replace(MENU_ID_PART, '');
	    };
	    return Level3;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (DropdownMenu) {
	
	    return {
	        close: function close() {
	            // get existing instance of the dropdown menu object
	            var dropdownMenu = DropdownMenu.get('HEADER_DROPDOWN_MENU');
	
	            dropdownMenu.toggleDropdown.apply(dropdownMenu);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(1), __webpack_require__(6), __webpack_require__(8), __webpack_require__(9), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_RESULT__ = function (util, domQ, Constant, analytics, countryLinkDropDown, stickyHeader) {
	    var IS_ACTIVE = 'navigation-is-active';
	    var IS_SELECTED = 'is-selected';
	    var PREVENT_SCROLLING = 'navigation-prevent-scrolling';
	    var PREVENT_STICKYSCROLLING = 'navigation-prevent-stickyscrolling';
	    var STICKY_CLASS = 'navigation-sticky';
	    var ANIMATION_TRANSITION = 'transform .1s cubic-bezier(0, 0.3, 0.2, 1.02) 0s';
	    var L1_ANIMATION_TRANSITION = 'transform .1s cubic-bezier(0, 0.3, 0.2, 1.02) 0s';
	    var HAMBURGER_CLASS = 'navigation-res-nav-header__item--menu';
	    var TOUCH_START = 'touchstart';
	    var PRIMARY_SECTION_WIDTH = 0.9;
	    var L3_MAXHEIGHT = '1000px';
	
	    function XSmallDevice(level2) {
	        this.level2 = level2;
	        this.navPrimarySectionEl = document.querySelector('.navigation-primary__section');
	        this.menuLastItem = document.querySelector('.navigation-menulastitem');
	        this.navigationOverlayEl = document.getElementById('navigationOverlay');
	        this.navContainerEl = document.getElementById('navContainer');
	        this.hamburgerEl = document.querySelector('.' + HAMBURGER_CLASS);
	        this.backLabelEl = document.querySelector('.navigation-submenu__back-bar-label');
	        this.backButtonEl = document.querySelector('.navigation-submenu__back-bar-link');
	        this.tempHolder = document.querySelector('.navigation-temp-accessibility');
	        this.navPrimaryWrapper = document.querySelector('.navigation-primary--wrapper');
	        this.bodyEl = document.querySelector('body');
	        this.level2Headers = document.querySelectorAll('#navContainer .nav-submenu__l2-header');
	        this.headerEl = document.querySelector('#progressiveHeaderSection');
	        this.hamburgerNavCloseButton = document.querySelector('.navigation-burger-close');
	        this.navVeil = document.querySelector('#progressiveHeaderSection > div.navigation-nav-veil');
	        this.searchButtonReset = document.querySelector('.navigation-search-bar--clear');
	        this.searchiconButton = document.querySelector('.navigation-search-bar--submit');
	        this.searchBar = document.querySelector('.navigation-search-bar--search');
	        this.searchBarSuggession = document.querySelector('.navigation-search-bar--suggestion-dropdown');
	        this.navPrimaryListEl = document.querySelectorAll('.nav-primary__list li');
	        this.navBottomAccountIcon = document.querySelectorAll('.navigation-bottom-myaccount>a>i.navigation-primary__menu-icon.navigation-icon--my-account');
	        this.navBottomMyAccount = document.querySelectorAll('.navigation-bottom-myaccount');
	        this.navBottomSparksIcon = document.querySelectorAll('.navigation-bottom-sparks');
	        this.navBottomFindStore = document.querySelectorAll('.navigation-bottom--find-store');
	        this.navBottomFindStoreIcon = document.querySelectorAll('.navigation-bottom--find-store>a>i.navigation-mobile-location-finder');
	        this.navPrimaryList = document.querySelectorAll('.nav-primary__list');
	        this.navBottomContainerOne = document.querySelector('.navigation-pane-one-navbottom');
	        this.navPrimaryFixedTopBar = document.querySelector('.navigation-burger__fixedtopmenu');
	        this.goToCountryLink = document.querySelector('.navigation-country-mobile--link');
	        this.mobileNavLogo = document.querySelector('.navigation-burger__fixedtopmenu .navigation-logo');
	        this.headerEL = document.getElementById('common-hdr-main');
	        this.countrySelectorHead = document.querySelector('.navigation-mobile-country-header');
	        this.countrySelector = document.querySelector('.navigation-mobile-country-selector');
	        this.mobileCountryDiv = document.querySelector('.navigation-nav-country-selector');
	        this.mobileCountryDropdown = document.querySelector('.navigation-country-mobile--country-list');
	        this.mobileLanguageDropdown = document.querySelector('.navigation-country-mobile--language-list');
	        this.bannerImageSection = document.querySelector('.navigation-banner-responsive');
	        this.spinnerImageSection = document.querySelector('.navigation-bannerspinner');
	        this.userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
	        this.navBottomContainerLinks = document.querySelectorAll('.navigation-bottom-container a');
	        this.navPrimaryListLinks = this.navPrimaryList[0].querySelectorAll('a');
	        // bind functions for event listeners
	        this.level2Click = this.level2Click.bind(this);
	        this.toggleCountrySelectorDiv = this.toggleCountrySelectorDiv.bind(this);
	        this.searchButtonResetClick = this.searchButtonResetClick.bind(this);
	        this.mobileMenuToggle = this.mobileMenuToggle.bind(this);
	        this.backClick = this.backClick.bind(this);
	        this.toggleLevel3 = this.toggleLevel3.bind(this);
	        this.toggleLevel3Keyup = this.toggleLevel3Keyup.bind(this);
	        this.closeMenu = this.closeMenu.bind(this);
	        this.checkHeaderClickToClose = this.checkHeaderClickToClose.bind(this);
	        this.myAccount = this.myAccount.bind(this);
	        this.loopFocus = this.loopFocus.bind(this);
	        this.loadseasonalBanner = this.loadseasonalBanner.bind(this);
	        this.interactionEvent = 'click';
	        this.goToCountryLinkClick = this.goToCountryLinkClick.bind(this);
	        this.mnsHeaderConfig = window.mnsHeaderConfig;
	        if (util.hasTouchCapability()) {
	            this.interactionEvent = TOUCH_START;
	        }
	    }
	
	    XSmallDevice.prototype.searchButtonResetClick = function () {
	        domQ(this.searchBarSuggession).addClass('navigation-search-bar--suggestion-dropdown__hidden');
	        this.searchBar.value = '';
	    };
	    XSmallDevice.prototype.errorPromptPopupClick = function (e) {
	        e.preventDefault();
	    };
	    XSmallDevice.prototype.analytics = function () {
	        var analyticActions = [{
	            functionName: 'analyticsL1Nav',
	            event: 'click'
	        }];
	        analytics.bind(this.navPrimaryListEl, analyticActions);
	    };
	    XSmallDevice.prototype.bind = function () {
	        var _this = this;
	        var thematicflag = false;
	        for (var iCount = 0; iCount < this.level2.navPrimaryAList.length; iCount++) {
	            var link = this.level2.navPrimaryAList[iCount];
	            link.addEventListener(_this.interactionEvent, _this.level2Click);
	            if (_this.interactionEvent === TOUCH_START) {
	                link.removeEventListener('touchstart', _this.level2Click);
	                link.addEventListener('click', _this.level2Click);
	            }
	        }
	
	        for (var navPrimaryListElCount = 0; navPrimaryListElCount < this.navPrimaryListEl.length; navPrimaryListElCount++) {
	            var navLiEl = this.navPrimaryListEl[navPrimaryListElCount];
	            if (!domQ(navLiEl).hasClass('nav-primary-inspire-me')) {
	                navLiEl.addEventListener(_this.interactionEvent, _this.level2Click);
	                if (_this.interactionEvent === TOUCH_START) {
	                    navLiEl.removeEventListener('touchstart', _this.level2Click);
	                    navLiEl.addEventListener('click', _this.level2Click);
	                }
	            }
	            if (navLiEl.innerText.indexOf('Bank') !== -1 && domQ(navLiEl.previousElementSibling).hasClass('nav-primary-inspire-me')) {
	                navLiEl.style.borderBottom = 'none';
	                thematicflag = true;
	                domQ(navLiEl).addClass('navigation-bankClass');
	            }
	        }
	
	        if (!thematicflag) {
	            if (document.querySelector('.nav-primary-inspire-me')) {
	                document.querySelector('.nav-primary-inspire-me').style.borderBottom = 'none';
	            }
	        }
	
	        this.hamburgerEl.addEventListener('click', this.mobileMenuToggle);
	        this.backButtonEl.addEventListener('click', this.backClick);
	        this.searchButtonReset.addEventListener('click', this.searchButtonResetClick);
	        for (var iHeader = 0; iHeader < this.level2Headers.length; iHeader++) {
	            var header = this.level2Headers[iHeader];
	            header.addEventListener('click', _this.toggleLevel3);
	        }
	        this.navigationOverlayEl.addEventListener(this.interactionEvent, this.closeMenu);
	        this.goToCountryLink.addEventListener(this.interactionEvent, this.goToCountryLinkClick);
	        //close the hamburger on click event only
	        this.navVeil.addEventListener('click', this.checkHeaderClickToClose);
	        this.countrySelectorHead.addEventListener('click', this.toggleCountrySelectorDiv);
	        this.hamburgerNavCloseButton.addEventListener('click', this.checkHeaderClickToClose);
	        document.querySelector('.navigation-primary--wrapper').tabIndex = '0';
	        this.setup();
	        //for safari-bfcache clear
	        window.onpageshow = function (event) {
	            if (event.persisted) {
	                //from bf cache
	                window.location.reload();
	            }
	        };
	        this.setPrimarySection();
	        this.analytics();
	        var analyticActionsL2Open = [{
	            functionName: 'analyticsL2OpenNav',
	            event: 'click'
	        }];
	        analytics.bind(this.level2Headers, analyticActionsL2Open);
	        this.menuLastItem.addEventListener('focus', function () {
	            var menuCloseIcon = document.querySelector('.navigation-burger-close');
	            menuCloseIcon.focus();
	        });
	        this.tempHolder.addEventListener('focus', this.loopFocus);
	        this.tempHolder.addEventListener('click', this.loopFocus);
	    };
	    XSmallDevice.prototype.unbind = function () {
	        var _this = this;
	        for (var iCount = 0; iCount < this.level2.navPrimaryAList.length; iCount++) {
	            var link = this.level2.navPrimaryAList[iCount];
	            link.removeEventListener(_this.interactionEvent, _this.level2Click);
	            if (_this.interactionEvent === TOUCH_START) {
	                link.removeEventListener('click', util.preventClick);
	            }
	        }
	        for (var navPrimaryListElCount = 0; navPrimaryListElCount < this.navPrimaryListEl.length; navPrimaryListElCount++) {
	            var navLiEl = this.navPrimaryListEl[navPrimaryListElCount];
	            if (!domQ(navLiEl).hasClass('nav-primary-inspire-me')) {
	                navLiEl.removeEventListener(_this.interactionEvent, _this.level2Click);
	                if (_this.interactionEvent === TOUCH_START) {
	                    navLiEl.removeEventListener('click', _this.level2Click);
	                }
	            }
	
	            if (domQ(navLiEl).hasClass('navigation-bankClass')) {
	                domQ(navLiEl).removeClass('navigation-bankClass');
	            }
	        }
	        this.hamburgerEl.removeEventListener('click', this.mobileMenuToggle);
	        this.backButtonEl.removeEventListener('click', this.backClick);
	        for (var iHeader = 0; iHeader < this.level2Headers.length; iHeader++) {
	            var header = this.level2Headers[iHeader];
	            header.removeEventListener('click', _this.toggleLevel3);
	        }
	        this.navigationOverlayEl.removeEventListener(this.interactionEvent, this.closeMenu);
	        this.navVeil.removeEventListener('click', this.checkHeaderClickToClose);
	        document.querySelector('.navigation-primary--wrapper').removeAttribute('tabIndex');
	        this.hamburgerNavCloseButton.removeEventListener('click', this.checkHeaderClickToClose);
	        this.teardown();
	        this.tempHolder.removeEventListener('focus', this.loopFocus);
	        this.tempHolder.removeEventListener('click', this.loopFocus);
	    };
	    XSmallDevice.prototype.toggleCountrySelectorDiv = function () {
	        countryLinkDropDown.buildDropDown();
	        countryLinkDropDown.resetDropDown();
	        if (domQ(this.countrySelector).hasClass('navigation-country-overlay-visible')) {
	            domQ(this.countrySelector).removeClass('navigation-country-overlay-visible');
	            setTimeout(function () {
	                document.querySelector('.navigation-mobile-country-selector').style.display = 'none';
	            }, 500);
	        } else {
	            this.navPrimarySectionEl.style.overflowY = 'hidden';
	            var parentEl = this.navPrimarySectionEl;
	            var countryDiv = this.mobileCountryDiv;
	            this.countrySelector.style.display = 'block';
	            setTimeout(function () {
	                domQ(document.querySelector('.navigation-mobile-country-selector')).addClass('navigation-country-overlay-visible');
	            }, 50);
	            setTimeout(function () {
	                parentEl.scrollTop = countryDiv.offsetTop;
	                parentEl.style.overflowY = 'scroll';
	            }, 500);
	        }
	        if (domQ(this.countrySelectorHead).hasClass('navigation-country-toggle-arrow')) {
	            domQ(this.countrySelectorHead).removeClass('navigation-country-toggle-arrow');
	            this.countrySelectorHead.setAttribute('aria-expanded', 'false');
	            countryLinkDropDown.resetDropDown();
	        } else {
	            domQ(this.countrySelectorHead).addClass('navigation-country-toggle-arrow');
	            this.countrySelectorHead.setAttribute('aria-expanded', 'true');
	        }
	    };
	    XSmallDevice.prototype.goToCountryLinkClick = function () {
	        if (this.goToCountryLink.href === 'javascript:;') {
	            this.closeMenu();
	        }
	    };
	    XSmallDevice.prototype.setup = function () {
	        var _this = this;
	        this.myAccount();
	        if (this.navContainerEl.classList.contains(IS_ACTIVE)) {
	            //close menu only if it is open
	            this.backClick();
	        }
	        clearTimeout(this.setTimeoutId);
	        this.setTimeoutId = setTimeout(function () {
	            _this.addAnimation();
	        }, 100);
	    };
	    XSmallDevice.prototype.teardown = function () {
	        this.level2.deactivate();
	        this.removeAnimation();
	        this.closeMenu();
	    };
	    XSmallDevice.prototype.addAnimation = function () {
	        this.navPrimarySectionEl.style.transition = ANIMATION_TRANSITION;
	        this.navPrimaryFixedTopBar.style.transition = ANIMATION_TRANSITION;
	    };
	    XSmallDevice.prototype.removeAnimation = function () {
	        this.navPrimarySectionEl.style.transition = 'none';
	        this.navPrimaryFixedTopBar.style.transition = 'none';
	    };
	    XSmallDevice.prototype.myAccount = function () {
	        var isAuthenticated = this.level2.auth.isAuthenticated();
	        var mobileAccountEl = document.querySelector('.navigation-bottom-container');
	        this.displayNode(mobileAccountEl.children[1].children[0].children[2], isAuthenticated);
	        this.displayNode(mobileAccountEl.children[1].children[0].children[3], !isAuthenticated);
	    };
	    XSmallDevice.prototype.displayNode = function (el, show) {
	        el.style.display = show ? 'block' : 'none';
	    };
	    XSmallDevice.prototype.level2Open = function (el) {
	        this.isActiveBottomContainer();
	        this.backButtonEl.style.display = 'inline-block';
	        //If Span is replaced with <img> in future change the below code
	        if (el.tagName === 'DIV' && el.parentElement && !el.parentElement.classList.contains(IS_ACTIVE)) {
	            this.level2.activate(el.parentElement);
	            this.setBackLabel(el.parentElement.innerHTML, el.parentElement.pathname);
	        } else if (el.tagName === 'IMG' && el.parentElement.parentElement && !el.parentElement.parentElement.classList.contains(IS_ACTIVE)) {
	            this.level2.activate(el.parentElement.parentElement);
	            this.setBackLabel(el.parentElement.parentElement.innerHTML, el.parentElement.parentElement.pathname);
	        } else if (el.tagName === 'IMG' && el.parentElement.parentElement) {
	            this.setBackLabel(el.parentElement.parentElement.innerHTML, el.parentElement.parentElement.pathname);
	        } else if (el.tagName === 'LI' && el.firstElementChild && !el.firstElementChild.classList.contains(IS_ACTIVE)) {
	            this.level2.activate(el.firstElementChild);
	            this.setBackLabel(el.firstElementChild.innerHTML, el.firstElementChild.pathname);
	        } else {
	            if (!domQ(el).hasClass(IS_ACTIVE)) {
	                this.level2.activate(el);
	                this.setBackLabel(el.innerHTML, el.pathname);
	            }
	        }
	
	        var subMenuID = el.getAttribute('data-cmspot-id');
	        var subMenu = document.getElementById(subMenuID);
	        if (subMenu) {
	            subMenu.tabIndex = '0';
	        }
	
	        this.navContainerEl.setAttribute('aria-hidden', 'false');
	        this.menuLastItem.tabIndex = -1;
	        this.navPrimarySectionEl.tabIndex = -1;
	        this.navPrimarySectionEl.setAttribute('aria-hidden', true);
	        this.navPrimaryList[0].tabIndex = -1;
	        this.navPrimaryList[0].setAttribute('aria-hidden', true);
	        this.countrySelectorHead.tabIndex = -1;
	        this.countrySelectorHead.setAttribute('aria-hidden', true);
	        this.mobileCountryDropdown.tabIndex = -1;
	        this.mobileCountryDropdown.setAttribute('aria-hidden', true);
	        this.mobileLanguageDropdown.tabIndex = -1;
	        this.mobileLanguageDropdown.setAttribute('aria-hidden', true);
	        this.goToCountryLink.tabIndex = -1;
	        this.goToCountryLink.setAttribute('aria-hidden', true);
	
	        for (var navL1i = 0; navL1i < this.navPrimaryListLinks.length; navL1i++) {
	            this.navPrimaryListLinks[navL1i].tabIndex = -1;
	            this.navPrimaryListLinks[navL1i].setAttribute('aria-hidden', 'true');
	        }
	        for (var navBotmI = 0; navBotmI < this.navBottomContainerLinks.length; navBotmI++) {
	            this.navBottomContainerLinks[navBotmI].tabIndex = -1;
	            this.navBottomContainerLinks[navBotmI].setAttribute('aria-hidden', 'true');
	        }
	
	        var headers = document.querySelectorAll('.navigation-open-submenu .nav-submenu__span--four-fifths .nav-submenu__l2-header');
	        util.setTabIndex(headers, '0');
	        this.backButtonEl.tabIndex = 0;
	        this.backButtonEl.focus();
	        if (this.tempHolder) {
	            this.displayNode(this.tempHolder, true);
	        }
	    };
	    XSmallDevice.prototype.isActiveBottomContainer = function () {
	        if (this.navBottomContainerOne && domQ(this.navBottomContainerOne).hasClass(IS_ACTIVE)) {
	            domQ(this.navBottomContainerOne).removeClass(IS_ACTIVE);
	        }
	    };
	    XSmallDevice.prototype.level2Click = function (e) {
	        e.preventDefault();
	        this.level2Open(e.target);
	        return false;
	    };
	    XSmallDevice.prototype.mobileMenuToggle = function () {
	        if (this.navPrimarySectionEl.classList.contains(IS_ACTIVE)) {
	            this.closeMenu();
	        } else {
	            this.openMenu();
	            this.loadseasonalBanner();
	        }
	    };
	    XSmallDevice.prototype.openMenu = function () {
	        domQ(this.navPrimaryWrapper).addClass(IS_ACTIVE);
	        if (domQ(this.headerEL).hasClass(STICKY_CLASS)) {
	            domQ(this.bodyEl).addClass(PREVENT_STICKYSCROLLING);
	            domQ(document.querySelector('html')).addClass(PREVENT_STICKYSCROLLING);
	        } else {
	            domQ(this.bodyEl).addClass(PREVENT_SCROLLING);
	        }
	        setTimeout(function () {
	            document.querySelector('.navigation-primary__section').classList.add(IS_ACTIVE);
	            document.querySelector('.navigation-burger__fixedtopmenu').classList.add(IS_ACTIVE);
	            document.querySelector('.navigation-pane-one-navbottom').classList.add(IS_ACTIVE);
	        }, 5);
	        domQ(this.hamburgerEl).addClass(IS_SELECTED);
	        domQ(this.navVeil).addClass(IS_ACTIVE);
	        this.mobileNavLogo.style.transform = 'none';
	        this.addAnimation();
	        this.anchoredNavigation();
	        document.querySelector('.navigation-burger__fixedtopmenu .navigation-mns-logo').focus();
	
	        if (this.navPrimarySectionEl.classList.contains('navigation-is-level2-active')) {
	            this.navPrimarySectionEl.tabIndex = -1;
	            this.navPrimarySectionEl.setAttribute('aria-hidden', true);
	            this.navPrimaryList[0].tabIndex = -1;
	            this.navPrimaryList[0].setAttribute('aria-hidden', true);
	            this.countrySelectorHead.tabIndex = -1;
	            this.countrySelectorHead.setAttribute('aria-hidden', true);
	            this.mobileCountryDropdown.tabIndex = -1;
	            this.mobileCountryDropdown.setAttribute('aria-hidden', true);
	            this.mobileLanguageDropdown.tabIndex = -1;
	            this.mobileLanguageDropdown.setAttribute('aria-hidden', true);
	            this.goToCountryLink.tabIndex = -1;
	            this.goToCountryLink.setAttribute('aria-hidden', true);
	            for (var navL1i = 0; navL1i < this.navPrimaryListLinks.length; navL1i++) {
	                this.navPrimaryListLinks[navL1i].tabIndex = -1;
	                this.navPrimaryListLinks[navL1i].setAttribute('aria-hidden', 'true');
	            }
	            for (var navBotmI = 0; navBotmI < this.navBottomContainerLinks.length; navBotmI++) {
	                this.navBottomContainerLinks[navBotmI].tabIndex = -1;
	                this.navBottomContainerLinks[navBotmI].setAttribute('aria-hidden', 'true');
	            }
	        } else {
	            this.navPrimarySectionEl.tabIndex = 0;
	            this.navPrimarySectionEl.setAttribute('aria-hidden', false);
	            this.navPrimaryList[0].tabIndex = 0;
	            this.navPrimaryList[0].setAttribute('aria-hidden', false);
	            this.countrySelectorHead.tabIndex = 0;
	            this.countrySelectorHead.setAttribute('aria-hidden', false);
	            this.mobileCountryDropdown.tabIndex = 0;
	            this.mobileCountryDropdown.setAttribute('aria-hidden', false);
	            this.mobileLanguageDropdown.tabIndex = 0;
	            this.mobileLanguageDropdown.setAttribute('aria-hidden', false);
	            this.goToCountryLink.tabIndex = 0;
	            this.goToCountryLink.setAttribute('aria-hidden', false);
	            for (var navl1I = 0; navl1I < this.navPrimaryListLinks.length; navl1I++) {
	                this.navPrimaryListLinks[navl1I].removeAttribute('tabIndex');
	                this.navPrimaryListLinks[navl1I].removeAttribute('aria-hidden');
	            }
	            for (var navBotmi = 0; navBotmi < this.navBottomContainerLinks.length; navBotmi++) {
	                this.navBottomContainerLinks[navBotmi].removeAttribute('tabIndex');
	                this.navBottomContainerLinks[navBotmi].removeAttribute('aria-hidden');
	            }
	        }
	    };
	    XSmallDevice.prototype.closeMenu = function () {
	        util.removeClass(this.bodyEl, PREVENT_STICKYSCROLLING);
	        util.removeClass(document.querySelector('html'), PREVENT_STICKYSCROLLING);
	        util.removeClass(this.bodyEl, PREVENT_SCROLLING);
	        this.backClick();
	        domQ(this.navPrimarySectionEl).removeClass(IS_ACTIVE);
	        domQ(this.navPrimaryFixedTopBar).removeClass(IS_ACTIVE);
	        domQ(this.navBottomContainerOne).removeClass(IS_ACTIVE);
	        domQ(this.hamburgerEl).removeClass(IS_SELECTED);
	        domQ(this.navVeil).removeClass(IS_ACTIVE);
	        if (domQ(this.countrySelectorHead).hasClass('navigation-country-toggle-arrow')) {
	            this.toggleCountrySelectorDiv();
	        }
	        this.navBottomContainerOne.style.transition = null;
	        this.mobileNavLogo.style.transform = 'translate3d(-105%, 0, 0)';
	        setTimeout(function () {
	            document.querySelector('.navigation-primary--wrapper').classList.remove('navigation-is-active');
	        }, 500);
	        document.querySelector('.navigation-hamburger-trigger').focus();
	    };
	    XSmallDevice.prototype.toggleLevel3 = function (e) {
	        if (e.target.classList.contains(IS_SELECTED)) {
	            this.closeLevel3(e.target);
	        } else {
	            this.openLevel3(e.target);
	        }
	    };
	    XSmallDevice.prototype.toggleLevel3Keyup = function (event) {
	        var keyPressed = event.key || event.keyCode;
	        if (keyPressed === 13 || keyPressed === 'Enter') {
	            if (event.target.classList.contains(IS_SELECTED)) {
	                this.closeLevel3(event.target);
	            } else {
	                this.openLevel3(event.target);
	            }
	        }
	    };
	    XSmallDevice.prototype.openLevel3 = function (header) {
	        this.lastLevel3Header = header;
	        domQ(header).addClass(IS_SELECTED);
	        domQ(header.nextElementSibling).addClass('nav-submenu__selectedlink-list');
	        header.nextElementSibling.style.display = 'block';
	        setTimeout(function () {
	            header.nextElementSibling.style.maxHeight = L3_MAXHEIGHT;
	        }, 50);
	        var rootEl = header.parentElement.parentElement.parentElement;
	        if (header.classList.contains(IS_SELECTED)) {
	            if (header.parentElement.children.length === 2) {
	                header.offsetTop === 0 ? rootEl.scrollTop = header.offsetTop : rootEl.scrollTop = header.parentElement.offsetTop;
	            } else {
	                if (header === header.parentElement.children[0]) {
	                    rootEl.scrollTop = header.parentElement.offsetTop;
	                } else {
	                    rootEl.scrollTop = header.offsetTop;
	                }
	            }
	        }
	    };
	
	    XSmallDevice.prototype.closeLevel3 = function (header) {
	        header.nextElementSibling.style.maxHeight = null;
	        domQ(header.nextElementSibling).removeClass('nav-submenu__selectedlink-list');
	        setTimeout(function () {
	            header.nextElementSibling.style.display = 'none';
	            domQ(header).removeClass(IS_SELECTED);
	        }, 500);
	    };
	    XSmallDevice.prototype.closeAllLevel3 = function (iHeader) {
	        var iHeaderlength = iHeader.length;
	        for (var i = 0; i < iHeaderlength; i++) {
	            domQ(iHeader[i]).removeClass(IS_SELECTED);
	            iHeader[i].nextElementSibling.style.maxHeight = null;
	            domQ(iHeader[i].nextElementSibling).removeClass('nav-submenu__selectedlink-list');
	        }
	    };
	    XSmallDevice.prototype.setBackLabel = function (label, url) {
	        this.backLabelEl.innerHTML = '<a  class="icon--hdr-arrow-right" href="' + url + '" aria-label="go to ' + label + '" >' + label + '</a>';
	    };
	    XSmallDevice.prototype.backClick = function () {
	        var iHeader = document.querySelectorAll('#navContainer .nav-submenu__l2-header.is-selected');
	        if (document.querySelector('.nav-primary__menu-link.navigation-is-active')) {
	            document.querySelector('.nav-primary__menu-link.navigation-is-active').focus();
	        }
	        domQ(this.navContainerEl).removeClass(IS_ACTIVE);
	        this.navContainerEl.setAttribute('aria-hidden', 'true');
	        if (this.navPrimarySectionEl.classList.contains('navigation-is-level2-active')) {
	            this.navPrimarySectionEl.style.transition = L1_ANIMATION_TRANSITION;
	            this.navBottomContainerOne.style.transition = L1_ANIMATION_TRANSITION;
	            this.navPrimarySectionEl.classList.remove('navigation-is-level2-active');
	            this.navBottomContainerOne.classList.remove('navigation-is-level2-active');
	            this.level2.deactivateAllMenus();
	            if (iHeader && iHeader.length > 0) {
	                this.closeAllLevel3(iHeader);
	            }
	        }
	        if (!domQ(this.navBottomContainerOne).hasClass(IS_ACTIVE) && this.navPrimarySectionEl.classList.contains(IS_ACTIVE)) {
	            domQ(this.navBottomContainerOne).addClass(IS_ACTIVE);
	        }
	        this.backButtonEl.tabIndex = -1;
	        this.tempHolder.removeAttribute('style');
	        this.backButtonEl.removeAttribute('style');
	
	        this.navPrimarySectionEl.tabIndex = 0;
	        this.menuLastItem.tabIndex = 0;
	        this.navPrimarySectionEl.setAttribute('aria-hidden', false);
	        this.navPrimaryList[0].tabIndex = 0;
	        this.navPrimaryList[0].setAttribute('aria-hidden', false);
	        this.countrySelectorHead.tabIndex = 0;
	        this.countrySelectorHead.setAttribute('aria-hidden', false);
	        this.mobileCountryDropdown.tabIndex = 0;
	        this.mobileCountryDropdown.setAttribute('aria-hidden', false);
	        this.mobileLanguageDropdown.tabIndex = 0;
	        this.mobileLanguageDropdown.setAttribute('aria-hidden', false);
	        this.goToCountryLink.tabIndex = 0;
	        this.goToCountryLink.setAttribute('aria-hidden', false);
	
	        for (var navL1I = 0; navL1I < this.navPrimaryListLinks.length; navL1I++) {
	            this.navPrimaryListLinks[navL1I].removeAttribute('tabIndex');
	            this.navPrimaryListLinks[navL1I].removeAttribute('aria-hidden');
	        }
	        for (var navBotmI = 0; navBotmI < this.navBottomContainerLinks.length; navBotmI++) {
	            this.navBottomContainerLinks[navBotmI].removeAttribute('tabIndex');
	            this.navBottomContainerLinks[navBotmI].removeAttribute('aria-hidden');
	        }
	    };
	    XSmallDevice.prototype.checkHeaderClickToClose = function (e) {
	        var target = e.target;
	        var isChildOfHamburgerTrigger = this.hamburgerEl.contains(target);
	        if (!(target.classList.contains(HAMBURGER_CLASS) || isChildOfHamburgerTrigger)) {
	            this.closeMenu();
	        }
	    };
	    //anchored navigation
	    XSmallDevice.prototype.anchoredNavigation = function () {
	        var l1Menu = this.navPrimarySectionEl.querySelector('.navigation-is-active-anchor');
	        var pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : 'OTH';
	        var l3Menu = null,
	            l3Url = window.location.pathname;
	        var headerElm = document.querySelector('#common-hdr-main');
	        var l3 = this.headerEL.querySelector('.navigation-anchor');
	        if (l3) {
	            l3.classList.remove('navigation-anchor');
	        }
	        if (l1Menu !== null && pageType !== 'SLP') {
	            this.level2Open(l1Menu);
	            if (domQ(headerElm).hasClass('navigation-sticky')) {
	                var headers = document.querySelectorAll('.navigation-open-submenu .nav-submenu__span--four-fifths .nav-submenu__l2-header');
	                util.setTabIndex(headers, '0');
	                stickyHeader.init();
	                stickyHeader.bindAnchor();
	                document.querySelector('.navigation-submenu__back-bar-label a').focus();
	                window.stickyActiveL1 = l1Menu;
	            }
	        }
	        if (window.hpl3Url && window.hpl3Url !== null) {
	            l3Menu = this.headerEL.querySelector('a[href$="' + window.hpl3Url + '"]');
	        } else if ((window.pdpData || window.navAnchorPdpData) && l1Menu !== null) {
	            var length = window.pdpData ? window.pdpData.breadcrumb.length : window.navAnchorPdpData.breadcrumb.length;
	            for (var category = 2; category < length; category++) {
	                l3Url = window.pdpData ? window.pdpData.breadcrumb[category].categoryUrl : window.navAnchorPdpData.breadcrumb[category].pathname;
	                if (l3Menu === null) {
	                    var urlWithQ = this.headerEL.querySelector('a[href^="' + l3Url + '?"]');
	                    var urlWithHash = urlWithQ === null ? this.headerEL.querySelector('a[href$="' + l3Url + '#intid"]') : urlWithQ;
	                    l3Menu = urlWithHash === null ? this.headerEL.querySelector('a[href$="' + l3Url + '"]') : urlWithHash;
	                }
	                if (l3Menu !== null && l3Menu.classList.length !== 0) {
	                    l3Menu = null;
	                }
	            }
	        } else if (l3Url.indexOf('/l/') !== -1) {
	            var urlWithOutAnalytics = this.headerEL.querySelector('a[href$="' + l3Url + '"]');
	            urlWithOutAnalytics = urlWithOutAnalytics === null ? this.headerEL.querySelector('a[href^="' + l3Url + '?"]') : urlWithOutAnalytics;
	            l3Menu = urlWithOutAnalytics === null ? this.headerEL.querySelector('a[href^="' + l3Url + '#intid"]') : urlWithOutAnalytics;
	            if (l3Menu === null && l3Url.indexOf('-n-') !== -1) {
	                l3Url = l3Url.split('-n-')[0];
	                l3Menu = this.headerEL.querySelector('a[href$="' + l3Url + '"]');
	            }
	        }
	        if (l3Menu !== null) {
	            var header = l3Menu.parentElement.parentElement.previousElementSibling;
	            var rootEl = header.parentElement.parentElement.parentElement;
	            header.nextElementSibling.style.transition = 'none';
	            this.openLevel3(header);
	            domQ(l3Menu).addClass('navigation-anchor');
	            setTimeout(function () {
	                rootEl.scrollTop = l3Menu.parentElement.offsetTop;
	                header.nextElementSibling.style.transition = 'max-height .5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s';
	            }, 30);
	        }
	    };
	
	    XSmallDevice.prototype.setPrimarySection = function () {
	        if (this.navPrimarySectionEl && this.navContainerEl) {
	            var paneOneEl = document.querySelector('.navigation-pane-one-navbottom');
	            if (window.innerWidth === 768 || window.innerWidth === 767) {
	                this.navPrimarySectionEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 270 + 'px';
	                this.navPrimaryFixedTopBar.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 290 + 'px';
	                this.navContainerEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 290 + 'px';
	                paneOneEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 270 + 'px';
	            } else {
	                this.navPrimarySectionEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH + 'px';
	                this.navPrimaryFixedTopBar.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 20 + 'px';
	                this.navContainerEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 20 + 'px';
	                paneOneEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH + 'px';
	            }
	        }
	    };
	    XSmallDevice.prototype.loopFocus = function () {
	        this.backButtonEl.focus();
	    };
	
	    XSmallDevice.prototype.loadseasonalBanner = function () {
	        this.bannerimageSrc = this.bannerImageSection ? this.bannerImageSection.getAttribute('data-src') : false;
	        if (this.bannerimageSrc && this.bannerImageSection.getAttribute('src') === '') {
	            this.bannerImageSection.src = this.bannerimageSrc;
	            var _this = this;
	            this.bannerImageSection.addEventListener('load', function () {
	                _this.spinnerImageSection.remove();
	                domQ(_this.bannerImageSection).removeClass('navigation-banner-hide');
	            });
	        }
	    };
	    return XSmallDevice;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(33)
	
	module.exports = forEach
	
	var toString = Object.prototype.toString
	var hasOwnProperty = Object.prototype.hasOwnProperty
	
	function forEach(list, iterator, context) {
	    if (!isFunction(iterator)) {
	        throw new TypeError('iterator must be a function')
	    }
	
	    if (arguments.length < 3) {
	        context = this
	    }
	    
	    if (toString.call(list) === '[object Array]')
	        forEachArray(list, iterator, context)
	    else if (typeof list === 'string')
	        forEachString(list, iterator, context)
	    else
	        forEachObject(list, iterator, context)
	}
	
	function forEachArray(array, iterator, context) {
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (hasOwnProperty.call(array, i)) {
	            iterator.call(context, array[i], i, array)
	        }
	    }
	}
	
	function forEachString(string, iterator, context) {
	    for (var i = 0, len = string.length; i < len; i++) {
	        // no such thing as a sparse string.
	        iterator.call(context, string.charAt(i), i, string)
	    }
	}
	
	function forEachObject(object, iterator, context) {
	    for (var k in object) {
	        if (hasOwnProperty.call(object, k)) {
	            iterator.call(context, object[k], k, object)
	        }
	    }
	}


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = __webpack_require__(39)
	  , forEach = __webpack_require__(32)
	  , isArray = function(arg) {
	      return Object.prototype.toString.call(arg) === '[object Array]';
	    }
	
	module.exports = function (headers) {
	  if (!headers)
	    return {}
	
	  var result = {}
	
	  forEach(
	      trim(headers).split('\n')
	    , function (row) {
	        var index = row.indexOf(':')
	          , key = trim(row.slice(0, index)).toLowerCase()
	          , value = trim(row.slice(index + 1))
	
	        if (typeof(result[key]) === 'undefined') {
	          result[key] = value
	        } else if (isArray(result[key])) {
	          result[key].push(value)
	        } else {
	          result[key] = [ result[key], value ]
	        }
	      }
	  )
	
	  return result
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()) || Function('return this')(), __webpack_require__(36)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(37);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()) || Function('return this')()))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if (global.Promise == null) {
	  global.Promise = __webpack_require__(42);
	}
	
	if (Object.assign == null) {
	  Object.defineProperty(Object, 'assign', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: __webpack_require__(34)
	  });
	}
	
	module.exports = __webpack_require__(41);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()) || Function('return this')()))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	 * Copyright 2015 Scott Brady
	 * MIT License
	 * https://github.com/scottbrady/xhr-promise/blob/master/LICENSE
	 */
	var ParseHeaders, XMLHttpRequestPromise;
	
	ParseHeaders = __webpack_require__(35);
	
	
	/*
	 * Module to wrap an XMLHttpRequest in a promise.
	 */
	
	module.exports = XMLHttpRequestPromise = (function() {
	  function XMLHttpRequestPromise() {}
	
	  XMLHttpRequestPromise.DEFAULT_CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';
	
	
	  /*
	   * XMLHttpRequestPromise.send(options) -> Promise
	   * - options (Object): URL, method, data, etc.
	   *
	   * Create the XHR object and wire up event handlers to use a promise.
	   */
	
	  XMLHttpRequestPromise.prototype.send = function(options) {
	    var defaults;
	    if (options == null) {
	      options = {};
	    }
	    defaults = {
	      method: 'GET',
	      data: null,
	      headers: {},
	      async: true,
	      username: null,
	      password: null,
	      withCredentials: false
	    };
	    options = Object.assign({}, defaults, options);
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var e, header, ref, value, xhr;
	        if (!XMLHttpRequest) {
	          _this._handleError('browser', reject, null, "browser doesn't support XMLHttpRequest");
	          return;
	        }
	        if (typeof options.url !== 'string' || options.url.length === 0) {
	          _this._handleError('url', reject, null, 'URL is a required parameter');
	          return;
	        }
	        _this._xhr = xhr = new XMLHttpRequest;
	        xhr.onload = function() {
	          var responseText;
	          _this._detachWindowUnload();
	          try {
	            responseText = _this._getResponseText();
	          } catch (_error) {
	            _this._handleError('parse', reject, null, 'invalid JSON response');
	            return;
	          }
	          return resolve({
	            url: _this._getResponseUrl(),
	            status: xhr.status,
	            statusText: xhr.statusText,
	            responseText: responseText,
	            headers: _this._getHeaders(),
	            xhr: xhr
	          });
	        };
	        xhr.onerror = function() {
	          return _this._handleError('error', reject);
	        };
	        xhr.ontimeout = function() {
	          return _this._handleError('timeout', reject);
	        };
	        xhr.onabort = function() {
	          return _this._handleError('abort', reject);
	        };
	        _this._attachWindowUnload();
	        xhr.open(options.method, options.url, options.async, options.username, options.password);
	        if (options.withCredentials) {
	          xhr.withCredentials = true;
	        }
	        if ((options.data != null) && !options.headers['Content-Type']) {
	          options.headers['Content-Type'] = _this.constructor.DEFAULT_CONTENT_TYPE;
	        }
	        ref = options.headers;
	        for (header in ref) {
	          value = ref[header];
	          xhr.setRequestHeader(header, value);
	        }
	        try {
	          return xhr.send(options.data);
	        } catch (_error) {
	          e = _error;
	          return _this._handleError('send', reject, null, e.toString());
	        }
	      };
	    })(this));
	  };
	
	
	  /*
	   * XMLHttpRequestPromise.getXHR() -> XMLHttpRequest
	   */
	
	  XMLHttpRequestPromise.prototype.getXHR = function() {
	    return this._xhr;
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._attachWindowUnload()
	   *
	   * Fix for IE 9 and IE 10
	   * Internet Explorer freezes when you close a webpage during an XHR request
	   * https://support.microsoft.com/kb/2856746
	   *
	   */
	
	  XMLHttpRequestPromise.prototype._attachWindowUnload = function() {
	    this._unloadHandler = this._handleWindowUnload.bind(this);
	    if (window.attachEvent) {
	      return window.attachEvent('onunload', this._unloadHandler);
	    }
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._detachWindowUnload()
	   */
	
	  XMLHttpRequestPromise.prototype._detachWindowUnload = function() {
	    if (window.detachEvent) {
	      return window.detachEvent('onunload', this._unloadHandler);
	    }
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._getHeaders() -> Object
	   */
	
	  XMLHttpRequestPromise.prototype._getHeaders = function() {
	    return ParseHeaders(this._xhr.getAllResponseHeaders());
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._getResponseText() -> Mixed
	   *
	   * Parses response text JSON if present.
	   */
	
	  XMLHttpRequestPromise.prototype._getResponseText = function() {
	    var responseText;
	    responseText = typeof this._xhr.responseText === 'string' ? this._xhr.responseText : '';
	    switch ((this._xhr.getResponseHeader('Content-Type') || '').split(';')[0]) {
	      case 'application/json':
	      case 'text/javascript':
	        responseText = JSON.parse(responseText + '');
	    }
	    return responseText;
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._getResponseUrl() -> String
	   *
	   * Actual response URL after following redirects.
	   */
	
	  XMLHttpRequestPromise.prototype._getResponseUrl = function() {
	    if (this._xhr.responseURL != null) {
	      return this._xhr.responseURL;
	    }
	    if (/^X-Request-URL:/m.test(this._xhr.getAllResponseHeaders())) {
	      return this._xhr.getResponseHeader('X-Request-URL');
	    }
	    return '';
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._handleError(reason, reject, status, statusText)
	   * - reason (String)
	   * - reject (Function)
	   * - status (String)
	   * - statusText (String)
	   */
	
	  XMLHttpRequestPromise.prototype._handleError = function(reason, reject, status, statusText) {
	    this._detachWindowUnload();
	    return reject({
	      reason: reason,
	      status: status || this._xhr.status,
	      statusText: statusText || this._xhr.statusText,
	      xhr: this._xhr
	    });
	  };
	
	
	  /*
	   * XMLHttpRequestPromise._handleWindowUnload()
	   */
	
	  XMLHttpRequestPromise.prototype._handleWindowUnload = function() {
	    return this._xhr.abort();
	  };
	
	  return XMLHttpRequestPromise;
	
	})();


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {!function(t){"use strict";function e(t){if(t){var e=this;t(function(t){e.resolve(t)},function(t){e.reject(t)})}}function n(t,e){if("function"==typeof t.y)try{var n=t.y.call(i,e);t.p.resolve(n)}catch(o){t.p.reject(o)}else t.p.resolve(e)}function o(t,e){if("function"==typeof t.n)try{var n=t.n.call(i,e);t.p.resolve(n)}catch(o){t.p.reject(o)}else t.p.reject(e)}var r,i,c="fulfilled",u="rejected",s="undefined",f=function(){function e(){for(;n.length-o;){try{n[o]()}catch(e){t.console&&t.console.error(e)}n[o++]=i,o==r&&(n.splice(0,r),o=0)}}var n=[],o=0,r=1024,c=function(){if(typeof MutationObserver!==s){var t=document.createElement("div"),n=new MutationObserver(e);return n.observe(t,{attributes:!0}),function(){t.setAttribute("a",0)}}return typeof setImmediate!==s?function(){setImmediate(e)}:function(){setTimeout(e,0)}}();return function(t){n.push(t),n.length-o==1&&c()}}();e.prototype={resolve:function(t){if(this.state===r){if(t===this)return this.reject(new TypeError("Attempt to resolve promise with self"));var e=this;if(t&&("function"==typeof t||"object"==typeof t))try{var o=!0,i=t.then;if("function"==typeof i)return void i.call(t,function(t){o&&(o=!1,e.resolve(t))},function(t){o&&(o=!1,e.reject(t))})}catch(u){return void(o&&this.reject(u))}this.state=c,this.v=t,e.c&&f(function(){for(var o=0,r=e.c.length;r>o;o++)n(e.c[o],t)})}},reject:function(n){if(this.state===r){this.state=u,this.v=n;var i=this.c;i?f(function(){for(var t=0,e=i.length;e>t;t++)o(i[t],n)}):!e.suppressUncaughtRejectionError&&t.console&&t.console.log("You upset Zousan. Please catch rejections: ",n,n?n.stack:null)}},then:function(t,i){var u=new e,s={y:t,n:i,p:u};if(this.state===r)this.c?this.c.push(s):this.c=[s];else{var l=this.state,a=this.v;f(function(){l===c?n(s,a):o(s,a)})}return u},"catch":function(t){return this.then(null,t)},"finally":function(t){return this.then(t,t)},timeout:function(t,n){n=n||"Timeout";var o=this;return new e(function(e,r){setTimeout(function(){r(Error(n))},t),o.then(function(t){e(t)},function(t){r(t)})})}},e.resolve=function(t){var n=new e;return n.resolve(t),n},e.reject=function(t){var n=new e;return n.reject(t),n},e.all=function(t){function n(n,c){n&&"function"==typeof n.then||(n=e.resolve(n)),n.then(function(e){o[c]=e,r++,r==t.length&&i.resolve(o)},function(t){i.reject(t)})}for(var o=[],r=0,i=new e,c=0;c<t.length;c++)n(t[c],c);return t.length||i.resolve(o),i},typeof module!=s&&module.exports&&(module.exports=e),t.define&&t.define.amd&&t.define([],function(){return e}),t.Zousan=e,e.soon=f}("undefined"!=typeof global?global:this);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()) || Function('return this')(), __webpack_require__(38).setImmediate))

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ])
});
;
//# sourceMappingURL=bundle.js.map